{
  "admin": {
    "title": "Hallintapaneeli",
    "announcementManagement": "Tiedotteiden hallinta",
    "auctionEndTime": "Kilpailutuksen loppumisaika",
    "auctionManagement": "Kilpailutusten hallinta",
    "auctionsNotFound": "(Kilpailutuksia ei löytynyt)",
    "companyNotFound": "(Yritystä ei löytynyt)",
    "dealerUsers": "Yrityskäyttäjät",
    "editAuctionStatus": "Muokkaa kilpailutuksen tilaa",
    "editAuctionItem": "Muokkaa kilpailutuksen tietoja",
    "editAuctionEndTime": "Muokkaa loppumisaikaa",
    "manageBids": "Hallinnoi tarjouksia",
    "auctionDetails": "Näytä tiedot",
    "rowActions": "Toiminnot",
    "noMoreResults": "Ei lisää tuloksia",
    "resultsCount": "{{count}} tulosta",
    "filteredResultsCount": "{{count}} / {{total}} tulosta",
    "dataTable": {
      "emptyMessage": "Ei tuloksia",
      "loadingMessage": "Ladataan…",
      "toolbar": {
        "ariaLabel": "Taulukon työkalurivi",
        "searchPlaceholder": "Etsi…",
        "quickSearchAriaLabel": "Pikahaku",
        "clearFilters": "Tyhjennä suodattimet",
        "clearAllFiltersAriaLabel": "Tyhjennä kaikki suodattimet",
        "columns": "Sarakkeet",
        "allColumns": "Kaikki",
        "scrollBackLeft": "Takaisin vasemmalle",
        "scrollRight": "Vieritä oikealle",
        "scrollTableLeftAriaLabel": "Vieritä taulukkoa vasemmalle",
        "scrollTableRightAriaLabel": "Vieritä taulukkoa oikealle",
        "rowHeightAriaLabel": "Rivikorkeus",
        "densityCompact": "Tiivis",
        "densityStandard": "Normaali",
        "densityComfortable": "Väljä",
        "exportCsvTooltip": "Lataa CSV-tiedostona",
        "exportCsvAriaLabel": "Vie CSV-tiedostoon"
      },
      "filters": {
        "all": "Kaikki",
        "clear": "Tyhjennä",
        "apply": "Käytä",
        "dateFrom": "Alkaen",
        "dateTo": "Päättyen",
        "numberMin": "Min €",
        "numberMax": "Max €",
        "allDates": "Kaikki ajat",
        "allPrices": "Kaikki hinnat",
        "datePresets": {
          "today": "Tänään",
          "yesterday": "Eilen",
          "last7": "Viimeiset 7 pv",
          "last30": "Viimeiset 30 pv",
          "thisMonth": "Tämä kuukausi",
          "lastMonth": "Viime kuukausi"
        },
        "numberPresets": {
          "under5k": "< 5 000",
          "5to15k": "5 000 – 15 000",
          "15to30k": "15 000 – 30 000",
          "over30k": "> 30 000"
        }
      },
      "header": {
        "resizeColumnAriaLabel": "Muuta sarakkeen leveyttä"
      }
    },
    "fetchNewestAuctions": "Hae uusimmat kilpailutukset",
    "fetchDraftAuctions": "Hae luonnokset",
    "downloadBillingReport": "Lataa laskutusraportti",
    "noBillingReportYet": "Laskutusraporttia ei ole vielä saatavilla.",
    "fetchUsers": "Hae käyttäjät",
    "login": "Kirjaudu Admin-tunnuksella",
    "searchWithCompanyId": "Hae yrityksen y-tunnuksella",
    "searchWithCompanyName": "Hae yrityksen nimellä",
    "searchWithEmail": "Hae sähköpostilla",
    "userNotFound": "(Käyttäjää ei löytynyt)",
    "announcements": {
      "announcements": "Tiedotteet",
      "edit": "Muokkaa tiedotetta",
      "add": "Lisää tiedote",
      "startDate": "Tiedotteen aloitusaika",
      "endDate": "Tiedotteen loppuaika",
      "content": "Sisältö",
      "severity": "Vakavuus",
      "audience": "Yleisö",
      "audienceHelper": "Rajoita tiedotteen näkyvyyttä",
      "deleteConfirmationTitle": "Haluatko varmasti poistaa tiedotteen?"
    },
    "gdpr": {
      "title": "Gdpr",
      "checkEmail": "Tarkista sähköposti",
      "enterEmail": "Syötä sähköposti",
      "errorMessage": "Sähköpostia ei löytynyt",
      "userData": "Käyttäjän {{email}} tiedot",
      "modal": {
        "title": "Olet anonymisoimassa käyttäjän tietoja",
        "description": "Anonymisointi korvaa käyttäjän henkilötiedot satunnaisilla merkkijonoilla. Anonymisointi on peruuttamaton toimenpide.",
        "description2": {
          "firstMessage": "Anonymisointi ei onnistu, jos huutokauppa on tilassa ",
          "boldedText": "KÄYNNISSÄ, PÄÄTTYNYT, TARJOUS HYVÄKSYTTY tai ODOTTAA LOPULLISTA TARJOUSTA."
        },
        "confirm": "Anonymisoi"
      },
      "tableDatas": {
        "service": {
          "title": "Palvelu",
          "serviceName": "Baana"
        },
        "id": "Id",
        "firstName": "Etunimi",
        "lastName": "Sukunimi",
        "email": "Sähköposti",
        "phoneNumber": "Puhelinnumero",
        "role": "Rooli",
        "address": "Osoite",
        "city": "Kaupunki",
        "country": "Maa",
        "createdAt": "Luotu",
        "auctions": "Ilmoitukset",
        "status": "Tila",
        "startTime": "Aloitusaika",
        "endTime": "Lopetusaika",
        "offerEndTime": "Tarjousten päättymisaika",
        "vehicles": "Ajoneuvot",
        "pdfConfirmationMessage": "Nämä tiedot on tarkistettu {{currentDate}}"
      },
      "user": {
        "consumer": "Yksityinen"
      },
      "notification": {
        "userAnonymized": "Käyttäjän tiedot anonymisoitu",
        "userAnonymizationError": "Virhe käyttäjän anonymisoitumisessa"
      }
    },
    "draftManagement": {
      "deleteInfo": "Poista luonnos",
      "delete": "Luonnos poistettu onnistuneesti",
      "deleteConfirm": "Haluatko varmasti poistaa luonnoksen ajoneuvosta {{regNo}}"
    },
    "auctionUpdate": {
      "error": "Virhe kilpailutuksen päivittämisessä",
      "duplicateRegNo": "Rekisterinumero on jo käytössä toisessa kilpailutuksessa",
      "stateUpdated": "Kilpailutuksen tila päivitetty: {{state}}",
      "endTimeUpdated": "Kilpailutuksen päättymisaika päivitetty",
      "bidDeclined": "Hyväksytty tarjous peruttu",
      "itemUpdated": "Kilpailutuksen tiedot päivitetty"
    },
    "adminNotes": {
      "modalTitle": "Muistiinpanot",
      "addPlaceholder": "Kirjoita muistiinpano…",
      "add": "Lisää",
      "save": "Tallenna",
      "cancel": "Peruuta",
      "edit": "Muokkaa",
      "delete": "Poista",
      "deleteConfirmTitle": "Poistetaanko muistiinpano?",
      "empty": "Ei muistiinpanoja",
      "loadError": "Muistiinpanojen lataus epäonnistui",
      "saveError": "Tallennus epäonnistui",
      "deleteError": "Poistaminen epäonnistui",
      "openIcon": "Avaa muistiinpanot",
      "menuAdd": "Lisää muistiinpano",
      "createdAt": "Lisätty: {{date}}",
      "updatedAt": "Muokattu: {{date}}",
      "validation": {
        "empty": "Muistiinpano ei voi olla tyhjä",
        "tooLong": "Muistiinpano voi olla enintään {{max}} merkkiä"
      }
    },
    "auctionFlags": {
      "title": "Raportoidut kilpailutukset",
      "openTab": "Avoimet",
      "resolvedTab": "Käsitellyt",
      "empty": "Ei raportointeja",
      "emptyResolved": "Ei käsiteltyjä raportointeja viimeisen 30 päivän ajalta",
      "resolve": "Merkitse käsitellyksi",
      "delete": "Poista",
      "cancel": "Peruuta",
      "deleteConfirmTitle": "Poistetaanko raportointi?",
      "resolved": "Raportointi merkitty käsitellyksi",
      "deleted": "Raportointi poistettu",
      "error": "Toiminto epäonnistui",
      "notFound": "Raportoitua kilpailutusta ei löytynyt"
    },
    "auctionDetailsModal": {
      "seller": {
        "title": "Myyjä",
        "name": "Nimi",
        "email": "Sähköposti",
        "phoneNumber": "Puhelinnumero",
        "targetPrice": "Tavoitehinta",
        "noTargetPrice": "Ei tavoitehintaa"
      },
      "dealer": {
        "title": "Tarjoukset",
        "name": "Nimi",
        "email": "Sähköposti",
        "businessName": "Yritys",
        "bid": "Tarjous",
        "status": "Status",
        "noBid": "Ei tarjouksia",
        "editBids": "Muokkaa tarjouksia",
        "bidState": {
          "accepted": "Hyväksytty",
          "declined": "Ei-hyväksytty",
          "inProgress": "Kesken"
        }
      },
      "vehicle": {
        "title": "Ajoneuvo",
        "make": "Merkki",
        "model": "Malli",
        "regNo": "Rekisterinumero",
        "regNoEmptyError": "Rekisterinumero ei voi olla tyhjä",
        "vehicleType": "Ajoneuvotyyppi",
        "bikeType": "Mototyyppi",
        "caravanType": "Matkailutyyppi"
      },
      "negotiationUser": {
        "seller": "Myyjä",
        "dealer": "Liike"
      }
    },
    "userRemoveModal": {
      "title": "Oletko varma, että haluat poistaa käyttäjän {{firstName}} {{lastName}} palvelustamme?",
      "description": "Olet poistamassa käyttäjän {{firstName}} {{lastName}}"
    },
    "patchesAndInfo": {
      "editMessage": "Lähetä yleisiä ohjeita ja päivityksiä",
      "patches": "Ohjeet & Päivitykset"
    },
    "verticalChecks": {
      "title": "Vertikaalitarkistukset",
      "description": "Tarkista mahdolliset menetetyt palkkiot",
      "loading": "Ladataan vertikaalitarkistuksia...",
      "error": "Virhe ladattaessa tarkistuksia",
      "noResults": "Ei tarkistustuloksia",
      "summary": {
        "new": "{{count}} uutta",
        "reviewed": "{{count}} tarkastettua",
        "total": "Yhteensä {{count}} tulosta"
      },
      "sections": {
        "new": "Uudet havainnot ({{count}})",
        "reviewed": "Tarkastellut kohteet ({{count}})"
      },
      "item": {
        "auctionId": "Kilpailutus ID",
        "regNo": "Rekisterinumero",
        "yTunnus": "Y-tunnus",
        "vertical": "Alusta",
        "businessName": "Yrityksen nimi",
        "listingDate": "Listausaika",
        "listingStatus": "Listaustila",
        "reviewedAt": "Tarkastettu",
        "adLink": "Ilmoituslinkki",
        "actions": {
          "markReviewed": "Merkitse tarkastetuksi",
          "viewAd": "Näytä ilmoitus",
          "viewAuction": "Näytä kilpailutus"
        }
      },
      "status": {
        "NEW": "Uusi",
        "REVIEWED": "Tarkastettu",
        "FORSALE": "Myynnissä",
        "SOLD": "Myyty",
        "RESERVED": "Varattu"
      },
      "verticals": {
        "nettiauto": "Nettiauto",
        "nettimoto": "Nettimoto"
      },
      "messages": {
        "markingAsReviewed": "Merkitään tarkastetuksi...",
        "loadingAuction": "Ladataan kilpailutustietoja...",
        "markedAsReviewed": "Merkitty tarkastetuksi",
        "failedToMark": "Merkitseminen epäonnistui",
        "failedToLoadResults": "Tuloksia ei voitu ladata",
        "auctionFetchError": "Virhe kilpailutuksen haussa",
        "tryAgain": "Yritä uudelleen",
        "refresh": "Päivitä"
      },
      "labels": {
        "needsReview": "⚠️ VAATII TARKASTUSTA",
        "reviewed": "✓ Tarkastettu",
        "unknown": "Tuntematon",
        "viewListing": "Näytä ilmoitus →",
        "needReview": "Vaativat tarkastusta",
        "alreadyReviewed": "Jo tarkastettu",
        "noItemsNeedReview": "🎉 Ei tarkistettavia kohteita!",
        "allItemsReviewed": "Kaikki vertikaalitarkistukset on käsitelty.",
        "noReviewedItems": "Ei vielä tarkistettuja kohteita."
      }
    }
  },
  "auctionStates": {
    "seller": {
      "BILLED": "Laskutettu",
      "CANCELLED": "Peruttu",
      "DELETED": "Poistettu",
      "DRAFT": "Kesken",
      "ENDED": "Päättynyt",
      "NOT_SOLD": "Ei myyty",
      "OFFER_ACCEPTED": "Tarjous hyväksytty",
      "SOLD": "Myyty",
      "SENT_FOR_BILLING": "Myyty",
      "STARTED": "Käynnissä",
      "REJECTED_BY_DEALER": "Ostaja hylkäsi"
    },
    "buyer": {
      "BILLED": "Laskutettu",
      "CANCELLED": "Keskeytetty",
      "DELETED": "Poistettu",
      "DRAFT": "Keskeneräinen",
      "ENDED": "Odotetaan myyjää",
      "NOT_SOLD": "Sulkeutunut",
      "OFFER_ACCEPTED": "Hyväksytty",
      "SOLD": "Kauppa toteutunut",
      "SENT_FOR_BILLING": "Kauppa toteutunut",
      "STARTED": "Kilpailutuksessa",
      "UNDER_NEGOTIATION": "Neuvottelu käynnissä",
      "REJECTED_BY_SELLER": "Tarjous hylätty",
      "REJECTED_BY_DEALER": "Tarjous peruttu"
    },
    "admin": {
      "DRAFT": "Luonnos",
      "SENT_FOR_BILLING": "Lähetetty laskutukseen"
    }
  },
  "components": {
    "reliabilityIndicator": {
      "title": "Luotettavuus",
      "level": {
        "2": "Hyvä",
        "3": "Erinomainen"
      },
      "info": "Hinta-arvio perustuu vastaavien autojen toteutuneisiin kauppahintoihin ja antaa hyvän käsityksen autosi arvosta."
    },
    "targetPriceAlert": {
      "within": {
        "title": "Hinta on kohdillaan",
        "body": "Hyvä lähtökohta – autoliikkeet pitävät hintaa realistisena."
      },
      "below": {
        "title": "Tavoitehintasi on alle arvion",
        "body": "Kilpailutus voi nostaa lopullisen hinnan tavoitettasi korkeammalle."
      },
      "above": {
        "title": "Tavoitehintasi on yli arvion",
        "body": "Korkea tavoitehinta voi vähentää autoliikkeiden kiinnostusta. Harkitse tavoitteen laskemista arvion sisälle parhaiden tarjousten saamiseksi."
      }
    },
    "auctionItem": {
      "noNotes": "Ei muistiinpanoja",
      "note": "muistiinpano",
      "note_other": "muistiinpanoa",
      "addNew": "Lisää uusi",
      "vehicleImageTargetPrice": "Tavoitehinta",
      "placeBid": "Tarjoa",
      "copyRegno": "Rekisterinumero {{regno}} kopioitu leikepöydälle",
      "copyRegnoError": "Rekisterinumeron kopiointi epäonnistui",
      "copyRegnoTooltip": "Kopioi",
      "quickAuction": "Pika",
      "hideAuction": "Piilota kilpailutus",
      "showAuction": "Näytä kilpailutus",
      "auctionHidden": "Kilpailutus piilotettu",
      "auctionUnhidden": "Kilpailutus näytetään taas",
      "oldAuction": "Vanha kilpailutus",
      "vehicleDataNotAvailable": "Ajoneuvon tiedot eivät ole enää saatavilla.",
      "consumerVehicleDataNotAvailable": "Vanha kilpailutuksesi on poistettu järjestelmästämme. Luo uusi kilpailutus",
      "createNewAuctionLink": "tästä",
      "endedInPlace": "Kilpailutus päättynyt"
    },
    "auctionTimer": {
      "daysUnit": "pv"
    },
    "biddingModal": {
      "bidSum": "Tarjous",
      "cancelButton": "Peruuta",
      "containsPickup": "Tarjous sisältää noudon",
      "editBidTitle": "Tarjouksen muokkaaminen",
      "highestBid": "Korkein tarjous",
      "minimumBid": "Minimitarjous",
      "minimumUpperLimit": "Minimiyläraja",
      "myBid": "Oma tarjous",
      "pickupRequired": "Huomioithan, että tarjoamasi hinta edellyttää ajoneuvon noutamisen myyjältä.",
      "placeBidButton": "Tee tarjous",
      "placeBidTitle": "Tarjouksen tekeminen",
      "upperLimit": "Yläraja",
      "useBidMachine": "Käytä korotusautomaattia",
      "bidTooHighWarning": "Huomio! Olet tekemässä merkittävästi korkeampaa tarjousta, kuin lähtöhinta tai korkein tarjous on.",
      "guaranteedAmountActivated": "Takuuhinta aktivoitu -",
      "guaranteedAmountNotActivated": "Takuuhinta ei aktivoitu käyttäjäasetuksissa",
      "toolTipHelp": "Aktivoitu takuutaso",
      "alertHighestBidChanged": "Kohteesta on tehty uusi korkeampi tarjous. Uusi minimitarjous on {{amount}}€. Tarkistathan vielä oman tarjouksesi ennen tarjouksen jättämistä."
    },
    "bidMachineDeactivationModal": {
      "title": "Korotusautomaatin sulkeminen",
      "verification": "Haluatko varmasti sulkea korotusautomaatin?"
    },
    "bidMachineInfo": {
      "bidMachine": "Korotusautomaatti",
      "bidMachineMaxValue": "Yläraja",
      "guaranteedAmount": "Takuuhinta"
    },
    "bidRow": {
      "highestBid": "Hinta nyt",
      "myBid": "Oma tarjous",
      "vatDeductible": {
        "title": "(ALV väh.kelp)",
        "description": "Arvonlisäveron saa vähentää ajoneuvon käyttö- tai hankintakustannuksista vain, jos ajoneuvo on hankittu yksinomaan vähennykseen oikeuttavan liiketoiminnan käyttöön. Vähäinenkin yksityiskäyttö poistaa koko vähennysoikeuden."
      }
    },
    "footer": {
      "aboutUsHeader": "Tietoa meistä",
      "baanaHeader": "Baana",
      "contact": "Yhteystiedot",
      "aboutUs": "Meistä",
      "termsOfUse": "Käyttöehdot",
      "placeABid": "Jätä ilmoitus",
      "continueAuction": "Jatka ilmoituksen täyttöä",
      "showAuction": "Omat kilpailutukset",
      "forConsumers": "Kuluttajille",
      "forDealers": "Ostajille",
      "faq": "Usein kysyttyä",
      "userGuide": "Käyttöohjeet",
      "weBuyCars": "Ostetaan autoja",
      "weBuyCarsByMaker": "Ostetaan automerkkejä",
      "weBuyCarsByCity": {
        "helsinki": "Ostetaan autoja Helsinki",
        "espoo": "Ostetaan autoja Espoo",
        "vantaa": "Ostetaan autoja Vantaa",
        "turku": "Ostetaan autoja Turku",
        "tampere": "Ostetaan autoja Tampere",
        "oulu": "Ostetaan autoja Oulu"
      },
      "weBuyCarsByMakerLinks": {
        "audi": "Ostetaan autoja Audi",
        "bmw": "Ostetaan autoja BMW",
        "ford": "Ostetaan autoja Ford",
        "mercedesBenz": "Ostetaan autoja Mercedes-Benz",
        "nissan": "Ostetaan autoja Nissan",
        "opel": "Ostetaan autoja Opel",
        "skoda": "Ostetaan autoja Skoda",
        "toyota": "Ostetaan autoja Toyota",
        "volkswagen": "Ostetaan autoja Volkswagen",
        "volvo": "Ostetaan autoja Volvo",
        "tesla": "Ostetaan autoja Tesla"
      }
    },
    "markAsCompleteModal": {
      "title": "Kaupan merkitseminen toteutuneeksi",
      "paragraph1": "Olet merkitsemässä kauppaa toteutuneeksi. Tarkista vielä sovitut tiedot ja kauppapaperit ennen merkintää.",
      "paragraph2": "Toteutuneeksi merkittyä kilpailutusta ei voi enää jälkikäteen perua tai käsitellä muutoin.",
      "markAsComplete": "Merkitse toteutuneeksi",
      "priceChangeReason": "Kauppahinnan muutoksen syy",
      "salePrice": "Kauppahinta"
    },
    "markOfferAcceptedModal": {
      "acceptConfirmation": "Haluatko varmasti merkitä kohteen alustavaksi kaupaksi?"
    },
    "notifications": {
      "BID_DECLINED": {
        "title": "Tarjouksesi on hylätty",
        "content": "Myyjä hylkäsi tarjouksesi ajoneuvosta {{regNo}}."
      },
      "ADMIN_BID_DECLINED": {
        "title": "Kilpailutuksen tilaa päivitetty",
        "content": "Ylläpito on päivittänyt kilpailutuksen tilaa. Tarjouksesi ei ole enää merkitty hyväksytyksi ajoneuvosta {{regNo}}."
      },
      "ADMIN_BID_REMOVED": {
        "title": "Tarjouksesi on poistettu",
        "content": "Ylläpito on poistanut tarjouksesi ajoneuvosta {{regNo}}."
      },
      "ADMIN_BID_MODIFIED": {
        "title": "Tarjoustasi on muokattu",
        "content": "Ylläpito on muokannut tarjoustasi ajoneuvosta {{regNo}}."
      },
      "BID_UPDATED": {
        "title": "Tarjousta muutettu",
        "content": "Liike on muuttanut tarjoustaan ajoneuvosta {{regNo}}."
      },
      "BID_UPDATED_AND_STATE_CHANGE": {
        "title": "Onnea kaupoista!",
        "content": "Liike on muuttanut ostotarjouksensa {{oldBid}} eurosta {{newBid}} euroon ja merkinnyt ajoneuvon {{regNo}} myydyksi."
      },
      "BID_ACCEPTED": {
        "title": "Alustava kauppa",
        "content": "Liike on merkinnyt ajoneuvon {{regNo}} alustavaksi kaupaksi."
      },
      "AUCTION_MARKED_SOLD": {
        "title": "Onnea kaupoista!",
        "content": "Liike on merkinnyt ajoneuvonne {{regNo}} myydyksi."
      },
      "OFFER_WITHDRAWN": {
        "title": "Tarjous peruttu",
        "content": "Liike on perunut tarjouksensa ajoneuvosta {{regNo}}."
      },
      "NEW_QUESTION": {
        "title": "Uusi kysymys",
        "content": "Ajoneuvosta {{regNo}} on saapunut uusi kysymys."
      },
      "NEW_ANSWER": {
        "title": "Uusi vastaus",
        "content": "Myyjä on vastannut kysymykseesi ajoneuvosta {{regNo}}."
      },
      "NEW_NEGOTIATION_MESSAGE": {
        "title": "Uusi neuvotteluviesti",
        "content": "Uusi neuvotteluviesti ajoneuvosta {{regNo}}."
      },
      "NEW_BIDS_OUTBIDDED": {
        "title": "Tarjouksesi on ylitetty",
        "content": "Tarjouksesi ajoneuvosta {{regNo}} on ylitetty."
      },
      "AUCTION_ENDED": {
        "title": "Kilpailutuksesi on päättynyt",
        "content": "Ajoneuvon {{regNo}} kilpailutus on päättynyt."
      },
      "FIRST_BID": {
        "title": "Ensimmäinen tarjous",
        "content": "Ajoneuvosta {{regNo}} on tehty ensimmäinen tarjous."
      },
      "TARGET_PRICE_REACHED": {
        "title": "Tavoitehinta ylitetty",
        "content": "Ajoneuvosta {{regNo}} on tehty tavoitehinnan ylittävä tarjous."
      },
      "AUCTION_ADDITIONAL_INFO_ADDED": {
        "title": "Tietoja lisätty",
        "content": "Huutamasi ajoneuvoon {{regNo}} on tullut lisätietoja, katso lisätiedot tästä."
      },
      "FINAL_OFFER_AVAILABLE": {
        "title": "Viimeinen tarjousmahdollisuus",
        "content": "Myyjä on hylännyt kaikki tarjoukset ajoneuvosta {{regNo}}. Sinulla on mahdollisuus tehdä vielä yksi korotettu tarjous."
      },
      "FINAL_OFFER_RECEIVED": {
        "title": "Viimeinen tarjous vastaanotettu",
        "content": "Liike on jättänyt viimeisen tarjouksensa ajoneuvosta {{regNo}}. Voit nyt hyväksyä tai hylätä tarjouksen."
      },
      "REMINDER_TO_MARK_SOLD": {
        "title": "Muistutus: merkitse kauppa toteutuneeksi",
        "content": "Ajoneuvon {{makeModel}} ({{regNo}}) tarjous on hyväksytty, mutta kauppaa ei ole vielä merkitty toteutuneeksi. Käythän merkitsemässä kaupan toteutuneeksi, mikäli ajoneuvon luovutus on jo tehty."
      },
      "age": {
        "days_one": "eilen",
        "days_other": "{{count}} päivää sitten"
      },
      "updateFailed": "Ilmoituksen päivittäminen epäonnistui. Yritä uudelleen tai ota yhteyttä tukeen",
      "generalFail": "Jotain meni pieleen. Yritä uudelleen tai ota yhteyttä tukeen",
      "notifications": "Ilmoitukset",
      "noNotifications": "Ei ilmoituksia",
      "markUnread": "Merkitse lukemattomaksi",
      "markRead": "Merkitse luetuksi",
      "markAllRead": "Merkitse kaikki luetuiksi"
    },
    "negotiationModal": {
      "me": "Minä",
      "seller": "Myyjä",
      "dealership": "Liike",
      "sendMessage": "Lähetä viesti",
      "title": "Neuvottelu myyjän kanssa",
      "targetPrice": "Myyjän tavoitehinta:"
    },
    "auctionEditModal": {
      "markAsComplete": "Merkitse kauppa toteutuneeksi",
      "paragraph1": "Olet merkitsemässä kauppaa toteutuneeksi. Tarkista vielä sovitut tiedot ja kauppapaperit ennen merkintää.",
      "paragraph2": "Toteutuneeksi merkittyä kilpailutusta ei voi enää jälkikäteen perua tai käsitellä muutoin.",
      "stateAndPriceEdit": "Huutokaupan tilan ja hinnan muokkaus",
      "soldPrice": "Merkitse toteutuneeksi hinnalla:",
      "ableToEditMessage": "Pääset vielä muokkaamaan ostohintaa",
      "successMessage": "Tilan ja hinnan muokkaaminen onnistui",
      "errorMessage": "Tilan ja hinnan muokkaamisessa tapahtui virhe"
    },
    "notificationContainer": {
      "showAuction": "Näytä kohde",
      "clickHere": "Klikkaa tästä"
    },
    "ourBidInfo": {
      "bidFromOurCompany": "Korkein tarjous yrityksestänne: {{highestBid}}€",
      "bidMachineFromOurCompany": "(suojattu automaatilla {{maxAmount}}€ asti)"
    },
    "quickRaise": {
      "confirmTitle": "Vahvistus",
      "confirmContent": "HUOM! Pikakorotukset eivät oletusarvoisesti sisällä noutoa. Voit halutessasi valita käyttäjäasetuksista \"Pikatarjous sisältää noudon\".  Tämä ilmoitus näkyy vain yhden kerran ja jatkossa korotus tapahtuu heti.",
      "buttonText": "Korota +{{minimumBidRaise}} €"
    },
    "rejectOfferDialog": {
      "title": "Tarjouksen hylkääminen",
      "titleRejectQuestion": "Hylätäänkö tarjous?",
      "amountLabel": "Summa: {{amount}} €",
      "hintBeforeReject": "Ennen hylkäämistä voit ehdottaa omaa hintaasi.",
      "negotiateOnPrice": "Ehdota hintaa",
      "content": "Haluatko varmasti hylätä tarjouksen?",
      "content2": "Haluatko varmasti hylätä tarjouksen kokeilematta neuvottelua? Voit ehdottaa neuvottelussa hintaa, jolla olisit valmis myymään.",
      "negotiateButton": "Näytä neuvottelu",
      "negotiateButton2": "Aloita neuvottelu"
    },
    "rejectAllOffersDialog": {
      "title": "Hylkää kaikki tarjoukset",
      "content": "Oletko varma, että haluat hylätä kaikki saamasi tarjoukset kokeilematta neuvottelua? Voit ehdottaa neuvottelussa hintaa, jolla olisit valmis myymään ajoneuvosi.",
      "contentAfterNegotiation": "Oletko varma, että haluat hylätä kaikki saamasi tarjoukset?"
    },
    "searchPanel": {
      "inputPlaceholder": "Hae hakusanoilla",
      "searchButtonLabel": "Hae"
    },
    "withdrawOfferModal": {
      "title": "Kaupan peruuttaminen",
      "paragraph1": "Haluatko varmasti peruuttaa kaupan?",
      "paragraph2": "Baanassa tehdyt tarjoukset ovat sitovia, edellyttäen että ajoneuvo vastaa ilmoituksessa annettuja tietoja. Mikäli kauppoihin ei päästä, voit peruuttaa kaupan. Huomaathan kuitenkin, että peruuttamisen jälkeen kaupankäyntiä ei voi enää jatkaa.",
      "reasonVisibilityInfo": "Kerrothan lisäksi syyn kaupan peruuttamiselle. Peruuttamisen syy näkyy vain sinulle ja ylläpidolle.",
      "reasonLabel": "Kirjoita syy",
      "withdrawOffer": "Peruuta kauppa"
    },
    "articlePage": {
      "title": "Näin myyt ajoneuvosi Baanan avulla:",
      "watchVideo": "Katso video",
      "opensInNewTabAriaLabel": "{{linkText}} (avautuu uuteen välilehteen)",
      "step1": "Tee myynti-ilmoitus. Palvelu ohjaa ilmoituksen tekemisen ja esimerkiksi kuvien ottamisen selkeästi vaihe vaiheelta",
      "step2": "Kun olet julkaissut ilmoituksen, ostajalikkeellä on mahdollisuus tehdä ostotarjouksia aina päättymisaikaan asti. Kilpailutus ei sido sinua myyntiin.",
      "step3": "Valitse tarjousajan päätyttyä paras tarjous. Kun olet hyväksynyt tarjouksen, yhteystietosi luovutetaan kyseisen tarjouksen tehneelle liikkeelle.",
      "step4": "Liike ottaa sinuun yhteyttä, ja voitte sopia ajoneuvon luovutuksesta. Myynti on hoidettu!",
      "moreArticles": "Lisää artikkeleita Baanassa"
    },
    "weBuyCarsPage": {
      "titleWithCity": "Ostetaan autoja {{cityName.basic}} - ostajina useat autoliikkeet {{cityName.inessive}} - Baana",
      "title": "Ostetaan autoja - ostajina sadat autoliikkeet ympäri Suomen - Baana",
      "metaData": "Baanassa ostetaan autoja päivittäin! Myy autosi autoliikkeelle nopeasti parhaalla hinnalla. Kilpailuta kerralla autoliikkeet ja tee kaupat jopa samana päivänä.",
      "metaDataWithCity": "Ostetaan autoja {{cityName.basic}} - Baanassa ostetaan autoja {{cityName.inessive}} ja ympäri Suomen päivittäin! Myy autosi autoliikkeelle nopeasti jopa samana päivänä, parhaalla hinnalla. ",
      "metaTitle": "Baana - Ostetaan autoja",
      "metaTitleWithCity": "Baana - Ostetaan autoja {{cityName.basic}}",
      "subtitle": "Myy autosi parhaalla hinnalla, jopa samana päivänä",
      "body1WithCity": "Baana on auton myynnin kilpailutuspalvelu, jossa voit yhdellä ilmoituksella kilpailuttaa tarjoukset autoliikkeiltä {{cityName.inessive}}. Baanassa ostetaan autoja niin isojen ketjujen kuin pienten liikkeiden toimesta. Myy autosi nopeimmillaan jopa samana päivänä.",
      "body1": "Baana on auton myynnin kilpailutuspalvelu, jossa voit yhdellä ilmoituksella kilpailuttaa tarjoukset autoliikkeiltä ympäri Suomen. Baanassa ostetaan autoja niin isojen ketjujen kuin pienten liikkeiden toimesta. Myy autosi nopeimmillaan jopa samana päivänä.",
      "title2": "Baanassa ostetaan kaikkia autoja",
      "body2": "Baanan kautta ostetaan sekä yleisimpiä Suomen teillä olevia autoja että harvinaisempia malleja – kilpailutus kannattaa autosta riippumatta!",
      "body3WithCity": "Baanan kautta ostetaan {{cityName.inessive}} henkilöautoja ja pakettiautoja, bensa-autoja, dieselautoja, hybridiautoja, sähköautoja, farmariautoja, tila-autoja ja monia muita.",
      "body3": "Baanan kautta ostetaan henkilöautoja ja pakettiautoja, bensa-autoja, dieselautoja, hybridiautoja, sähköautoja, farmariautoja, tila-autoja ja monia muita.",
      "title3": "Vaivaton myynti, luotettavat ostajat",
      "body4": "Kilpailutuksen ansiosta saat autostasi aina parhaan hinnan, jonka autoliikkeet siitä kyseisellä hetkellä maksavat. Myynti on helppoa ja luotettavaa, sillä liikkeen ammattilaiset hoitavat paperityöt puolestasi.",
      "subtitleWithCity": "{{cityName.basic}} - näihin ja moniin muihin liikkeisiin ostetaan autoja {{cityName.inessive}}",
      "subtitle2": "Ostajina Baanassa nämä ja sadat muut liikkeet:"
    },
    "weBuyCarsByMakerPage": {
      "titleWithMaker": "Ostetaan {{carMaker}} - ostajina useat autoliikkeet ympäri Suomen - Baana",
      "title": "Ostetaan autoja - ostajina sadat autoliikkeet ympäri Suomen - Baana",
      "metaData": "Baanassa ostetaan autoja päivittäin! Myy autosi autoliikkeelle nopeasti parhaalla hinnalla. Kilpailuta kerralla autoliikkeet ja tee kaupat jopa samana päivänä.",
      "metaDataWithMaker": "Ostetaan {{carMaker}} - Baanassa ostetaan {{carMaker}} autoja päivittäin! Myy {{carMaker}} autosi autoliikkeelle nopeasti jopa samana päivänä, parhaalla hinnalla.",
      "metaTitle": "Baana - Ostetaan autoja",
      "metaTitleWithMaker": "Baana - Ostetaan {{carMaker}} autoja",
      "subtitle": "Myy autosi parhaalla hinnalla, jopa samana päivänä",
      "subtitleWithMaker": "{{carMaker}} - näihin ja moniin muihin liikkeisiin ostetaan {{carMaker}}-autoja",
      "body1WithMaker": "Baana on auton myynnin kilpailutuspalvelu, jossa voit yhdellä ilmoituksella kilpailuttaa tarjoukset autoliikkeiltä ympäri Suomen {{carMaker}}-autostasi. Baanassa ostetaan autoja niin isojen ketjujen kuin pienten liikkeiden toimesta. Myy {{carMaker}} nopeimmillaan jopa samana päivänä.",
      "body1": "Baana on auton myynnin kilpailutuspalvelu, jossa voit yhdellä ilmoituksella kilpailuttaa tarjoukset autoliikkeiltä ympäri Suomen. Baanassa ostetaan autoja niin isojen ketjujen kuin pienten liikkeiden toimesta. Myy autosi nopeimmillaan jopa samana päivänä.",
      "title2": "Baanassa ostetaan kaikkia autoja",
      "body2": "Baanan kautta ostetaan sekä yleisimpiä Suomen teillä olevia autoja että harvinaisempia malleja – kilpailutus kannattaa autosta riippumatta!",
      "body3WithMaker": "Baanan kautta ostetaan {{carMaker}}-henkilöautoja ja -pakettiautoja, bensa-autoja, dieselautoja, hybridiautoja, sähköautoja, farmariautoja, tila-autoja ja monia muita.",
      "body3": "Baanan kautta ostetaan henkilöautoja ja pakettiautoja, bensa-autoja, dieselautoja, hybridiautoja, sähköautoja, farmariautoja, tila-autoja ja monia muita.",
      "title3": "Vaivaton myynti, luotettavat ostajat",
      "body4": "Kilpailutuksen ansiosta saat autostasi aina parhaan hinnan, jonka autoliikkeet siitä kyseisellä hetkellä maksavat. Myynti on helppoa ja luotettavaa, sillä liikkeen ammattilaiset hoitavat paperityöt puolestasi."
    }
  },
  "consumer": {
    "menu": {
      "articles": "Artikkelit",
      "auctions": "Kilpailutukset",
      "contactInfo": "Yhteystiedot",
      "faq": "Usein kysyttyä",
      "login": "Kirjaudu",
      "logout": "Kirjaudu ulos",
      "newAuction": "Uusi kilpailutus",
      "notifications": "Ilmoitukset",
      "ownAuctions": "Omat kilpailutukset",
      "toDealerView": "Ostajille",
      "userSettings": "Käyttäjäasetukset"
    },
    "seo": {
      "homePage": {
        "title": {
          "car": "Baana - Kilpailuta auton myynti liikkeeseen - löydä paras hinta",
          "moto": "Baana - Kilpailuta Moottoripyörän, mopon, mönkijän, mopoauton tai skootterin myynti liikkeeseen - löydä paras hinta",
          "caravan": "Baana - Kilpailuta matkailuauton, matkailuvaunun tai talovaunun myynti liikkeeseen - löydä paras hinta"
        },
        "description": {
          "car": "Myy autosi autoliikkeelle nopeasti, parhaalla hinnalla. Kilpailuta kerralla autoliikkeet ympäri Suomen ja tee kaupat jopa samana päivänä.",
          "moto": "Myy Moottoripyörä, mopo, mönkijä, mopoauto tai skootteri liikkeelle nopeasti, parhaalla hinnalla. Kilpailuta kerralla liikkeet ympäri Suomen ja tee kaupat jopa samana päivänä.",
          "caravan": "Myy matkailuauto, matkailuvaunu tai talovaunu liikkeelle nopeasti, parhaalla hinnalla. Kilpailuta kerralla liikkeet ympäri Suomen ja tee kaupat jopa samana päivänä."
        }
      }
    },
    "auctionPage": {
      "editingDisabled": "Valitettavasti kyseistä kilpailutusta ei pysty muokkaamaan."
    },
    "components": {
      "apiError": {
        "somethingWentWrong": "Jotain meni pieleen"
      },
      "deletePictureConfirm": "Haluatko varmasti poistaa kuvan?",
      "deletePictureQ": "Poista kuva?",
      "errorOccurred": "Valitettavasti nyt tapahtui virhe. Yritä myöhemmin uudelleen."
    },
    "homePage": {
      "cars": "Autot",
      "motoVehicleTypes": "Moottoripyörät, mönkijät, moottorikelkat",
      "caravanVehicleTypes": "Matkailuautot ja -vaunut",
      "carBasicInfoTitle": "Auton perustiedot",
      "carConditionTitle": "Tiedot auton kunnosta",
      "continueAuction": "Jatka kilpailutuksen täyttöä",
      "CAR": {
        "instructionBullet1": "Täytä autosi tiedot",
        "instructionBullet2": "Kilpailuta autoliikkeiden tarjoukset",
        "instructionBullet3": "Myy eniten tarjoavalle",
        "descriptionHeader": "Kilpailuta kerralla tarjoukset autoliikkeiltä ympäri Suomen",
        "descriptionListItem-1": "Maksuton palvelu, joka ei velvoita auton myyntiin",
        "descriptionListItem-2": "Tarvitset vain perustiedot ja kuvat autostasi",
        "descriptionListItem-3": "Kaupat jopa samana päivänä, luotettavat autoliikkeiden ostajat",
        "dealerLogoTitle": "Ostajina nämä ja sadat muut autoliikkeet",
        "instructionListItem-1-title": "Syötä perustiedot",
        "instructionListItem-1-body": "Ilmoitusta varten tarvitset rekisteritunnuksen ja mittarilukeman. Auto soveltuu Baanaan, jos se on enintään 250 000 km ajettu ja rekisteröity Suomeen. Moottoripyörä, mopo, mönkijä, mopoauto, skootteri tai moottorikelkka soveltuu Baanaan, jos se on enintään 100 000 km ajettu.",
        "instructionListItem-2-title": "Ota kuvat",
        "instructionListItem-2-body": "Palvelu ohjaa sinut lisäämään pakolliset kuvat autostasi (ulko- ja sisäkuvat). Suosittelemme lisäämään myös muita kuvia mahdollisimman kattavasti, esim. huoltokirjasta.",
        "instructionListItem-3-title": "Kerro auton kunnosta",
        "instructionListItem-3-body": "Kuvaile ainakin autosi renkaiden ja tuulilasin kunto ilmoituksessa. Jos autossa on vaurioita, kerro ne ja lisää niistä kuvat.\n\nVoit tallentaa ilmoituksen luonnoksena ja tehdä sen loppuun myöhemmin.",
        "sellCarTitle": "Myy autosi parhaalla hinnalla"
      },
      "MOTO": {
        "instructionBullet1": "Täytä motosi tiedot",
        "instructionBullet2": "Kilpailuta ostajaliikkeet",
        "instructionBullet3": "Myy eniten tarjoavalle",
        "vehicleTypes": "Moottoripyörä, mönkijä, skootteri tai moottorikelkka",
        "descriptionHeader": "Kilpailuta kerralla tarjoukset liikkeiltä ympäri Suomen",
        "descriptionListItem-1": "Maksuton palvelu, joka ei velvoita ajoneuvon myyntiin",
        "descriptionListItem-2": "Tarvitset vain perustiedot ja kuvat ajoneuvosta",
        "descriptionListItem-3": "Kaupat jopa samana päivänä, luotettavat liikkeiden ostajat",
        "dealerLogoTitle": "Ostajina nämä ja sadat muut liikkeet",
        "instructionListItem-1-title": "Syötä perustiedot",
        "instructionListItem-1-body": "Ilmoitusta varten tarvitset rekisteritunnuksen ja mittarilukeman. Auto soveltuu Baanaan, jos se on enintään 250 000 km ajettu ja rekisteröity Suomeen. Moottoripyörä, mopo, mönkijä, mopoauto, skootteri tai moottorikelkka soveltuu Baanaan, jos se on enintään 100 000 km ajettu.",
        "instructionListItem-2-title": "Ota kuvat",
        "instructionListItem-2-body": "Palvelu ohjaa sinut lisäämään pakolliset kuvat ajoneuvostasi (ulko- ja mahdolliset sisäkuvat). Suosittelemme lisäämään myös muita kuvia mahdollisimman kattavasti.",
        "instructionListItem-3-title": "Kerro ajoneuvon kunnosta",
        "instructionListItem-3-body": "Kuvaile ainakin renkaiden ja mahdollisen tuulilasin kunto ilmoituksessa. Jos ajoneuvossa on vaurioita, kerro ne ja lisää niistä kuvat.\n\nVoit tallentaa ilmoituksen luonnoksena ja tehdä sen loppuun myöhemmin.",
        "sellCarTitle": "Myy parhaalla hinnalla"
      },
      "CARAVAN": {
        "instructionBullet1": "Täytä ajoneuvosi tiedot",
        "instructionBullet2": "Kilpailuta ostajaliikkeet",
        "instructionBullet3": "Myy eniten tarjoavalle",
        "vehicleTypes": "Matkailuauto, matkailuvaunu, talovaunu",
        "descriptionHeader": "Kilpailuta kerralla tarjoukset liikkeiltä ympäri Suomen",
        "descriptionListItem-1": "Maksuton palvelu, joka ei velvoita ajoneuvon myyntiin",
        "descriptionListItem-2": "Tarvitset vain perustiedot ja kuvat ajoneuvosta",
        "descriptionListItem-3": "Kaupat jopa samana päivänä, luotettavat liikkeiden ostajat",
        "dealerLogoTitle": "Ostajina nämä ja sadat muut liikkeet",
        "instructionListItem-1-title": "Syötä perustiedot",
        "instructionListItem-1-body": "Ilmoitusta varten tarvitset rekisteritunnuksen ja mittarilukeman. Auto tai matkailuauto soveltuu Baanaan, jos se on enintään 250 000 km ajettu ja rekisteröity Suomeen. Moottoripyörä, mopo, mönkijä, mopoauto tai skootteri soveltuu Baanaan, jos se on enintään 100 000 km ajettu.",
        "instructionListItem-2-title": "Ota kuvat",
        "instructionListItem-2-body": "Palvelu ohjaa sinut lisäämään pakolliset kuvat ajoneuvostasi (ulko- ja mahdolliset sisäkuvat). Suosittelemme lisäämään myös muita kuvia mahdollisimman kattavasti.",
        "instructionListItem-3-title": "Kerro ajoneuvon kunnosta",
        "instructionListItem-3-body": "Kuvaile ainakin renkaiden ja mahdollisen tuulilasin kunto ilmoituksessa. Jos ajoneuvossa on vaurioita, kerro ne ja lisää niistä kuvat.\n\nVoit tallentaa ilmoituksen luonnoksena ja tehdä sen loppuun myöhemmin.",
        "sellCarTitle": "Myy parhaalla hinnalla"
      },
      "descriptionListItem-4": "Voit hyväksyä tai hylätä minkä tahansa tarjouksen",
      "descriptionListItem-5": "Kaupat luotettavan ostajan kanssa. Liike hoitaa paperityöt",
      "descriptionListItem-6": "Useimmat liikkeet noutavat auton kotoasi",
      "descriptionListItem-7": "Suomalainen palvelu, suomenkielinen asiakastuki käytössäsi arkisin klo 9-16",
      "faqBody": "Vastaus voi löytyä palvelun usein kysytyistä kysymyksistä.",
      "faqTitle": "Tarvitsetko apua ilmoituksen teossa tai askarruttaako joku muu asia?",
      "showAuction": "Omat kilpailutukset",
      "start": "Aloita",
      "startAuction": "Aloita kilpailutus tästä",
      "title": "Myy ajoneuvosi parhaalla hinnalla",
      "titleMain": "Myy ajoneuvosi",
      "titleEmphasis": "parhaalla hinnalla",
      "title2": "Näin teet myynti-ilmoituksen",
      "articleBlockTitle": "Uusimmat artikkelit",
      "katsastusBanner": {
        "title": "Kuntotutkimus tekee autostasi houkuttelevamman",
        "subtitle": "Saat paremman hinnan, kun ostaja tietää tarkalleen autosi kunnon.",
        "ctaButton": "Lue lisää"
      },
      "recentlySoldTitle": "Juuri myytyjä Baanassa",
      "activeAuctionsBanner": {
        "title": "Sinulla on {{count}} aktiivista kilpailutusta",
        "andMore": "ja {{count}} muuta",
        "viewAuctions": "Näytä kilpailutukset"
      }
    },
    "myAuctions": {
      "republish": {
        "title": "Kilpailuta uudelleen",
        "body": "Voit muokata ilmoitusta ennen julkaisua."
      },
      "republishModal": {
        "title": "Tarkista ilmoituksen tiedot ennen uutta kilpailutusta",
        "body": "Voit vielä muokata ilmoitusta ennen uudelleenjulkaisua. Huomaa: jos olet lisännyt tietoja edellisen kilpailutuksen aikana, ne eivät päivity ilmoitukseen automaattisesti.",
        "bodyNoAdditionalInfo": "Seuraavassa näkymässä voit vielä muokata ilmoituksen tietoja ennen kuin se julkaistaan uudelleen.",
        "bodyWithAdditionalInfo": "Aiempaan kilpailutukseen lisätyt tekstitiedot eivät siirry uuteen ilmoitukseen automaattisesti. Tarkista ja päivitä ne tarvittaessa seuraavassa vaiheessa.",
        "previousInfoHeader": "Aiemmat lisätiedot:",
        "addedAt": "Lisätty",
        "onlyImagesAdded": "Kuvia lisätty",
        "publish": "Tarkista ilmoitus",
        "errorText": "Uudelleenjulkaisu epäonnistui. Ota yhteyttä asiakaspalveluun."
      },
      "distanceBetween": "Etäisyys ostajaan",
      "businessName": "Ostaja",
      "pickup": "Nouto",
      "questions": {
        "notAnsweredYet": "(Et ole vielä vastannut tähän kysymykseen)",
        "answer": "Vastaa",
        "noQuestions": "(Ei kysymyksiä)",
        "answerDeleted": "Vastaus poistettu",
        "answerDeleteError": "Vastauksen poistaminen epäonnistui",
        "answerDelete": "Poista vastaus?",
        "answerSentSuccessfully": "Vastaus lähetetty",
        "answerSendError": "Vastauksen lähetys epäonnistui",
        "answerTheQuestion": "Vastaa kysymykseen",
        "writeAnswer": "Kirjoita vastaus"
      },
      "userInfoMissingModal": {
        "title": "Päivitä henkilötiedot",
        "text": "Päivitäthän puuttuvat henkilötietosi, niin pääset hyväksymään tarjouksen. ",
        "textLink": "Lue lisää tietojen keräämisestä",
        "taxIdentificationNumberInfo": "Henkilötunnusta ei luovuteta muille tahoille kuin veroviranomaiselle."
      }
    },
    "wizard": {
      "common": {
        "validationSummaryTitle": "Tarkista alla olevat kohdat ennen jatkamista",
        "targetPrice": "Tavoitehinta"
      },
      "phoneNumberPlaceholder": "esim. 0441234567",
      "title": "Myy autosi vaivattomasti parhaalla hinnalla",
      "verticalPrefillNotFound": "Ilmoitusta rekisterinumerolla {{regNo}} ei löytynyt {{source}}sta. Tarkista rekisterinumero tai täytä tiedot manuaalisesti.",
      "verticalPrefillUnavailable": "Tietojen hakeminen {{source}}sta epäonnistui. Yritä myöhemmin uudelleen tai täytä tiedot manuaalisesti.",
      "verticalPrefillDealerNotAllowed": "Ajoneuvoliikkeiden autoja ei voi ilmoittaa Baanassa",
      "verticalPrefillAlreadyHasAuction": "Sinulla on jo aktiivinen kilpailutus, et voi tuoda {{source}}sta ilmoitusta.",
      "verticalPrefillRegnoAlreadyInUse": "Rekisterinumerolle {{regNo}} on jo olemassa luonnostilassa oleva ilmoitus. Uutta kilpailutusta ei voida luoda samalla rekisterinumerolla.",
      "existingDraftModal": {
        "title": "Kirjaudu sisään jatkaaksesi",
        "body": "Rekisterinumerolla {{regno}} on jo luonnos tai kilpailutus käynnissä sähköpostiosoitteella {{maskedEmail}}. Kirjaudu sisään jatkaaksesi tai syötä eri rekisterinumero.",
        "loginCta": "Kirjaudu sisään",
        "clearRegnoCta": "Syötä eri rekisterinumero"
      },
      "verticalImport": {
        "regNoLabel": "Rekisterinumero",
        "fetchButton": "Hae tiedot",
        "loginAndFetch": "Kirjaudu ja hae tiedot",
        "newBadge": "UUSI",
        "car": {
          "buttonText": "Tuo tiedot {{source}}-ilmoituksesta",
          "title": "Tuo {{source}}-ilmoitus",
          "description": "Syötä {{source}}-ilmoituksen rekisterinumero alle, niin täytämme löydetyt tiedot automaattisesti. Voit tuoda <strong>alle 250 000 km</strong> ajettuja autoja.",
          "regNoHelper": "Esim. ABC-123"
        },
        "moto": {
          "buttonText": "Tuo tiedot {{source}}-ilmoituksesta",
          "title": "Tuo {{source}}-ilmoitus",
          "description": "Syötä {{source}}-ilmoituksen rekisterinumero alle, niin täytämme löydetyt tiedot automaattisesti. Voit tuoda <strong>alle 100 000 km</strong> ajettuja motoja.",
          "regNoHelper": "Esim. AB-123"
        },
        "caravan": {
          "buttonText": "Tuo tiedot {{source}}-ilmoituksesta",
          "title": "Tuo {{source}}-ilmoitus",
          "description": "Syötä {{source}}-ilmoituksen rekisterinumero alle, niin täytämme löydetyt tiedot automaattisesti. Voit tuoda <strong>alle 250 000 km</strong> ajettuja karavaaneja.",
          "regNoHelper": "Esim. ABC-123"
        },
        "progress": {
          "title": "Siirretään ilmoitusta {{source}}sta",
          "fetchingData": "Haetaan tietoja {{source}}sta...",
          "creatingAuction": "Luodaan ilmoitusta...",
          "transferringImages": "Siirretään kuvia...",
          "finalizing": "Viimeistellään..."
        },
        "success": {
          "completeDetails": "Viimeistele ilmoitus\n\nTäytä vielä puuttuvat tiedot, niin ilmoitus on valmis julkaistavaksi Baanassa"
        }
      },
      "auctionWizard": {
        "auctionAlreadyActive": "Sinulla on aktiivinen kilpailutus",
        "auctionUnfinished": "Sinulla on keskeneräinen kilpailutus. Jatka kilpailutuksen täyttämistä.",
        "showAuctions": "Omat kilpailutukset",
        "draftSavedSuccessfully": "Kilpailutusilmoitus tallennettu luonnoksena. Voit jatkaa sen täyttöä myöhemmin.",
        "draftSaveError": "Valitettavasti luonnoksen tallennus ei onnistunut",
        "resetAuctionVerificationModal": {
          "title": "Aloita uusi ilmoitus",
          "description": "Sinulla on luonnostilassa oleva ilmoitus. Haluatko jatkaa luonnosta vai luoda uuden ilmoituksen?",
          "resetAuctionButton": "Luo uusi ilmoitus",
          "continueWithDraftButton": "Jatka luonnosta"
        },
        "leaveConfirmation": {
          "title": "Poistutaanko ilmoituksesta?",
          "description": "Tallennamme ilmoituksesi luonnoksena. Voit jatkaa myöhemmin kohdasta Omat kilpailutukset. Haluatko poistua?",
          "leave": "Poistu",
          "stay": "Jatka luonnosta"
        }
      },
      "moto": {
        "motoStepRegnoMileage": {
          "stepTitle": "Ajoneuvon tiedot",
          "mileage": "Mittarilukema",
          "orGiveBasicInfo": "TAI anna ajoneuvon perustiedot",
          "labelRegnoExample": "Rekisteritunnus (AB-123)",
          "licenseFormatError": "Tarkista rekisteritunnuksen muoto",
          "licenseMissingError": "Tarkista rekisteritunnus",
          "checkMileageError": "Tarkista ajokilometrit",
          "mileageZeroError": "Arvon on oltava suurempi kuin 0",
          "mileageOverError": "Voit kilpailuttaa alle 100 000 km ajettuja ajoneuvoja"
        },
        "motoStepBasicVehicleInfo": {
          "stepTitle": "Ajoneuvon perustiedot",
          "labelRegNo": "Rekisteritunnus",
          "mileage": "Ajokilometrit",
          "mileageUnit": {
            "KM": "km",
            "H": "h"
          },
          "motoType": "Ajoneuvolaji",
          "type": "Tyyppi",
          "make": "Merkki",
          "model": "Malli",
          "modelType": "Mallitarkenne",
          "modelYear": "Vuosimalli",
          "roadLegal": "Liikennekelpoisuus",
          "roadLegalOptions": {
            "roadLegal": "Tieliikennekelpoinen",
            "notRoadLegal": "Ei tieliikennekelpoinen"
          },
          "firstRegistrationMonth": "Käyttöönottokuukausi",
          "firstRegistrationYear": "Käyttöönottovuosi",
          "numberOfOwners": "Aiempien omistajien lukumäärä",
          "popularResults": "Suositut",
          "otherResults": "Muut",
          "snowmobileDemandWarning": "Moottorikelkkojen kysyntä on tällä hetkellä vähäistä, joten tarjouksia ei välttämättä tule. Voit silti jättää ilmoituksen normaalisti.",
          "mopedDemandWarning": "Mopojen kysyntä on tällä hetkellä vähäistä, joten tarjouksia ei välttämättä tule. Voit silti jättää ilmoituksen normaalisti."
        },
        "motoStepTechnicalInfo": {
          "stepTitle": "Tekniset tiedot",
          "driveType": "Vetotapa",
          "gearType": "Vaihteisto",
          "engineSize": "Moottorin tilavuus",
          "powerClass": "Teholuokka",
          "fuelType": "Moottorin tyyppi",
          "isCoSeater": "Rinnakkain istuttava",
          "cooling": "Jäähdytys",
          "trackWidth": "Telan leveys",
          "coolingOptions": {
            "airCooled": "Ilmajäähdytys",
            "waterCooled": "Vesi-/nestejäähdytys"
          }
        },
        "stepBasicInfo": {
          "stepTitle": "Ajoneuvon tiedot",
          "pageTitle": "Ajoneuvon perustiedot",
          "ownerInfo": "Omistajuus",
          "ownershipTitle": "Omistajuus",
          "vehicleOwnershipSelf": "Omistan ajoneuvon itse",
          "vehicleOwnerShipOther": "Teen ilmoituksen toisen puolesta",
          "vehicleOwnershipFinanceCompany": "Ajoneuvon omistaa rahoitusyhtiö",
          "vehicleOwnershipBusiness": "Yritys omistaa ajoneuvon",
          "maintenanceBookTitle": "Kuinka kattava ajoneuvon huoltokirja on?",
          "maintenanceBookPerfectBrand": "Täydellinen merkkihuoltokirja",
          "maintenanceBookPerfect": "Täydellinen huoltokirja",
          "maintenanceBookIncomplete": "Puutteellinen huoltokirja",
          "maintenanceBookNone": "Ei ole",
          "lastMaintenanceTitle": "Viimeisin huolto",
          "lastMaintenanceYear": "Vuosi",
          "lastMaintenanceMonth": "Kuukausi",
          "lastMaintenanceMileage": "Kilometrit",
          "lastMaintenanceUnknown": "Ei tiedossa",
          "lastMaintenanceUnknownInfo": "Tämä tieto vaikuttaa merkittävästi siihen, kuinka paljon ostaja on valmis tarjoamaan moottoripyörästäsi. Oletko varma, ettet halua syöttää sitä?",
          "lastMaintenanceKms": "Täytä vielä viimeisimmän huollon kilometrimäärä",
          "lastMaintenanceKmsTooHigh": "Kilometrimäärä pitää olla pienempi kuin ajokilometrit: {{mileage}}",
          "clearMaintenance": "Tyhjennä huolto",
          "maintenanceBookInfo": "Vapaa kuvaus",
          "incompleteMaintenanceBook": "Voit täyttää puuttuvat tiedot huoltokirjasta",
          "keyCountTitle": "Avainten määrä",
          "keyCountOne": "Yksi",
          "keyCountTwoOrMore": "Kaksi tai useampi"
        },
        "stepFreeDescription": {
          "labelFreeDescription": "Avoin kuvaus",
          "stepSubtitle": "Voit kirjoittaa ajoneuvostasi vapaamuotoisen kuvauksen myynti-ilmoitustasi varten.",
          "stepTitle": "Oma kuvauksesi ajoneuvosta",
          "stepHeading": "Vapaa kuvaus ajoneuvosta"
        },
        "motoStepDelivery": {
          "delivery": "Toimitus",
          "chooseDistance": "Valitse etäisyys, johon asti olet valmis toimittamaan ajoneuvosi.",
          "labelDeliveryWanted": "Haluan ajoneuvolleni noudon",
          "stepAdditionalInfo": "Huom. mikäli olet valmis toimittamaan ajoneuvosi itse, saat todennäköisesti ajoneuvollesi paremman hinnan.",
          "vatDeductible": "ALV-vähennyskelpoinen",
          "stepHeading": "Yhteystiedot ja toimitus",
          "targetPrice": "Tavoitehinta",
          "targetPriceTooHigh": "Tavoitehinta on liian suuri"
        },
        "stepVehicleCondition": {
          "stepTitle": "Ajoneuvon kunto",
          "tireWear": "Renkaiden kunto",
          "tireWearNew": "Uudet renkaat",
          "tireWearGood": "Hyvät renkaat",
          "tireWearFair": "Kohtalaiset renkaat",
          "tireWearBad": "Huonot renkaat",
          "tireWearNone": "Ei renkaita",
          "trackWear": "Telojen kunto",
          "trackWearNew": "Uudet telat",
          "trackWearGood": "Hyvät telat",
          "trackWearFair": "Kohtalaiset telat",
          "trackWearBad": "Huonot telat",
          "trackWearNone": "Ei teloja",
          "rimsHas": "On vanteet",
          "rimsHasNone": "Ei vanteita",
          "windshieldConditionGood": "Hyvä tuulilasi",
          "windshieldConditionWornOut": "Kulunut tuulilasi",
          "windshieldConditionStoneMark": "Kiveniskemä tuulilasissa",
          "windshieldConditionCracked": "Halki tuulilasi",
          "mileage": "Kilometrimäärä",
          "mileageError": "Syötetty luku on suurempi kuin ajokilometrit",
          "engine": "Moottori",
          "fuelSystem": "Polttoainejärjestelmä",
          "electricalSystem": "Sähköjärjestelmä",
          "coldStartProblems": "Kylmäkäynnistysongelmat",
          "frame": "Runko",
          "suspensionAndChassis": "Jousitus ja alusta",
          "track": "Telat",
          "transmissionAndClutch": "Vaihteisto ja kytkin",
          "brakes": "Jarrut",
          "tiresAndSuspension": "Renkaat ja jousitus",
          "steering": "Ohjaus",
          "exhaust": "Pakoputkisto",
          "fairings": "Katteet",
          "labelDamageFreeText": "Esim. penkin päällysteet revenneet.",
          "damageTitle": "Onko {{motoSubTypeText}} lisäksi jotain näistä vaurioista?",
          "additionalDamageInfo": "Voit tarkentaa tietoja tai kertoa jostain muusta vauriosta alle. Palvelu pyytää myös lisäämään kuvan listaamistasi asioista."
        },
        "stepAccessories": {
          "accessoriesTitle": "Ajoneuvosi varustelutaso",
          "accessoryQuestion": "Onko {{motoSubTypeText}} lisäksi jotain näistä lisävarusteista",
          "additionalAccessoriesSubtitle": "Voit halutessasi täydentää {{motoSubTypeText}} lisävarusteita",
          "labelAccessoriesExamples": "Esim. Kaatumaraudat, vetokäynnistys, käsisuojat",
          "trimLevelSubtitle": "Kirjoita {{motoSubTypeText}} varustelutason nimi. Jos et tiedä varustelutasoa, jätä tämä kohta tyhjäksi.",
          "labelAccessoriesExamplesMotorcycle": "",
          "labelAccessoriesExamplesMoped": "",
          "labelAccessoriesExamplesMopedCar": "",
          "labelAccessoriesExamplesATV": "",
          "labelAccessoriesExamplesScooter": "",
          "labelAccessoriesExamplesSnowmobile": "Esim. Säilytyslaukut, GPS-navigaattori, lumiankkurit",
          "motoSubTypeTextMotorcycle": "moottoripyörässäsi",
          "motoSubTypeTextMoped": "mopossasi",
          "motoSubTypeTextATV": "mönkijässäsi",
          "motoSubTypeTextScooter": "skootterissasi",
          "motoSubTypeTextMopedCar": "mopoautossasi",
          "motoSubTypeTextSnowmobile": "moottorikelkassasi",
          "motoSubTypeTextDefault": "ajoneuvossasi",
          "motoSubTypeTextMotorcycle2": "moottoripyöräsi",
          "motoSubTypeTextMoped2": "moposi",
          "motoSubTypeTextATV2": "mönkijäsi",
          "motoSubTypeTextScooter2": "skootterisi",
          "motoSubTypeTextMopedCar2": "mopoautosi",
          "motoSubTypeTextSnowmobile2": "moottorikelkkasi",
          "motoSubTypeTextDefault2": "ajoneuvosi"
        },
        "stepAccessoriesMotorbike": {
          "12vOutlet": "12V ulosotto",
          "serviceBook": "Huoltokirja",
          "crashBars": "Kaatumaraudat",
          "heatedGrips": "Kahvanlämmittimet",
          "tractionControl": "Luistonesto",
          "antiLockBrakes": "Lukkiutumattomat jarrut",
          "navigator": "Navigaattori",
          "backrest": "Selkänoja",
          "sideBags": "Sivulaukut",
          "electricStart": "Sähkökäynnistys",
          "topCase": "Takalaukku",
          "cruiseControl": "Vakionopeudensäädin",
          "adaptiveCruiseControl": "Mukautuva vakionopeudensäädin",
          "ledAuxLights": "LED-apuvalot",
          "gpsNavigator": "GPS-navigaattori"
        },
        "stepAccessoriesATV": {
          "storageBoxes": "Tavarakorit",
          "winch": "Vinssi",
          "snowPlow": "Lumiaura",
          "skidPlate": "Pohjapanssari",
          "offRoadTires": "Maastorenkaat",
          "ledLights": "LED-valot",
          "towHitch": "Vetokoukku"
        },
        "stepAccessoriesMoped": {
          "luggageRack": "Tavarateline",
          "smallTopCase": "Pieni takalaukku",
          "chainGuard": "Ketjusuoja",
          "heatedGrips": "Kahvalämmitin",
          "usbChargingPort": "USB-latausportti",
          "ledLights": "LED-valot",
          "seatCover": "Istuinsuoja",
          "footGuards": "Jalkasuojat"
        },
        "stepAccessoriesScooter": {
          "seatBag": "Istuinlaukku",
          "topCase": "Takalaukku",
          "mirrors": "Peilit",
          "weatherShield": "Sääsuoja",
          "handGuards": "Käsisuojat",
          "usbChargingPort": "USB-latausportti",
          "ledLights": "LED-valot",
          "phoneMount": "Puhelinteline"
        },
        "stepAccessoriesSnowmobile": {
          "storageBags": "Säilytyslaukut",
          "cargoRacks": "Tavarakorit",
          "heatedGrips": "Kahvalämmitin",
          "ledHeadlights": "LED-ajovalot",
          "gpsNavigator": "GPS-navigaattori",
          "skidPlate": "Pohjapanssari",
          "deepSnowTracks": "Syvälumitelat",
          "snowAnchors": "Lumiankkurit"
        },
        "stepAccessoriesMopedCar": {
          "centralLocking": "Kaukosäätöinen keskuslukitus",
          "leatherInterior": "Nahkasisusta",
          "radio": "Radio",
          "electricWindows": "Sähköikkunat",
          "reversingCamera": "Peruutuskamera",
          "usbChargingPort": "Puhelimen latauspistoke",
          "ledDaytimeRunningLights": "LED-päiväajovalot"
        },
        "stepMedia": {
          "stepTitle": "Kuvat",
          "stepSubtitle": "Lisää kuvia ajoneuvostasi",
          "stepHeading": "Kuvat",
          "bulletListTitle": "Pakollisia kuvia moottoripyörästä, moposta, mönkijästä tai skootterista ovat:",
          "helpText": "Jos ajoneuvossasi on mainitsemisen arvoisia naarmuja, vaurioita tai puutteita, näistä on hyvä myös ottaa kuvat.",
          "damageDescriptionTitle": "Vaurioiden kuvaus",
          "damageDetailsTitle": "Kerroit, että ajoneuvossasi on seuraavia vaurioita:",
          "damagePictures": "Vaurioiden kuvat",
          "damagePicturesSubtitle": "Jos lisäät myös tarkat kuvat vaurioista tai vioista, myyt motosi jopa 2,5 kertaa todennäköisemmin.",
          "labelAddPhoto": "Lisää kuva",
          "labelMainPhoto": "Edestä",
          "labelDamagePhoto": "Kuva vauriosta",
          "labelInterior": "Sisätilat",
          "labelTrunk": "Tavaratila",
          "labelTyres": "Renkaat",
          "perspectiveBack": "Kuva takaa",
          "perspectiveBackAngle": "Kuva takaviistosta",
          "perspectiveDashboard": "Kuva kojelaudasta auto käynnissä",
          "perspectiveFront": "Kuva edestä",
          "perspectiveFrontAngle": "Kuva etuviistosta",
          "perspectiveSideLeft": "Kuva vasemmalta",
          "perspectiveSideRight": "Kuva oikealta",
          "perspectiveFrontTire": "Kuva eturenkaasta",
          "perspectiveBackTire": "Kuva takarenkaasta",
          "perspectiveRightTrack": "Kuva oikeasta telasta",
          "perspectiveLeftTrack": "Kuva vasemmasta telasta",
          "perspectiveDashboardMoto": "Kuva mittaristosta",
          "photoTakingTips": "Pakollisten kuvien lisäksi suosittelemme lisäämään kuvan ainakin huoltokirjastasi:",
          "stepDescription": "Lisää kuvat ajoneuvostasi. Mitä monipuolisemmat kuvat, sitä realistisempia tarjouksia saat.",
          "processingImages": "Prosessoidaan kuvia...",
          "uploadProgress": "{{uploaded}} / {{total}} kuvaa ladattu",
          "aisaProcessingSingle": "Viimeistellään kuvan käsittelyä",
          "aisaProcessingMultiple": "Viimeistellään kuvien käsittelyä",
          "doNotRefreshWarning": "Odota, että kaikki kuvat on käsitelty",
          "requiredPhoto": "*Pakollinen kuva",
          "requiredPhotosMissingError": "Lisää kaikki pakolliset kuvat",
          "imageTooBigError": "Kuva on liian iso. Maksimikoko on 15Mt.",
          "imageTooLowQuality": "Lisäämäsi kuva on heikkolaatuinen. Suosittelemme käyttämään riittävän laadukkaita kuvia, jotta ostajat saavat niiden perusteella muodostettua oikean kuvan ajoneuvostasi.",
          "unsupportedMediaType": "Palvelumme ei valitettavasti tue valitsemasi kuvan tiedostotyyppiä.",
          "damageReminderTitle": "Valitsit aikaisemmin seuraavat vauriot:",
          "minimumDamageImages": "Vähintään {{count}} vauriokuvaa vaaditaan",
          "requiredDamageImages": "Vauriokuvat vaaditaan",
          "titleFront": "Edestä (Pääkuva)",
          "titleBack": "Takaa",
          "titleLeftSide": "Vasen sivu",
          "titleRightSide": "Oikea sivu",
          "titleFrontTire": "Etuosa",
          "titleBackTire": "Takaosa",
          "titleDashboardMoto": "Kojelauta (Käynnissä)",
          "titleRightTrack": "Oikea telaketju",
          "titleLeftTrack": "Vasen telaketju",
          "titleMaintenanceBook": "Huoltokirja",
          "titleChainAndSprocket": "Ketju ja rattaat",
          "brokenImagesWarning": "{{count}} kuvan lataus epäonnistui. Poista lataamattomat kuvat, niin pääset siirtymään seuraavaan vaiheeseen.",
          "brokenImageAutoRemoved": "1 lataamaton kuva poistettiin automaattisesti.",
          "brokenImagesAutoRemoved": "{{count}} lataamatonta kuvaa poistettiin automaattisesti.",
          "refreshWarning": "Haluatko varmasti päivittää sivun? Kuvien lataus tai käsittely on kesken.",
          "imagesProcessing": "Odota, kuvia käsitellään..."
        },
        "stepSummary": {
          "stepTitle": "Yhteenveto",
          "stepHeading": "Myynti-ilmoitus",
          "additionalAccessories": "Onko ajoneuvossasi lisäksi jotain näistä lisävarusteista?",
          "delivery": "Ajoneuvon toimittaminen kauppojen jälkeen",
          "checkInfo": "Tarkista vielä, että tiedot ovat oikein. Sitten voit julkaista ilmoituksen!",
          "deliveryDistance": "Etäisyys, johon asti olet valmis toimittamaan ajoneuvosi",
          "descriptionNotProvided": "(kuvausta ei annettu)",
          "labelEditMileage": "Muokkaa mittarilukemaa",
          "ownership": "Ajoneuvon omistajuus",
          "possibleDamages": "Mahdolliset vauriot",
          "trimLevel": "Ajoneuvon varustelutaso",
          "deliveryPickup": "Ajoneuvo on noudettava",
          "editTargetPrice": "Muokkaa tavoitehintaa",
          "publishConfirmation": {
            "modalTitle": "Vahvista julkaisu ja kesto",
            "areYouSure": "Oletko varma, että haluat julkaista ilmoituksen?",
            "cannotEditAfterPublish": "Julkaisun jälkeen ilmoitusta ei voi enää muokata.",
            "durationTitle": "Milloin haluat kilpailutuksen päättyvän?",
            "quickOption": "Pikakilpailutus (Mikäli myynti on kiirellinen)",
            "normalOption": "Normaali (suositus)",
            "oneDayOption": "Seuraavana arkipäivänä (24 tuntia)",
            "twoDaysOption": "2 arkipäivän kuluttua (48 tuntia)",
            "sameDayOption": "Tänään (päättyy klo 14-17)",
            "estimatedEndTime": "Arvioitu päättymisaika",
            "normalOptionInfo": "Päättyy noin kahden arkipäivän kuluttua. Tarkka aika näkyy julkaisun jälkeen.",
            "sameDayHint": "Ennen klo 10:00 luotu kilpailutus päättyy samana päivänä (klo 14-17), muussa tapauksessa seuraavana arkipäivänä."
          },
          "basicInfoTitle": "Ajoneuvon perustiedot",
          "conditionTitle": "Ajoneuvon kunto",
          "accessoriesTitle": "Lisävarusteet",
          "usageHours": "Käyttötunnit",
          "mileageUnit": {
            "KM": "km",
            "H": "h"
          },
          "errors": {
            "mileageRequired": "Kilometrilukema on pakollinen ja sen on oltava suurempi kuin 0",
            "mileageTooHigh": "Kilometrilukema ylittää sallitun rajan",
            "mileageLowerThanCurrent": "Uusi kilometrilukema ei voi olla pienempi kuin viimeisimmän huollon kilometrit",
            "targetPriceRequired": "Tavoitehinta on pakollinen ja sen on oltava suurempi kuin 0",
            "targetPriceTooHigh": "Tavoitehinta on liian suuri"
          }
        }
      },
      "caravan": {
        "stepRegnoMileage": {
          "stepTitle": "Ajoneuvon perustiedot",
          "caravanTypeLabel": "Ajoneuvon tyyppi",
          "caravanTypeMotorhome": "Matkailuauto",
          "caravanTypeCaravan": "Matkailuvaunu",
          "caravanTypeStorageTrailer": "Talovaunu"
        },
        "stepOwnerInfo": {
          "stepTitle": "Ajoneuvon tiedot",
          "stepTitleNew": "Ajoneuvon tiedot",
          "labelCarInfo": "Ajoneuvon tiedot",
          "stepSubtitleNew": "Tarkista, että ajoneuvon tiedot ovat oikein.",
          "popularResults": "Suositut",
          "otherResults": "Muut"
        },
        "stepBasicInfo": {
          "stepTitle": "Ajoneuvon perustiedot",
          "moistureMeasurementTitle": "Onko ajoneuvoon tehty kosteusmittaus?",
          "moistureMeasurementNo": "Ei",
          "moistureMeasurementYes": "Kyllä",
          "moistureMeasurementDescriptionLabel": "Kerro tähän mitä ja milloin",
          "moistureMeasurementHelperText": "Voit myös lisätä kuvan myöhemmin",
          "amountOfKeys": "Ajoneuvon avainten määrä",
          "lastMaintenanceKms": "Täytä vielä viimeisimmän huollon kilometrimäärä",
          "lastMaintenanceMonth": "Täytä vielä viimeisimmän huollon kuukausi",
          "lastMaintenanceTitle": "Viimeisen huollon mittarilukema",
          "lastMaintenanceYear": "Täytä vielä viimeisimmän huollon vuosi",
          "lastMaintenanceUnknown": "Tämä tieto vaikuttaa merkittävästi siihen, kuinka paljon ostaja on valmis tarjoamaan ajoneuvostasi. Oletko varma, ettet halua syöttää sitä?",
          "lastMaintenanceLabel": "Viimeisen huollon vuosi ja kuukausi",
          "unknownLabel": "Ei tiedossa",
          "maintenanceBook": "Kuinka kattava ajoneuvon huoltokirja on?",
          "lastMaintenanceKmsTooHigh": "Kilometrimäärä pitää olla pienempi kuin ajokilometrit: {{mileage}}",
          "clearMaintenance": "Tyhjennä huolto",
          "stepHeading": "Ajoneuvon perustietoja",
          "vehicleOwnershipSelf": "Omistan ajoneuvon itse",
          "vehicleOwnerShipOther": "Teen ilmoituksen toisen puolesta",
          "vehicleOwnershipFinanceCompany": "Ajoneuvon omistaa rahoitusyhtiö",
          "vehicleOwnershipBusiness": "Yritys omistaa ajoneuvon",
          "amounOfKeysOne": "Yksi",
          "amountOfKeysTwoOrMore": "Kaksi tai useampi",
          "maintenanceBookPerfectBrand": "Täydellinen merkkihuoltokirja",
          "maintenanceBookPerfect": "Täydellinen huoltokirja",
          "maintenanceBookMaintainedNotByProgram": "Huollettu, mutta ei huolto-ohjelman mukaan",
          "maintenanceBookIncomplete": "Puutteellinen huoltokirja",
          "maintenanceBookNone": "Ei huoltokirjaa",
          "incompleteMaintenanceBook": "Voit tarkentaa puutteita huoltokirjasta",
          "lastInspection": {
            "title": "Viimeinen tarkastus",
            "year": "Vuosi",
            "month": "Kuukausi",
            "notInspected": "Ei tarkastettu"
          }
        },
        "stepVehicleCondition": {
          "stepTitle": "Ajoneuvon kunto",
          "stepHeading": "Ajoneuvon kunto"
        },
        "stepDamages": {
          "stepTitle": "Ajoneuvon mahdolliset vauriot",
          "labelDamageFreeText": "Esim. pyyhkijät ei toimi, vesipumppu on rikki, lattialämmitys ei toimi",
          "smokedInQuestion": "Onko ajoneuvossa tupakoitu?",
          "smokedInYes": "Kyllä",
          "smokedInNo": "Ei"
        },
        "stepAccessories": {
          "stepTitle": "Ajoneuvon varusteet",
          "modelDesignationLabel": "Mallitarkenteet",
          "modelDesignationSubtitle": "Mitä vaunun kyljessä lukee (ehkä)",
          "accessoriesTitle": "Varusteet",
          "accessories": "Varusteet",
          "caravanAccessoriesSectionTitle": "Asuinvaunuvarusteet",
          "additionalAccessoriesSubtitle": "Voit halutessasi täydentää ajoneuvosi lisävarusteita",
          "labelAccessoriesExamples": "Esim. Alde lämmönvaihdin, Mover, Invertteri, Li-Ion -akku",
          "accessoryQuestion": "Onko ajoneuvossasi lisäksi jotain näistä lisävarusteista",
          "trimLevelSubtitle": "Kirjoita ajoneuvosi varustelutason nimi. Jos et tiedä varustelutasoa, jätä tämä kohta tyhjäksi.",
          "preselectedNote": "Seuraavat varusteet on tunnistettu automaattisesti ajoneuvostasi:"
        },
        "stepMedia": {
          "stepTitle": "Ajoneuvon kuvat",
          "titleFrontAngle": "Etuviisto",
          "titleSide": "Sivulta",
          "titleBackAngle": "Takaviisto",
          "titleInteriorFromEntrance": "Ovensuu sisätiloista",
          "titleTowardsCabin": "Hyttiä kohti",
          "titleFromDriverArea": "Ohjaamosta",
          "titleSofaGroup": "Sohvaryhmä/Pöytäryhmä",
          "titleFromKitchen": "Keittiöstä",
          "titleToiletShower": "Vessa/suihku",
          "titleBunkBeds": "Sänky",
          "titleMoistMeasurement": "Kosteusmittaus"
        },
        "stepFreeDescription": {
          "stepTitle": "Ajoneuvon vapaa kuvaus",
          "stepHeading": "Vapaa kuvaus ajoneuvosta",
          "stepSubtitle": "Voit kirjoittaa ajoneuvostasi vapaamuotoisen kuvauksen myynti-ilmoitustasi varten."
        },
        "stepDelivery": {
          "stepTitle": "Ajoneuvon toimitus",
          "stepHeading": "Yhteystiedot ja toimitus",
          "chooseDistance": "Valitse etäisyys, johon asti olet valmis toimittamaan ajoneuvosi.",
          "labelDeliveryWanted": "Haluan ajoneuvolleni noudon",
          "stepAdditionalInfo": "Huom. mikäli olet valmis toimittamaan ajoneuvosi itse, saat todennäköisesti ajoneuvollesi paremman hinnan.",
          "targetPrice": "Tavoitehinta",
          "vatDeductible": "ALV-vähennyskelpoinen",
          "targetPriceTooHigh": "Tavoitehinta on liian suuri"
        },
        "stepPriceEstimate": {
          "stepTitle": "Ajoneuvon arviohinta",
          "stepHeading": "Hinta-arvio",
          "labelAccessories": "Lisävarusteet",
          "notFoundSubtitle": "Valitettavasti emme pysty antamaan ajoneuvollesi luotettavaa hinta-arviota. Voit kuitenkin antaa ajoneuvollesi tavoitehinnan. Kilpailutuksesta saamasi tarjoukset vastaavat ajoneuvosi tämän hetkistä markkinahintaa.",
          "targetPriceInfo": "Kerro seuraavaksi hinta, jolla olisit valmis myymään ajoneuvosi. Huomaathan, että liian korkea tavoitehinta voi vähentää autoliikkeiden kiinnostusta ajoneuvostasi. ",
          "checkTargetPriceError": "Tarkista tavoitehinta",
          "targetPriceTooHigh": "Tavoitehinta on liian suuri",
          "fetchingPrice": "Haetaan hinta-arviota ajoneuvostasi...",
          "giveMakeAndModel": "Anna vielä ajoneuvosi merkki ja malli",
          "makeAndModelSelectionDesc": "Hakutuloksissamme löytyi useita lähes samankaltaisia malleja. Varmistathan vielä ajoneuvosi tarkan mallin tästä.",
          "estimateNotFound": "Hinta-arviota ei löytynyt",
          "estimateDescription": "Hinta-arvio perustuu ajoneuvosi merkkiin, malliin, vuosimalliin ja ajokilometreihin.",
          "estimateAdditionalInfo": "Huom! Kehitämme hinta-arviotyökalua. Joissain tapauksissa hinta-arvio voi näyttää jopa reilusti ylä- tai alakanttiin. Kilpailuttamalla myynnin Baanassa saat aidosti sen hinnan, jonka autoliikkeet enimmillään ajoneuvostasi tällä hetkellä maksavat.",
          "estimateBulletsInfo": "Ajoneuvon ostohintaan vaikuttavat myös seuraavat asiat:",
          "labelTyreHealth": "Renkaiden kunto",
          "maintenanceHistory": "Huoltokirjan tarkkuus ja historiatiedot",
          "paintCondition": "Maalipinnan kunto ja mahdolliset naarmut",
          "windshieldCondition": "Tuulilasin kunto ja mahdolliset viat",
          "vatDeductible": "ALV-vähennyskelpoinen"
        },
        "stepSummary": {
          "stepTitle": "Ajoneuvon yhteenveto",
          "stepHeading": "Myynti-ilmoitus",
          "possibleDamages": "Mahdolliset vauriot",
          "deliveryDistance": "Etäisyys, johon asti olet valmis toimittamaan ajoneuvosi",
          "ownership": "Ajoneuvon omistajuus",
          "trimLevel": "Ajoneuvon varustelutaso",
          "carDelivery": "Ajoneuvon toimittaminen kauppojen jälkeen",
          "checkInfo": "Tarkista vielä, että tiedot ovat oikein. Sitten voit julkaista ilmoituksen!",
          "descriptionNotProvided": "(kuvausta ei annettu)",
          "deliveryPickup": "Ajoneuvo on noudettava",
          "additionalAccessories": "Onko ajoneuvossasi lisäksi jotain näistä lisävarusteista?",
          "vehicleDetailsTitle": "Ajoneuvon tekniset tiedot",
          "caravanType": "Ajoneuvon tyyppi"
        }
      },
      "stepAccessories": {
        "accessoriesTitle": "Autosi varustelutaso",
        "accessoryQuestion": "Onko autossasi lisäksi jotain näistä lisävarusteista",
        "additionalAccessoriesSubtitle": "Voit halutessasi täydentää autosi lisävarusteita",
        "automaticAc": "Automaattinen ilmastointi",
        "blockHeater": "Lohkolämmitin",
        "cruiseControl": "Vakionopeudensäädin",
        "adaptiveCruiseControl": "Mukautuva vakionopeudensäädin",
        "electricAdjustedSeating": "Sähkösäätöiset istuimet",
        "gasHeater": "Polttoainekäyttöinen lisälämmitin",
        "hitch": "Vetokoukku",
        "keylessIgnition": "Avaimeton käynnistys",
        "labelAccessoriesExamples": "Esim. Kaistavahti, kevytmetallivanteet, lämmitettävä ohjauspyörä",
        "labelTrimLevel": "Varustetaso. esim. Classic, Elegance, Business",
        "leatherInterior": "Nahkaverhoilu",
        "metalColour": "Metalliväri",
        "navigator": "Navigointi",
        "parkingSensor": "Pysäköintitutka",
        "reversingCamera": "Peruutuskamera",
        "trimLevelSubtitle": "Kirjoita autosi varustelutason nimi. Jos et tiedä varustelutasoa, jätä tämä kohta tyhjäksi.",
        "preselectedNote": "Seuraavat varusteet on tunnistettu automaattisesti ajoneuvostasi:",
        "preselectedAccessories": "Tunnistetut varusteet",
        "accessories": "Varusteet"
      },
      "stepBasicInfo": {
        "amountOfKeys": "Auton avainten määrä",
        "incompleteMaintenanceBook": "Voit tarkentaa puutteita huoltokirjasta",
        "lastMaintenanceKms": "Täytä vielä viimeisimmän huollon kilometrimäärä",
        "lastMaintenanceMonth": "Täytä vielä viimeisimmän huollon kuukausi",
        "lastMaintenanceTitle": "Viimeisen huollon mittarilukema",
        "lastMaintenanceYear": "Täytä vielä viimeisimmän huollon vuosi",
        "lastMaintenanceUnknown": "Tämä tieto vaikuttaa merkittävästi siihen, kuinka paljon ostaja on valmis tarjoamaan autostasi. Oletko varma, ettet halua syöttää sitä?",
        "lastMaintenanceLabel": "Viimeisen huollon vuosi ja kuukausi",
        "unknownLabel": "Ei tiedossa",
        "maintenanceBook": "Kuinka kattava auton huoltokirja on?",
        "stepTitle": "Auton perustiedot",
        "lastMaintenanceKmsTooHigh": "Kilometrimäärä pitää olla pienempi kuin ajokilometrit: {{mileage}}",
        "clearMaintenance": "Tyhjennä huolto",
        "stepHeading": "Auton perustietoja",
        "vehicleOwnershipSelf": "Omistan auton itse",
        "vehicleOwnerShipOther": "Teen ilmoituksen toisen puolesta",
        "vehicleOwnershipFinanceCompany": "Auton omistaa rahoitusyhtiö",
        "vehicleOwnershipBusiness": "Yritys omistaa ajoneuvon",
        "amounOfKeysOne": "Yksi",
        "amountOfKeysTwoOrMore": "Kaksi tai useampi",
        "maintenanceBookPerfectBrand": "Täydellinen merkkihuoltokirja",
        "maintenanceBookPerfect": "Täydellinen huoltokirja",
        "maintenanceBookIncomplete": "Puutteellinen huoltokirja",
        "maintenanceBookNone": "Ei ole",
        "lastInspection": {
          "title": "Viimeisin katsastuspäivä",
          "notInspected": "Ei katsastettu",
          "year": "Katsastusvuosi",
          "month": "Katsastuskuukausi"
        }
      },
      "stepDamages": {
        "additionalInfo": "Voit tarkentaa tietoja tai kertoa jostain muusta vauriosta alle. Palvelu pyytää myös lisäämään kuvan listaamistasi asioista.",
        "labelDamageFreeText": "Esim. takapenkin päällysteet revenneet.",
        "paintDamage": "Maalipinnan vaurio",
        "stepTitle": "Onko autossasi lisäksi jotain näistä vaurioista?"
      },
      "stepDelivery": {
        "chooseDistance": "Valitse etäisyys, johon asti olet valmis toimittamaan autosi.",
        "labelDeliveryWanted": "Haluan autolleni noudon",
        "stepAdditionalInfo": "Huom. mikäli olet valmis toimittamaan autosi itse, saat todennäköisesti autollesi paremman hinnan.",
        "stepHeading": "Yhteystiedot ja toimitus",
        "businessSection": "Yritystiedot",
        "officialName": "Virallinen nimi",
        "businessRegistryNumber": "Y-tunnus",
        "vatNumber": "ALV-numero",
        "tinIssuingCountry": "Rekisteröintimaa",
        "addressStreet": "Katuosoite",
        "addressPostalCode": "Postinumero",
        "addressCity": "Kaupunki",
        "vehicleLocationSection": "Ajoneuvon sijainti",
        "vehicleLocationDescription": "Valitse myyntipaikan osoite tai syötä muu sijainti.",
        "vehicleLocationCompany": "Ajoneuvo on yrityksen osoitteessa",
        "vehicleLocationCompanyChip": "Yrityksen osoite",
        "vehicleLocationCompanyDisabled": "Täytä yrityksen tiedot yllä ottaaksesi tämän vaihtoehdon käyttöön",
        "vehicleLocationOtherTitle": "Muu sijainti",
        "vehicleLocationOtherDescription": "Syötä eri osoite tähän ilmoitukseen",
        "validation": {
          "invalidYTunnus": "Tarkista Y-tunnus",
          "invalidBusinessRegistryNumber": "Tarkista yrityksen rekisterinumero",
          "officialNameRequired": "Syötä yrityksen nimi",
          "businessRegistryNumberRequired": "Syötä Y-tunnus",
          "tinIssuingCountryRequired": "Syötä rekisteröintimaa",
          "addressStreetRequired": "Syötä katuosoite",
          "addressCityRequired": "Syötä kaupunki",
          "vehicleStreetRequired": "Syötä katuosoite",
          "vehicleCityRequired": "Syötä kaupunki"
        }
      },
      "stepFinished": {
        "buyersAllowedToBidCar": "Liikeet voivat nyt tehdä tarjouksia autostasi",
        "buyersAllowedToBidMoto": "Liikkeet voivat nyt tehdä tarjouksia motostasi",
        "buyersAllowedToBidCaravan": "Liikkeet voivat nyt tehdä tarjouksia ajoneuvostasi",
        "labelPostSuccesful": "Ilmoituksesi on nyt julkaistu!",
        "acquisitionSurveyTitle": "Miten sait tietää Baanasta?",
        "acquisitionSurveyOptions": {
          "google": "Googlesta",
          "socialMedia": "Sosiaalisesta mediasta (esim. Tiktok, YouTube, Instagram, Facebook)",
          "nettiauto": "Nettiautosta",
          "bannerAd": "Näin bannerimainoksen",
          "tvAd": "Näin TV -mainoksen",
          "radioAd": "Kuulin radiomainoksen",
          "article": "Artikkelin tai uutisen kautta",
          "friend": "Kuulin kaverilta, perheenjäseneltä tai tutulta",
          "other": "Jokin muu"
        },
        "acquisitionSurveyOtherPlaceholder": "Kerro meille...",
        "acquisitionSurveyThankYou": "Kiitos vastauksestasi ja onnea myyntiin!",
        "submitAndShowAuction": "Lähetä ja näytä ilmoitus",
        "beelyLinkTitle": "Palaa Beelyyn"
      },
      "stepFreeDescription": {
        "labelFreeDescription": "Avoin kuvaus",
        "stepSubtitle": "Voit kirjoittaa autostasi vapaamuotoisen kuvauksen myynti-ilmoitustasi varten.",
        "stepTitle": "Oma kuvauksesi autosta",
        "stepHeading": "Vapaa kuvaus autosta"
      },
      "stepMedia": {
        "bulletListTitle": "Pakollisia kuvia ovat:",
        "helpText": "Jos ajoneuvossasi on mainitsemisen arvoisia naarmuja, vaurioita tai puutteita, näistä on hyvä myös ottaa kuvat.",
        "damageDescriptionTitle": "Vaurioiden kuvaus",
        "damageDetailsTitle": "Kerroit, että autossasi on seuraavia vaurioita:",
        "damagePictures": "Vaurioiden kuvat",
        "damagePicturesSubtitle": "Suosittelemme, että lisäät vähintään yhden kuvan mainitsemistasi vaurioista. Jos lisäät tarkat kuvat vaurioista tai vioista, myyt ajoneuvosi jopa 2,5 kertaa todennäköisemmin.  ",
        "labelAddPhoto": "Lisää kuva",
        "labelDamagePhoto": "Kuva vauriosta",
        "labelInterior": "Sisätilat",
        "labelTrunk": "Tavaratila",
        "labelTyres": "Renkaat",
        "perspectiveBack": "Kuva takaa",
        "perspectiveBackAngle": "Kuva takaviistosta",
        "perspectiveDashboard": "Kuva kojelaudasta auto käynnissä",
        "perspectiveFront": "Kuva edestä",
        "perspectiveFrontAngle": "Kuva etuviistosta",
        "perspectiveFrontSeat": "Kuva etuistuimesta",
        "perspectiveSide": "Kuva sivusta",
        "photoTakingTips": "Pakollisten kuvien lisäksi suosittelemme lisäämään kuvat myös seuraavista:",
        "stepDescription": "Huomaathan, että autoliikkeet arvostavat varsinkin kuvia huoltokirjasta ja istuinten kunnosta. ",
        "processingImages": "Prosessoidaan kuvia...",
        "stepTitle": "Auton kuvat",
        "requiredPhotosMissingError": "Lisää kaikki pakolliset kuvat",
        "imageTooBigError": "Kuva on liian iso. Maksimikoko on 15Mt.",
        "imageTooLowQuality": "Lisäämäsi kuva on heikkolaatuinen. Suosittelemme käyttämään riittävän laadukkaita kuvia, jotta ostajat saavat niiden perusteella muodostettua oikean kuvan autostasi.",
        "unsupportedMediaType": "Palvelumme ei valitettavasti tue valitsemasi kuvan tiedostotyyppiä.",
        "damageReminderTitle": "Valitsit aikaisemmin seuraavat vauriot:",
        "multipleUploadInfo": "Voit lisätä useita kuvia kerralla.",
        "generalImages": "Yleiskuvat",
        "requiredPhoto": "(*Pakollinen)",
        "recommendedPhoto": "(Suositeltu)",
        "minimumImages_one": "Vielä {{count}} yleiskuva vaaditaan",
        "minimumImages_other": "Vielä {{count}} yleiskuvaa vaaditaan",
        "requiredImages": "Kuvat vaaditaan",
        "requiredPhotoCount": "Pakollisten kuvien määrä: väh. {{count}}",
        "remainingPhoto": "Lisää vielä yksi kuva",
        "remainingPhotosNeeded": "Lisää vielä {{count}} kuvaa",
        "allRequiredPhotosAdded": "Pakolliset yleiskuvat lisätty",
        "allRequiredDamagePhotosAdded": "Pakolliset vauriokuvat lisätty",
        "allRequiredPhotosAddedContinuation": "Voit täydentää ilmoitusta lisäkuvilla",
        "uploadingImages": "Ladataan kuvia...",
        "uploadProgress": "{{uploaded}} / {{total}} kuvaa ladattu",
        "aisaProcessingSingle": "Viimeistellään kuvan käsittelyä",
        "aisaProcessingMultiple": "Viimeistellään kuvien käsittelyä",
        "doNotRefreshWarning": "Odota, että kaikki kuvat on käsitelty",
        "damageSectionTitle": "Vauriot",
        "otherImagesSectionTitle": "Muut kuvat",
        "otherImagesSectionExamples": "Lisää esim. nämä kuvat:",
        "labelMainPhoto": "Etuviistosta",
        "minimumDamageImages_one": "Vielä {{count}} vauriokuva vaaditaan",
        "minimumDamageImages_other": "Vielä {{count}} vauriokuvaa vaaditaan",
        "requiredDamageImages": "Vauriokuvat vaaditaan",
        "titleFrontAngle": "Etuviistosta (Pääkuva)",
        "titleSide": "Sivulta",
        "titleFront": "Edestä",
        "titleBackAngle": "Takaviistosta",
        "titleBack": "Takaa",
        "titleFrontSeat": "Etuistuimesta",
        "titleDashboard": "Kojelauta (Käynnissä)",
        "titleMaintenanceBook": "Huoltokirja",
        "titleTires": "Renkaat",
        "titleTrunk": "Tavaratila",
        "titleInterior": "Sisätilat",
        "titleDamages": "Vauriot",
        "brokenImagesWarning": "{{count}} kuvan lataus epäonnistui. Poista lataamattomat kuvat, niin pääset siirtymään seuraavaan vaiheeseen.",
        "brokenImageAutoRemoved": "1 lataamaton kuva poistettiin automaattisesti.",
        "brokenImagesAutoRemoved": "{{count}} lataamatonta kuvaa poistettiin automaattisesti.",
        "refreshWarning": "Haluatko varmasti päivittää sivun? Kuvien lataus tai käsittely on kesken.",
        "imagesProcessing": "Odota, kuvia käsitellään...",
        "cancelUploads": "Peruuta lataus",
        "cancelingUploads": "Perutaan kuvien lataus",
        "uploadsCancelled": "{{count}} kuvan lataus on peruttu.",
        "uploadsCancelledWithKept": "{{cancelled}} kuvan lataus on peruttu. {{kept}} onnistuneesti ladattua kuvaa säilytettiin.",
        "allImagesProcessed": "Kaikki kuvat on käsitelty, ei peruttavia kuvia.",
        "showExamples": "Näytä esimerkkikuvat",
        "hideExamples": "Piilota esimerkit",
        "uploadsInProgress": "Kuvien lataus on kesken",
        "aisaProcessing": "Kuvia käsitellään, odota hetki",
        "kuntoraportti": {
          "title": "A-Katsastus kuntotutkimusraportti",
          "toggleLabel": "Näytä raportti ilmoituksessa",
          "included": "Raportti lisätty ilmoitukseen",
          "previewLabel": "Näytä raportti",
          "previewError": "Raportin avaaminen epäonnistui"
        }
      },
      "carousel": {
        "imageNotAvailable": "Kuva ei saatavilla",
        "imageProcessing": "Kuvaa käsitellään...",
        "loadingImage": "Ladataan kuvaa...",
        "imageDetailsMissing": "Kuvan tiedot puuttuvat",
        "takesMoment": "Tämä voi kestää hetken",
        "waitMoment": "Odota hetki",
        "tryAgain": "Yritä uudelleen tai käy lataamassa kuvat uudelleen",
        "openLightbox": "Avaa kuva valokuvatilassa",
        "openLightboxWithIndex": "Avaa kuva {{index}}/{{total}} valokuvatilassa"
      },
      "stepOwnerInfo": {
        "labelBatteryCapacity": "Akkukapasiteetti",
        "labelBrand": "Merkki",
        "labelCarInfo": "Auton tiedot",
        "labelContactInfo": "Yhteyshenkilön yhteystiedot",
        "labelEngineSize": "Moottoritilavuus",
        "firstRegistrationYear": "Käyttöönottovuosi",
        "personsCount": "Henkilömäärä",
        "labelRegNo": "Rekisteritunnus",
        "mileage": "Ajokilometrit",
        "model": "Malli",
        "modelYear": "Vuosimalli",
        "modelTypeName": "Mallityyppi",
        "stepSubtitle": "Tarkistathan, että esitäytetyt tiedot pitävät paikkansa",
        "stepSubtitleNew": "Tarkista, että auton tiedot ovat oikein.",
        "stepTitle": "Auton ja yhteyshenkilön tiedot",
        "stepTitleNew": "Auton tiedot",
        "checkMunicipality": "Tarkista paikkakunta",
        "enterMunicipality": "Syötä paikkakunta",
        "checkModelYearFormat": "Anna vuosimalli oikeassa muodossa",
        "checkPhoneNumberFormat": "Anna puhelinnumero oikeassa muodossa",
        "checkPhoneNumber": "Tarkista puhelinnumero",
        "enterPhoneNumber": "Syötä puhelinnumero",
        "checkPostalCode": "Tarkista postinumero",
        "enterPostalCode": "Syötä postinumero",
        "alreadyExistError": "Toisella Baanan käyttäjällä on jo ilmoitus kyseisestä ajoneuvosta. Jos tämä on mielestäsi virhe niin ota yhteyttä asiakaspalveluumme.",
        "youAlreadyHaveAuction": "Sinulla on keskeneräinen kilpailutusluonnos. Haluatko jatkaa luonnosta vai aloittaa uuden?",
        "errorMessage": {
          "checkMake": "Anna auton merkki.",
          "checkModel": "Anna auton malli.",
          "checkFuelType": "Anna auton polttoainetyyppi.",
          "checkDriveType": "Anna auton vetotapa.",
          "checkGearType": "Anna auton vaihteistotyyppi.",
          "checkModelTypeName": "Anna auton mallityypin.",
          "checkModelYear": "Anna auton vuosimalli.",
          "checkTargetPrice": "Tarkista tavoitehinta.",
          "checkStreetAddress": "Tarkista osoite",
          "enterStreetAddress": "Syötä osoite",
          "checkCountry": "Tarkista maa",
          "enterCountry": "Syötä maa",
          "checkBatteryCapacity": "Anna akkukapasiteetti.",
          "batteryCapacityTooHigh": "Akkukapasiteetti on liian suuri (max 1000 kWh).",
          "checkFirstRegistrationYear": "Käyttöönottovuoden tulee olla sama tai uudempi kuin vuosimalli."
        }
      },
      "stepPriceEstimate": {
        "checkTargetPriceError": "Tarkista tavoitehinta",
        "targetPriceTooHigh": "Tavoitehinta on liian suuri",
        "estimateAdditionalInfo": "Huom! Kehitämme hinta-arviotyökalua. Joissain tapauksissa hinta-arvio voi näyttää jopa reilusti ylä- tai alakanttiin. Kilpailuttamalla myynnin Baanassa saat aidosti sen hinnan, jonka autoliikkeet enimmillään autostasi tällä hetkellä maksavat.",
        "estimateBulletsInfo": "Auton ostohintaan vaikuttavat myös seuraavat asiat:",
        "estimateDescription": "Huom! Kehitämme hinta-arviotyökalua parhaillaan. Joissain tapauksissa hinta-arvio voi näyttää jopa reilusti ylä- tai alakanttiin.",
        "estimateNotFound": "Aseta oma tavoitehintasi",
        "fetchingPrice": "Haetaan hinta-arviota autostasi...",
        "giveMakeAndModel": "Anna vielä autosi merkki ja malli",
        "labelAccessories": "Lisävarusteet",
        "labelTyreHealth": "Renkaiden kunto",
        "maintenanceHistory": "Huoltokirjan tarkkuus ja historiatiedot",
        "makeAndModelSelectionDesc": "Hakutuloksissamme löytyi useita lähes samankaltaisia malleja. Varmistathan vielä autosi tarkan mallin tästä.",
        "notFoundSubtitle": "Autolle ei löydy tarpeeksi vertailutietoa luotettavan arvion pohjaksi. Voit silti asettaa oman tavoitehinnan ja kilpailuttaa auton. Autoliikkeet tekevät tarjouksen markkinatilanteen mukaan.",
        "paintCondition": "Maalipinnan kunto ja mahdolliset naarmut",
        "priceFactorsTitle": "Mikä vaikuttaa hintaan?",
        "stepTitle": "Hinta-arvio autollesi",
        "targetPriceInfo": "Kerro seuraavaksi hinta, jolla olisit valmis myymään autosi. Huomaathan, että liian korkea tavoitehinta voi vähentää autoliikkeiden kiinnostusta autostasi. ",
        "windshieldCondition": "Tuulilasin kunto ja mahdolliset viat",
        "stepHeading": "Hinta-arvio",
        "vatDeductible": "ALV-vähennyskelpoinen"
      },
      "stepRegno": {
        "labelRegnoExample": "Rekisteritunnus (ABC-123)",
        "orGiveBasicInfo": "TAI anna auton perustiedot",
        "notFoundError": "Valitettavasti antamallasi rekisterinumerolla ei löytynyt auton tietoja, täytä tiedot manuaalisesti.",
        "vehicleTooOldError": "Valittavasti kyseinen auto on liian vanha myytäväksi Baanalla",
        "licenseFormatError": "Tarkista rekisteritunnuksen muoto",
        "licenseMissingError": "Tarkista rekisteritunnus",
        "checkMileageError": "Tarkista ajokilometrit",
        "mileageZeroError": "Ajokilometrien on oltava suurempi kuin 0",
        "mileageOverError": "Voit kilpailuttaa vain alle 250 000 km ajettuja autoja.",
        "vehicleAgeCheckError": "Auton ikää ei voitu varmistaa",
        "youAlreadyHaveAuction": "Sinulla on jo kilpailutus tällä rekisterinumerolla. Voit muokata olemassa olevaa kilpailutusta omista kilpailutuksistasi.",
        "regnoAlreadyInUse": "Tämä rekisterinumero on jo käytössä toisessa kilpailutuksessa.",
        "kuntoraporttiAvailable": "Rekisterinumerolla löytyy A-Katsastuksen kuntotutkimusraportti. Näet sen kohdassa 7/11."
      },
      "stepSummary": {
        "businessContactMissing": "Täydennä yrityksen tiedot ennen julkaisua.",
        "additionalAccessories": "Onko autossasi lisäksi jotain näistä lisävarusteista?",
        "carDelivery": "Auton toimittaminen kauppojen jälkeen",
        "checkInfo": "Tarkista vielä, että tiedot ovat oikein. Sitten voit julkaista ilmoituksen!",
        "deliveryDistance": "Etäisyys, johon asti olet valmis toimittamaan autosi",
        "descriptionNotProvided": "(kuvausta ei annettu)",
        "labelEditMileage": "Muokkaa kilometrejä",
        "ownership": "Auton omistajuus",
        "possibleDamages": "Mahdolliset vauriot",
        "stepTitle": "Myynti-ilmoituksen yhteenveto",
        "trimLevel": "Auton varustelutaso",
        "deliveryPickup": "Auto on noudettava",
        "stepHeading": "Myynti-ilmoitus",
        "editTargetPrice": "Muokkaa tavoitehintaa",
        "mileageUnit": {
          "km": "km"
        },
        "publishConfirmation": {
          "modalTitle": "Vahvista julkaisu ja kesto",
          "beelyModalTitle": "Vahvista julkaisu",
          "areYouSure": "Oletko varma, että haluat julkaista ilmoituksen?",
          "cannotEditAfterPublish": "Julkaisun jälkeen ilmoitusta ei voi enää muokata.",
          "durationTitle": "Milloin haluat kilpailutuksen päättyvän?",
          "quickOption": "Pikakilpailutus",
          "normalOption": "Normaali (suositus)",
          "oneDayOption": "Seuraavana arkipäivänä (24 tuntia)",
          "twoDaysOption": "2 arkipäivän kuluttua (48 tuntia)",
          "sameDayOption": "Tänään (päättyy klo 14-17)",
          "estimatedEndTime": "Arvioitu päättymisaika",
          "normalOptionInfo": "Päättyy noin kahden arkipäivän kuluttua. Tarkka aika näkyy julkaisun jälkeen.",
          "sameDayHint": "Ennen klo 10:00 luotu kilpailutus päättyy samana päivänä (klo 14-17), muussa tapauksessa seuraavana arkipäivänä."
        },
        "errors": {
          "mileageRequired": "Kilometrilukema on pakollinen ja sen on oltava suurempi kuin 0",
          "mileageTooHigh": "Kilometrilukema ylittää sallitun rajan",
          "mileageLowerThanCurrent": "Uusi kilometrilukema ei voi olla pienempi kuin viimeisimmän huollon kilometrit",
          "targetPriceRequired": "Tavoitehinta on pakollinen ja sen on oltava suurempi kuin 0",
          "targetPriceTooHigh": "Tavoitehinta on liian suuri"
        }
      },
      "stepVehicleCondition": {
        "provideWindshieldInfo": "Voit tarkentaa tietoja tuulilasin kunnosta alle",
        "summerTyreCondition": "Kesärenkaiden kunto",
        "summerTyreRims": "Kesärenkaiden vanteet",
        "windshieldCondition": "Tuulilasin kunto",
        "windshieldInsurance": "Minulla on tuulilasivakuutus",
        "winterTyreCondition": "Talvirenkaiden kunto",
        "winterTyreRims": "Talvirenkaiden vanteet",
        "stepHeading": "Tiedot auton kunnosta",
        "tireWearNew": "Uudenveroiset",
        "tireWearGood": "Hyvät",
        "tireWearFair": "Kohtalaiset",
        "tireWearBad": "Huonot",
        "tireWearNone": "Ei ole",
        "timingSystemAttentionText": "Voit halutessasi syöttää viimeisen kilometrimäärän, jolloin jakopää on vaihdettu. Tämä tieto auttaa ostajia arvioimaan auton kuntoa ja huoltotarpeita.",
        "timingSystemInfo": "Jakopään tyyppi",
        "timingSystem": "Jakopää",
        "timingSystemChanged": "Jakopään vaihtoaika",
        "timingSystemBelt": "Hihna (alkuperäinen)",
        "timingSystemBeltChanged": "Hihna (vaihdettu)",
        "timingSystemChain": "Ketju (alkuperäinen)",
        "timingSystemChainChanged": "Ketju (vaihdettu)",
        "timingSystemUnknown": "Ei tiedossa",
        "mileage": "Kilometrimäärä",
        "mileageError": "Syötetty luku on suurempi kuin ajokilometrit",
        "rimsHas": "On",
        "rimsHasNone": "Ei ole",
        "windshieldConditionGood": "Hyvä",
        "windshieldConditionWornOut": "Kulunut",
        "windshieldConditionStoneMark": "Kiveniskemä",
        "windshieldConditionCracked": "Halkeama"
      }
    },
    "emailNotifications": {
      "consumerAuctionEnded": "Kilpailutus päättyi",
      "consumerNewNegotiationMessage": "Uusi neuvotteluviesti",
      "consumerQuestionAsked": "Kysymys esitetty",
      "consumerAuctionStarted": "Kilpailutus alkoi",
      "consumer15minWarning": "15 min kilpailutuksen päättymiseen",
      "consumerFirstBidNotification": "Ensimmäinen tarjous",
      "consumerDealerRaisedBid": "Ostaja korotti tarjousta"
    },
    "marketingEmailNotifications": {
      "googleReviewEmails": "Google-arvostelupyynnöt",
      "draftReminderEmails": "Luonnos-muistutukset"
    },
    "smsNotifications": {
      "consumerAuctionEnded": "Kilpailutus päättyi",
      "consumerTargetPriceReached": "Tavoitehinta saavutettu",
      "consumerNewNegotiationMessage": "Uusi neuvotteluviesti",
      "consumerQuestionAsked": "Kysymys esitetty",
      "consumer4HourWarning": "4 tuntia aikaa hyväksyä tarjous",
      "consumerDealerRaisedBid": "Ostaja korotti tarjousta",
      "consumerFinalOfferReceived": "Viimeinen tarjous vastaanotettu"
    },
    "settingsPage": {
      "title": "Käyttäjäasetukset",
      "addressTitle": "Osoitetiedot",
      "notificationSettings": "Ilmoitusasetukset",
      "sms": "Tekstiviestit",
      "email": "Sähköposti",
      "updateSuccess": "Päivitys onnistui",
      "updateFail": "Päivitys epäonnistui",
      "phoneNumber": "Puhelinnumero",
      "taxIdentificationNumber": "Henkilötunnus",
      "checkPhoneNumberFormat": "Anna puhelinnumero oikeassa muodossa",
      "checkIdentificationTaxNumberFormat": "Anna henkilötunnus oikeassa muodossa",
      "countryCode": "Maakoodi",
      "emailMessage": "Sähköpostiosoite ei ole muokattavissa",
      "marketingEmails": "Markkinointiviestit"
    },
    "unsubscribe": {
      "title": "Peruuta viestien tilaus",
      "loading": "Ladataan...",
      "greeting": "Hei {{name}}!",
      "confirmationText": "Haluatko peruuttaa seuraavien viestien tilauksen: {{emailType}}?",
      "unsubscribeButton": "Peruuta tilaus",
      "processing": "Käsitellään...",
      "successMessage": "Tilaus peruutettu onnistuneesti!",
      "successDescription": "Olet peruuttanut viestien tilauksen. Voit tilata viestit uudelleen käyttäjäasetuksistasi.",
      "returnToHome": "Siirry etusivulle",
      "managePreferences": "Hallinnoi asetuksia",
      "managePreferencesInfo": "Voit myös hallita kaikkia viestiasetuksiasi käyttäjäasetuksissa.",
      "invalidToken": "Virheellinen tai vanhentunut linkki.",
      "error": "Tapahtui virhe. Yritä myöhemmin uudelleen.",
      "networkError": "Verkkoyhteysvirhe. Tarkista internetyhteytesi ja yritä uudelleen.",
      "emailTypes": {
        "googleReview": "Google-arvostelupyynnöt",
        "draftReminders": "Luonnosmuistutukset"
      }
    },
    "pageTitle": {
      "contactInfo": "Yhteystiedot",
      "home": "Etusivu",
      "blog": "Artikkelit",
      "faq": "Usein kysytyt kysymykset"
    }
  },
  "dealer": {
    "bulkMarkAsSold": {
      "markAsComplete": "Merkitse toteutuneeksi",
      "acceptedDaysAgo": "Hyväksytty {{count}} pv sitten",
      "acceptedToday": "Hyväksytty tänään",
      "pageInstructions": "Merkitse kauppa toteutuneeksi, mikäli ajoneuvon luovutus on jo tehty."
    },
    "userActions": {
      "favourites": {
        "delete": "Poista {{regno}} suosikeista",
        "add": "Lisää {{regno}} suosikiksi",
        "deleted": "{{regno}} poistettu suosikeista",
        "added": "{{regno}} lisätty suosikkeihin",
        "error": "Suosikiksi lisääminen epäonnistui"
      },
      "hide": {
        "deleted": "{{regno}} palautettu näkyviin",
        "added": "{{regno}} piilotettu",
        "error": "Piilottaminen epäonnistui"
      }
    },
    "auctionDetailsPage": {
      "acceptedOffer": "Hyväksytty tarjous",
      "accessories": "Varustetiedot",
      "newVehicleRemarks": "Ilmoitukseen jälkikäteen lisätyt tiedot",
      "accessoriesList": "Varusteet",
      "vehicleAccessories": {
        "OUTLET_12V": "12V ulosotto",
        "SERVICE_BOOK": "Huoltokirja",
        "CRASH_BARS": "Kaatumaraudat",
        "HEATED_GRIPS": "Kahvanlämmittimet",
        "TRACTION_CONTROL": "Luistonesto",
        "ANTI_LOCK_BRAKES": "Lukkiutumattomat jarrut",
        "NAVIGATOR": "Navigaattori",
        "BACKREST": "Selkänoja",
        "SIDE_BAGS": "Sivulaukut",
        "ELECTRIC_START": "Sähkökäynnistys",
        "TOP_CASE": "Takalaukku",
        "CRUISE_CONTROL": "Vakionopeudensäädin",
        "ADAPTIVE_CRUISE_CONTROL": "Mukautuva vakionopeudensäädin",
        "STORAGE_BOXES": "Tavarakorit",
        "WINCH": "Vinssi",
        "SNOW_PLOW": "Lumiaura",
        "SKID_PLATE": "Pohjapanssari",
        "OFF_ROAD_TIRES": "Maastorenkaat",
        "LED_LIGHTS": "LED-valot",
        "POWER_STEERING": "Ohjaustehostin",
        "POWER_WINDOWS": "Sähkökäyttöiset ikkunat",
        "TOW_BAR": "Vetokoukku",
        "ALLOY_WHEELS": "Kevytmetallivanteet",
        "TWO_SETS_OF_TYRES": "Kahdet renkaat",
        "AIR_CONDITIONING_MANUAL": "Manuaalinen",
        "AIR_CONDITIONING_AUTOMATIC": "Automaattinen",
        "INTERIOR_SOCKET": "Sisätilanpistoke",
        "MOTOR_HEATER": "Lohkolämmitin / Moottorilämmitin",
        "LEATHER_UPHOLSTERY": "Nahkaverhoilu",
        "ABS_BRAKES": "Lukkiutumattomat jarrut (ABS)",
        "AIRBAG": "Turvatyynyt",
        "HUOLTOKIRJA_PAPER": "Paperinen",
        "HUOLTOKIRJA_ELECTRONIC": "Sähköinen",
        "SOUND_SYSTEM": "Äänentoistojärjestelmä",
        "IMMOBILIZER": "Käynnistyksenesto",
        "ALARM_SYSTEM": "Varashälytin",
        "SUNROOF_WITHOUT_PANORAMA": "Ilman panoraamaa",
        "SUNROOF_WITH_PANORAMA": "Panoraama",
        "ON_BOARD_COMPUTER": "Ajotietokone",
        "CRUISE_CONTROL_TRADITIONAL": "Perinteinen",
        "CRUISE_CONTROL_ADAPTIVE": "Mukautuva",
        "DRIVING_ASSISTANT": "Ajonvakautusjärjestelmä",
        "REVERSING_CAMERA_SIMPLE": "Kamera takana",
        "REVERSING_CAMERA_360": "360-asteen kamera",
        "CENTRAL_LOCKING_KEYLESS": "Avaimettomuus",
        "CENTRAL_LOCKING_REMOTE": "Kaukosäädin",
        "CENTRAL_LOCKING_WITH_KEY": "Avaimella",
        "ELECTRIC_SEATS_WITHOUT_MEMORY": "Ilman muistia",
        "ELECTRIC_SEATS_WITH_MEMORY": "Muistilla",
        "ROOF_OPENING_ELECTRONIC": "Sähköinen",
        "ROOF_OPENING_MANUAL": "Manuaalinen",
        "TOW_HITCH": "Vetokoukku",
        "LUGGAGE_RACK": "Tavarateline",
        "SMALL_TOP_CASE": "Pieni takalaukku",
        "CHAIN_GUARD": "Ketjusuoja",
        "USB_CHARGING_PORT": "USB-latauspistoke",
        "SEAT_COVER": "Istuinsuoja",
        "FOOT_GUARDS": "Jalkasuojat",
        "SEAT_BAG": "Istuinlaukku",
        "MIRRORS": "Peilit",
        "WEATHER_SHIELD": "Sääsuoja",
        "HAND_GUARDS": "Käsisuojat",
        "PHONE_MOUNT": "Puhelinteline",
        "STORAGE_BAGS": "Säilytyslaukut",
        "CARGO_RACKS": "Tavarakorit",
        "LED_HEADLIGHTS": "LED-ajovalot",
        "GPS_NAVIGATOR": "GPS-navigaattori",
        "DEEP_SNOW_TRACKS": "Syvälumitelat",
        "SNOW_ANCHORS": "Lumiankkurit",
        "BACK_SEAT": "Takapenkki",
        "CENTRAL_LOCKING": "Kaukosäätöinen keskuslukitus",
        "ELECTRIC_WINDOWS": "Sähköikkunat",
        "LEATHER_INTERIOR": "Nahkasisusta",
        "LED_DAYTIME_RUNNING_LIGHTS": "LED-päiväajovalot",
        "RADIO": "Radio",
        "REVERSING_CAMERA": "Peruutuskamera",
        "AIR_CONDITIONING_LIVING_AREA": "Ilmastointi asuinosassa",
        "GAS_STOVE": "Kaasu-uuni",
        "BUNK_BED": "Kerrossänky",
        "AWNING": "Markiisi",
        "DOUBLE_BED": "Parivuode",
        "SEPARATE_BEDS": "Erillisvuode",
        "ISLAND_BED": "Saarekevuode",
        "DROP_DOWN_BED": "Laskuvuode",
        "FRIDGE": "Jääkaappi",
        "ALDE_HEATING": "Alde (nestekiertolämmitys)",
        "TRUMATIC_HEATING": "Trumatic (ilma)",
        "SOLAR_PANELS": "Aurinkopaneelit",
        "INSULATED_GREY_WATER": "Eristetty harmaavesi",
        "FLOOR_HEATING": "Lattialämmitys",
        "BIKE_RACK": "Pyöräteline",
        "MAINS_ELECTRIC_HEATING": "Sähköpatruuna (Maasähkölämmitys)",
        "CABIN_AC": "Ilmastointi ajotilassa",
        "CASSETTE_WC": "Kasetti WC",
        "CASSETTE_CURTAINS": "Kasettiverhot",
        "CARPETS_IN_BACK": "Lattiamatot asunto-osassa",
        "CENTRAL_HEATING": "Keskuslämmitys",
        "FREEZER": "Pakastelokero",
        "HOT_WATER_TANK": "Lämminvesiboileri",
        "MICROWAVE_OVEN": "Mikroaaltouuni",
        "REAR_KITCHEN": "Takakeittiö",
        "SHOWER": "Suihku",
        "SINK": "Pesuallas",
        "ELECTRIC_STEP": "Sähkörappu",
        "STABILIZER": "Tukijalat",
        "SUN_ROOF": "Kattoluukku",
        "TV_ANTENNA_OR_SATELLITE_DISH": "TV-antenni tai lautasantenni",
        "FUEL_HEATER": "Polttoainekäyttöinen lisälämmitin",
        "GENERATOR": "Aggregaatti",
        "ROOF_BOX": "Kattoboxi",
        "DOUBLE_BOTTOM": "Tuplapohja",
        "FRONT_CANOPY": "Etukatos",
        "FRONT_TENT": "Etuteltta",
        "SERVICE_MANUAL": "Huoltokirja"
      },
      "additionalInfo": "Lisätietoja",
      "addNote": "Lisää muistiinpano",
      "addNoteModal": {
        "title": "Lisää muistiinpano",
        "enterMessage": "Kirjoita muistiinpano"
      },
      "auctionEndsAt": "Kilpailutus päättyy",
      "sellerTargetPrice": "Myyjän tavoitehinta",
      "basicInfo": "Auton perustiedot",
      "batteryCapacity": "Akkukapasiteetti",
      "engineSize": "Moottorin tilavuus",
      "vehicleBasicInfo": "Ajoneuvon perustiedot",
      "bidMachineActive": "Korotusautomaatti on päällä.",
      "bodyType": "Korityyppi",
      "condition": "Kunto",
      "containsPickup": "Tarjous sisältää noudon.",
      "pickupIncluded": "Tarjous sisältää noudon.",
      "pickupNotIncluded": "Tarjous ei sisällä noutoa.",
      "coolingSystem": "Jäähdytys",
      "damageExtent": {
        "CRACK": "Halkeama",
        "DENT": "Lommo",
        "FAULT_LIGHT": "Vikavalo",
        "PAINT": "Maalipintavaurio",
        "SCRATCH": "Naarmu",
        "UPHOLSTERY": "Verhoiluvaurio",
        "MOISTURE_DAMAGE": "Kosteusvaurio",
        "AIR_CONDITIONING": "Ilmastointivika",
        "ENGINE": "Moottori",
        "FUEL_SYSTEM": "Polttoainejärjestelmä",
        "ELECTRICAL_SYSTEM": "Sähköjärjestelmä",
        "TRANSMISSION_AND_CLUTCH": "Vaihteisto ja kytkin",
        "BRAKES": "Jarrut",
        "TIRES_AND_SUSPENSION": "Renkaat ja jousitus",
        "STEERING": "Ohjaus",
        "EXHAUST": "Pakoputkisto",
        "FAIRINGS": "Katteet",
        "TRACK": "Telat",
        "SUSPENSION_AND_CHASSIS": "Jousitus ja alusta",
        "COLD_START_PROBLEMS": "Kylmäkäynnistysongelmat",
        "FRAME": "Runko"
      },
      "damages": "Vauriot",
      "dealCompleted": "Kauppa toteutunut",
      "deleteNoteTitle": "Poista muistiinpano?",
      "delivery": "Myyjä on valmis toimittamaan auton.",
      "vehicleDelivery": "Myyjä on valmis toimittamaan ajoneuvon.",
      "deliveryLabel": "Toimitus / nouto",
      "deliveryWithRange": "Myyjä on valmis toimittamaan auton {{range}}km säteellä.",
      "vehicleDeliveryWithRange": "Myyjä on valmis toimittamaan ajoneuvon {{range}}km säteellä.",
      "description": "Kuvaus",
      "descriptionNotProvided": "-",
      "doorCount": "Ovien lukumäärä",
      "engine": "Moottori",
      "driveType": "Vetotapa",
      "editNote": "Muokkaa muistiinpanoa",
      "gearType": "Vaihteisto",
      "highestBid": "Korkein tarjous",
      "isSideBySide": "Rinnakkain istuttava",
      "keyCount": "Avainten lukumäärä",
      "lastMaintenanceLabel": "Edellinen huolto",
      "lastInspection": "Viimeisin katsastuspäivä",
      "location": "Sijainti ja etäisyys",
      "locationAndDelivery": "Sijainti ja toimitus",
      "maintenanceBook": {
        "INCOMPLETE": "Puutteellinen",
        "MAINTAINED_NOT_BY_PROGRAM": "Huollettu, ei ohjelman mukaan",
        "NONE": "Puuttuu",
        "PERFECT": "Täydellinen",
        "PERFECT_BRAND": "Täydellinen, merkkihuolto"
      },
      "maintenanceBookLabel": "Huoltokirja",
      "moistureMeasurementLabel": "Kosteusmittaus",
      "moistureMeasurementDate": "Kosteusmittauksen ajankohta",
      "moistureMeasurementPerformed": {
        "yes": "Kyllä",
        "no": "Ei"
      },
      "caravanType": "Ajoneuvon tyyppi",
      "makeAnOffer": "Tee tarjous",
      "markOfferAccepted": "Alustava kauppa",
      "markOfferAcceptedToolTip": "Voit sopia alustavat kaupat, jolloin kohde nousee hyväksyttyihin kohteisiin. Ajoneuvon luovutuksen yhteydessä voit vielä merkitä kaupan toteutuneeksi tai tarvittaessa perua sen.",
      "markDealAsComplete": "Merkitse kauppa toteutuneeksi",
      "mileage": "Mittarilukema",
      "mileageUnit": {
        "KM": "km",
        "H": "h"
      },
      "modelYear": "Vuosimalli | Ensirek.pvm",
      "myBid": "Oma tarjous",
      "ourBid": "Ostajaliikkeen tarjous",
      "myBidRanking": "Oman tarjouksen sijoitus",
      "numberOfBids": "Tarjousten määrä yhteensä",
      "negotiationMessageLimit": "Huomioithan, että keskustelun pituus on rajattu kymmeneen viestiin per osapuoli.",
      "negotiationMessageLimitReached": "Olet käyttänyt sinulle varatun viestimäärän. Mikäli keskustelu myyjän kanssa jäi pahasti kesken, ole hyvä ja ota yhteyttä Baanan asiakaspalveluun.",
      "noDamages": "Ei vaurioita",
      "smokedIn": "Tupakoitu ajoneuvossa",
      "noNotes": "Ei muistiinpanoja.",
      "notes": "Muistiinpanot",
      "notesInfo": "Muistiinpanot näkyvät vain oman organisaation käyttäjille.",
      "noteHistory": {
        "title": "Aiemmat muistiinpanot",
        "mileageSince": "edellisestä",
        "loadError": "Aiempien muistiinpanojen lataaminen epäonnistui.",
        "currentAuction": "Tämä kilpailutus",
        "previousAuction": "Aiempi kilpailutus",
        "mileageThen": "Mittari tuolloin",
        "mileageNow": "Mittari nyt"
      },
      "questionsAndAnswersInfo": "Kysymykset ja vastaukset näkyvät kaikille yrityksille.",
      "notFound": "Hakemasi kohde on poistettu.",
      "backToAuctions": "Avoimet kohteet",
      "notKnown": "Ei tiedossa",
      "timingSystemNotChanged": "Ei vaihdettu",
      "type": "Tyyppi",
      "offerDeal": "Tarjouskauppa",
      "offerEndsAt": "Myyjän harkinta-aika päättyy",
      "startNegotiation": "Aloita neuvottelu",
      "openNegotiation": "Avaa neuvottelu",
      "ownership": {
        "FINANCE_COMPANY": "Rahoituslaitos omistaa auton",
        "OTHER": "Muu omistaja",
        "SELF": "Myyjä omistaa auton itse",
        "BUSINESS": "Yritys omistaa auton"
      },
      "vehicleOwnership": {
        "FINANCE_COMPANY": "Rahoituslaitos omistaa ajoneuvon",
        "OTHER": "Muu omistaja",
        "SELF": "Myyjä omistaa ajoneuvon itse",
        "BUSINESS": "Yritys omistaa ajoneuvon"
      },
      "ownerCount": "Aiempien omistajien lukumäärä",
      "ownershipLabel": "Omistajuus",
      "personCount": "Henkilömäärä",
      "pickupOnly": "Myyjä vaatii autolle noudon.",
      "vehiclePickupOnly": "Myyjä vaatii ajoneuvolle noudon.",
      "power": "Teho",
      "powerType": "Käyttövoima",
      "powerClass": "Teholuokka",
      "registrationNumber": "Rekisterinumero",
      "sellerInfo": "Myyjän tiedot",
      "sellerToolTip": "Myyjän tiedot näkyvät vain korkeimman tarjouksen tehneelle.",
      "summerTires": "Kesärenkaat",
      "timeLeft": "Aikaa jäljellä",
      "tires": "Renkaat",
      "descriptionAndCondition": "Kuvaus ja auton kunto",
      "descriptionAndVehicleCondition": "Kuvaus ja ajoneuvon kunto",
      "tireWear": {
        "BAD": "Huonot",
        "FAIR": "Kohtalaiset",
        "GOOD": "Hyvät",
        "NEW": "Uudenveroiset",
        "NONE": "Ei ole"
      },
      "timingSystem": "Jakopää",
      "timingSystemType": "Jakopään tyyppi",
      "timingSystemChanged": "Vaihdettu",
      "transmissionType": "Vaihteisto",
      "trimLevel": "Varustelutaso",
      "withdrawalReason": "Perumisen syy",
      "timingSystemCondition": {
        "CHAIN_ORIGINAL": "Ketju",
        "CHAIN_CHANGED": "Ketju",
        "BELT_ORIGINAL": "Hihna",
        "BELT_CHANGED": "Hihna",
        "UNKNOWN": "Ei tiedossa"
      },
      "windscreen": "Tuulilasi",
      "windscreenCondition": {
        "CRACKED": "Haljennut",
        "GOOD": "Hyvä",
        "STONE_MARK": "Kiveniskemä",
        "WORN_OUT": "Kulunut"
      },
      "winterTires": "Talvirenkaat",
      "withdrawOffer": "Peruuta kauppa",
      "withRims": "Vanteilla",
      "questions": {
        "notAnswered": "(Kysymykseen ei ole vielä vastattu)",
        "title": "Kysymykset ja vastaukset",
        "noQuestions": "Ei kysymyksiä.",
        "add": "Lisää kysymys",
        "deleteConfirm": "Poista kysymys?",
        "edit": "Muokkaa kysymystä",
        "writeQuestion": "Kirjoita kysymys",
        "answerDeleted": "Vastaus poistettu",
        "questionDeletedByDealer": "Kysymys poistettu",
        "quickQuestions": {
          "question1": "Katsastatko auton ennen myyntiä?",
          "question2": "Onko jakopää vaihdettu?",
          "question3": "Kertoisitko lisää huolloista / huoltokirjasta?"
        }
      },
      "reportAuction": {
        "button": "Ilmoita ylläpidolle",
        "title": "Ilmoita kilpailutuksesta ylläpidolle",
        "description": "Kerro lyhyesti, miksi kilpailutus vaatii ylläpidon huomiota:",
        "reasonLabel": "Syy",
        "submit": "Lähetä",
        "limitReachedTooltip": "Olet ilmoittanut tästä kilpailutuksesta jo kolme kertaa."
      },
      "startPrice": "Lähtöhinta",
      "sendOffer": "Lähetä tarjous",
      "raiseOffer": "Voit vielä korottaa tarjoustasi",
      "windshieldInsurance": "Tuulilasivakuutus",
      "tracks": "Telat",
      "trackWidth": "Telan leveys (cm)",
      "finalOfferTitle": "Viimeinen tarjousmahdollisuus",
      "finalOfferDescription": "Myyjä on hylännyt kaikki tarjoukset. Sinulla on mahdollisuus tehdä vielä yksi korotettu tarjous.",
      "finalOfferDeadline": "Tarjousaika päättyy: {{deadline}}",
      "finalOfferSubmitted": "Viimeinen tarjous jätetty",
      "submitFinalOffer": "Tee viimeinen tarjous",
      "finalOfferModalTitle": "Viimeinen tarjous",
      "finalOfferInfo": "Tämä on viimeinen mahdollisuutesi tehdä tarjous tästä kohteesta. Tarjouksen tulee olla korkeampi kuin edellinen tarjouksesi.",
      "finalOfferCurrentBid": "Nykyinen tarjouksesi: {{amount}} €",
      "finalOfferNewAmount": "Uusi tarjoussumma",
      "finalOfferMustBeHigher": "Tarjouksen tulee olla korkeampi kuin edellinen tarjouksesi",
      "finalOfferSuccess": "Viimeinen tarjous lähetetty onnistuneesti",
      "finalOfferError": "Viimeisen tarjouksen lähettäminen epäonnistui",
      "competition": {
        "title": "Muiden liikkeiden tarjoukset",
        "businessName": "Yritys",
        "highestBid": "Korkein tarjous",
        "numberOfBiddersLabel": "Tarjouksen tehneitä",
        "openCompetitionDetails": "Avaa kilpailutiedot"
      },
      "viewKuntoraportti": "Näytä kuntotutkimusraportti",
      "kuntoraporttiViewError": "Kuntotutkimusraportin avaaminen epäonnistui"
    },
    "loginPage": {
      "stockRefillNeeded": "Tarvitseeko liikkeesi täydennystä varastoon?",
      "baanaOfferDescription": "Baanassa ostat kuluttajilta alle 250 000 km ajettuja autoja, alle 250 000 km ajettuja karavaaneja sekä alle 100 000 km ajettuja moottoripyöriä ja mopoja, sekä mönkijöitä, mopoautoja ja skoottereita. Maksat ainoastaan toteutuneista kaupoista – ei kiinteitä kuluja. Mukana Baanalla on suurin osa suomalaisista auto- ja motoliikkeistä.",
      "intrestedContact": "Kiinnostuitko? Ota yhteyttä:"
    },
    "menu": {
      "allActiveAuctions": "Avoimet kohteet",
      "endedAuctions": "Päättyneet",
      "myAuctions": "Omat kilpailutukset",
      "instructionsAndUpdates": "Ohjeet ja päivitykset"
    },
    "myAuctions": {
      "my": "Omat",
      "company": "Yrityksen"
    },
    "pageTitle": {
      "acceptedAuctions": "Hyväksytyt kilpailutukset",
      "allActiveAuctions": "Avoimet kohteet",
      "allEndedAuctions": "Kaikki päättyneet kilpailutukset",
      "auctionsUnderNegotiation": "Neuvottelussa olevat kilpailutukset",
      "closedAuctions": "Sulkeutuneet kilpailutukset",
      "declinedAuctions": "Hylätyt kilpailutukset",
      "completedAuctions": "Toteutuneet kaupat",
      "contactInfo": "Yhteystiedot",
      "endedAuctions": "Päättyneet kilpailutukset",
      "finalOfferAvailable": "Näihin voit vielä jättää viimeisen tarjouksen",
      "home": "Etusivu",
      "myAuctions": "Omat kilpailutukset",
      "pendingAuctions": "Odottavat kilpailutukset",
      "instructionsAndUpdates": "Ohjeet ja päivitykset"
    },
    "showHiddenAuctions": "Näytä piilotetut",
    "subHeaderTitle": {
      "acceptedAuctions": "Hyväksytyt",
      "auctionsUnderNegotiation": "Neuvottelussa",
      "pendingAuctions": "Odottavat",
      "completedAuctions": "Toteutuneet",
      "declinedAuctions": "Hylätyt",
      "closedAuctions": "Sulkeutuneet",
      "all": "Kaikki"
    },
    "searchFilters": {
      "vehicleType": {
        "title": "Ajoneuvo",
        "all": "Kaikki",
        "car": "Auto",
        "moto": "Moto",
        "caravan": "Karavaani"
      },
      "bikeType": {
        "title": "Ajoneuvolaji",
        "noBikeTypesAvailable": "Ei Ajoneuvolajeja saatavilla"
      },
      "caravanType": {
        "title": "Karavaanityyppi"
      },
      "make": "Merkki",
      "modelYear": "Vuosimalli",
      "mileage": "Ajokilometrit",
      "info": "Suodattimet määräytyvät myynnissä olevien ajoneuvojen tietojen mukaan",
      "modelYearStart": "Alkaen",
      "modelYearNoStartLimit": "Ei alarajaa",
      "modelYearEnd": "Päättyen",
      "modelYearNoEndLimit": "Ei ylärajaa",
      "location": "Sijainti",
      "sellerDelivers": "Myyjä valmis toimittamaan kauempaa",
      "targetPrice": "Tavoitehinta",
      "sortOrderNewestFirst": "Uusin ensin",
      "sortOrderOldestFirst": "Vanhin ensin",
      "filterTitle": "Suodata",
      "sameNameError": "Samalla nimellä löytyy jo tallennettu haku",
      "powerType": "Käyttövoima",
      "gearType": "Vaihteisto",
      "actionButtons": {
        "updateSearch": "Päivitä tallennettu haku",
        "showResults": "Näytä",
        "saveSearch": "Tallenna haku",
        "clearSearch": "Tyhjennä haku"
      }
    },
    "searchFilterGeneral": {
      "saveFilter": "Tallenna uusi haku",
      "filterName": "Haun nimi",
      "savedFilters": "Tallennetut haut",
      "updateSavedFilter": "Päivitä tallennettua hakua",
      "hideCompanyAuctionFilter": "Piilota yrityksen muut kilpailutukset",
      "moreFilters": "+{{count}} muuta"
    },
    "searchFilterMessages": {
      "searchFiltersSaved": "Hakuehto lisätty onnistuneesti",
      "searchFiltersUpdatedSuccessfully": "Hakuehtoja päivitetty onnistuneesti",
      "searchFilterDeletedSuccessfully": "Hakuehto poistettu onnistuneesti"
    },
    "searchFilterModal": {
      "title": "Haluatko varmasti poistaa tallennetun haun?",
      "body": "Poista haku {{filterToBeDeleted}}"
    },
    "emailNotifications": {
      "dealerOfferAccepted": "Tarjous hyväksytty",
      "dealerOutBidded": "Tarjous ylitetty",
      "dealerNewNegotiationMessage": "Uusi neuvotteluviesti",
      "dealer5minWarning": "5 minuuttia huutokaupan loppumiseen",
      "dealer15minWarning": "15 minuuttia huutokaupan loppumiseen",
      "dealerAuctionDeleted": "Kilpailutus poistettu",
      "dealerAuctionEnded": "Kilpailutus päättynyt",
      "dealerDailyInfoEmail": "Tänään päättyviä kohteita"
    },
    "smsNotifications": {
      "dealerOfferAccepted": "Tarjous hyväksytty",
      "dealerOutBidded": "Tarjous ylitetty",
      "dealerNewNegotiationMessage": "Uusi neuvotteluviesti",
      "dealer5minWarning": "5 minuuttia huutokaupan loppumiseen",
      "dealer15minWarning": "15 minuuttia huutokaupan loppumiseen",
      "dealerQuestionAnswered": "Kysymykseen vastattu"
    },
    "settingsPage": {
      "title": "Käyttäjäasetukset",
      "notificationSettings": "Ilmoitusasetukset",
      "pricingTitle": "Hinnasto",
      "pricingInfo": {
        "title": "Ajoneuvon huutokauppahinnasta",
        "body": "1% (alv. 0%)"
      },
      "pricingMin": {
        "title": "Vähintään",
        "body": "100€ (alv. 0%)"
      },
      "pricingMax": {
        "title": "Enintään",
        "body": "400€ (alv. 0%)"
      },
      "sms": "Tekstiviestit",
      "email": "Sähköposti",
      "updateSuccess": "Päivitys onnistui",
      "updateFail": "Päivitys epäonnistui",
      "phoneNumber": "Puhelinnumero (henk.koht)",
      "phoneNumberLabel": "Puhelinnumero",
      "countryCode": "Maakoodi",
      "emailMessage": "Sähköpostiosoite ei ole muokattavissa",
      "bids": "Tarjoukset",
      "quickRaiseIncludePickUp": "Pikakorotus sisältää noudon",
      "bidAlwaysIncludePickUp": "Tarjouksissa nouto mukana oletuksena",
      "excludeOrganizationBidsTitle": "Kilpailutus suodatin",
      "excludeOrganizationBids": "Piilota yrityksen muut kilpailutukset",
      "keepEndedAuctionsVisibleTitle": "Päättyneet kohteet",
      "keepEndedAuctionsVisible": "Näytä päättyneet kohteet listausnäkymässä. Selaimen päivittäessä kohteet häviävät.",
      "guaranteedAmount": {
        "title": "Korotusautomaatin takuutaso - näin se toimii:",
        "example": "Esimerkiksi:",
        "instruction1": "Voit valita korotusautomaattiin takuutason, jolle tarjouksesi korotetaan, jos se muuten jää kyseisen tason alle. Takuutaso on prosenttiosuus korotusautomaattiin valitsemastasi ylärajasta.",
        "instruction2": "Olet valinnut kilpailutustesi korotusautomaattiin takuutasoksi 90 %.",
        "instruction3": "Teet autosta 5000 € tarjouksen ja asetat korotusautomaatin ylärajaksi 10 000 €.",
        "instruction4": " Voitat tarjouskilpailun ensimmäisellä tarjouksellasi.",
        "instruction5": "Tekemäsi 5000 € tarjous jäi matalammaksi, kuin 90 % korotusautomaatin ylärajasta. Tarjouksesi korotetaan automaattisesti 90 prosenttiin eli 9 000 euroon.",
        "choosePercentage": "Valitse korotusautomaatin takuutaso",
        "attention": "Huom! Valinta vaikuttaa kaikkiin kilpailutuksiin, joissa sinulla on korotusautomaatti käytössä. Valintaa ei voi muuttaa kesken tarjouskilpailun, vaan ainoastaan sen päätyttyä."
      }
    }
  },
  "faq": {
    "mainTitle": "Usein kysytyt kysymykset",
    "readMore": "Lue lisää",
    "generalTitle": "Yleistä",
    "auctionInProgressTitle": "Kilpailutus käynnissä",
    "afterAuctionTitle": "Kilpailutuksen päätyttyä",
    "financialTitle": "Taloudelliset näkökulmat",
    "salesProcessAndAuction": "Auton, moottoripyörän tai muun ajoneuvon kilpailutus",
    "technicalQuestionsAndPreparation": "Ajoneuvon tiedot ja kuvat",
    "leavingAdAndControl": "Myynti-ilmoituksen jättäminen",
    "timeTable": "Kilpailutuksen kesto",
    "content-1": "Baana on yksityiskäyttäjälle maksuton palvelu. Kun myyt ajoneuvosi liikkeelle Baanan kilpailutuksen kautta, perimme ostajaliikkeeltä provision.",
    "content-10": "Kaikki Suomen suurimmat liikkeet ostavat Baanassa. Lisäksi mukana on paljon keskisuuria sekä pienempiä liikkeitä. Yhteensä ostajaliikkeitä on satoja.",
    "content-11": "Suosittelemme kokeilemaan selaimen evästeiden poistoa. Jos se ei auta tai kohtaat muita ongelmia ilmoituksen suhteen, asiakastukemme auttaa mielellään puhelimitse 0600 04070, avoinna arkisin 9-16, la-su 11-15 (0,38€ /min + pvm) tai sähköpostitse asiakaspalvelu@almamobility.fi.",
    "content-12": "Perinteinen tapa testata ajoneuvon renkaiden kunto on asettaa kahden euron kolikko renkaan uraan. Voit myös ottaa ilmoitukseen lähikuvat renkaistasi, jolloin ostajaliike pystyy arvioimaan renkaidesi kunnon.",
    "content-13": "Tuulilasiin voi tulla kiveniskemiä tai pahimmillaan se voi haljeta. Tällaiset vauriot näkyvät paljaalla silmällä. Silmämääräinen arviointi tuulilasin kunnosta on riittävä.",
    "content-14": "Korjaaminen varmasti nostaa auton arvoa, samoin moottoripyörän, mopon tai muun ajoneuvon kohdalla. On kuitenkin tapauskohtaista, nostaako korjauksen arvo hintaa enemmän kuin mitä korjaus maksaa. Ostajaliikkeillä on usein hyvät yhteistyökumppanit ajoneuvojen korjaamiseen, joten voit jättää sen ostajan huoleksi. Muista vain mainita korjausta tarvitsevasta viasta ilmoituksessasi, jotta ostajaliike osaa ottaa sen huomioon tarjouksessaan.",
    "content-15": "Auton tai muun ajoneuvon luovutus kauppojen jälkeen voidaan tehdä joko niin, että ajoneuvo noudetaan, tai niin, että toimitat sen itse liikkeeseen. Tämä tieto on ilmoituksessa ostajaliikkeille, jotta he osaavat varautua tarjousta tehdessään mahdollisiin noutokustannuksiin. Jos olet valmis viemään ajoneuvon liikkeeseen, saat todennäköisesti siitä hieman paremman hinnan.",
    "content-16": "Puhelimen kamera riittää mainiosti kuvien ottamiseen. Palvelu kertoo, mistä kohdista ajoneuvoa tarvitaan kuvat ja neuvoo niiden ottamisessa. Jos ajoneuvossasi on jotain erityistä, kuten vaurioita, suosittelemme ottamaan lisäkuvia. Mitä kattavammin ajoneuvo on kuvattu, sitä paremman käsityksen ostajaliike siitä saa. Muista ottaa kuvat myös huoltokirjasta.",
    "content-17": "Kyllä, voit tallentaa keskeneräisen ilmoituksen ja jatkaa sen täyttöä, kun sinulle parhaiten sopii.",
    "content-18": "Liike on sinuun yhteydessä pian sen jälkeen, kun olet hyväksynyt tarjouksen. Huomioithan, että viikonloppuisin ostajat eivät välttämättä ole töissä, joten yhteydenotto voi joissain tapauksissa venyä seuraavan viikon puolelle. Jos liikkeestä ei siltikään kuulu, voit olla meihin yhteydessä sähköpostitse osoitteeseen asiakaspalvelu@almamobility.fi.",
    "content-19": "Jos et ole tyytyväinen saamiisi tarjouksiin, kannattaa aloittaa neuvottelu valitsemasi liikkeen kanssa kohdasta \"aloita neuvottelu\". Neuvottelussa kumpikin osapuoli voi lähettää yhteensä 10 viestiä. Neuvottelun avulla pyritään pääsemään sopuun kauppahinnasta, jotta ajoneuvon myynti toteutuu.",
    "content-2": "Baanassa voit tehdä autostasi ilmaisen hinta-arvion ilmoitusta jättäessä. Hinta-arvio perustuu keskihintoihin, joten huomioithan, että arvio voi erota todellisesta arvosta, sillä jokainen auto on yksilö. Jos autostasi ei saada tehtyä hinta-arvioita, se johtuu yleensä siitä, että autosi on joko niin uusi tai niin harvinainen, ettei dataa ole tarpeeksi saatavilla.<br/><br/>{{link1}}<br/><br/>Muista autoneuvoista kuin autosta ei ole saatavilla hinta-arviota. Parhaan arvion käyvästä myyntihinnasta saat kilpailuttamalla tarjoukset Baanassa. Korkein tarjous on se, mitä liikkeet ovat enimmillään valmiita ajoneuvostasi maksamaan.",
    "content-20": "Ehdottomasti. Uudehkon auton, moottoripyörän tai esimerkiksi mönkijän myynti Baanan kautta kannattaa, sillä ne ovat usein kaikkein kiinnostavimpia, varsinkin isojen autoliikeketjujen näkökulmasta. Parhaimmillaan useampi liike on kiinnostunut juuri sinun ajoneuvostasi, ja auton, moottoripyörän tai muun ajoneuvon myynnin kilpailutuksen myötä sinun saamasi hinta nousee.",
    "content-21": "Helpoimmalla pääset, kun myyt autosi, moottoripyöräsi tai muun ajoneuvosi Baanan kautta ja käytät nämä rahat ajoneuvon vaihtoon. Yleensä parhaimpaan lopputulokseen myyjän kannalta päädytään, kun vanha ajoneuvo myydään ja uusi ostetaan erikseen. Tällöin saat vanhasta ajoneuvostasi hyvän pääoman uuden ostoon ja voit ostaa sen mistä tahansa liikkeestä.",
    "content-22": "Tietoliikennerajoituksista johtuen käyttöliittymässä näkyvä kellonaika voi heittää sekunnin suuntaansa. Suosittelemme olemaan jättämättä viestien lähetyksiä tai tarjouksia viimeisille sekunneille.",
    "content-23": "Käytämme kilpailutuksissa ja neuvotteluissa palvelumme virallista aikaa, jotta kellonaika on sama kaikille osapuolille, ja riippumaton päätelaitteiden päivämäärä- ja aika-asetuksista.",
    "content-202504011": "Näet tarjoukset hintoineen vasta, kun tarjousaika on päättynyt.",
    "content-3": "Kilpailutus Baanassa varmistaa, että saat parhaan hinnan autollesi, moottoripyörällesi tai muulle ajoneuvolle – nopeasti ja vaivattomasti. Kun myyt liikkeelle, kaupat hoituvat luotettavasti: liike arvioi ajoneuvosi asiantuntevasti ja hoitaa kaikki paperityöt puolestasi. Sinun tehtäväsi? Valita paras tarjous!",
    "content-4": "Auton voi myydä Baanassa, jos se on rekisteröity Suomeen ja sillä on ajettu enintään 250 000 km. Moottoripyörä, mopo, mönkijä, mopoauto, skootteri tai moottorikelkka soveltuu Baanaan, jos se on rekisteröity Suomeen ja sillä on ajettu enintään 100 000 km.",
    "content-5": "Ei, päinvastoin. Palvelumme opastaa ilmoituksenjätön kaikissa kohdissa ja kertoo, mitä tietoja kannattaa lisätä ja millaisia kuvia ilmoitukseen tarvitaan. Ilmoituksen jättäminen vie alle kymmenen minuuttia.",
    "content-202504013": "Kyseisellä rekisterinumerolla löytyy todennäköisesti luonnostilassa oleva myynti-ilmoitus eri sähköpostilla, kuin millä yrität nyt ilmoitusta palveluun jättää. Kirjaudu sisään Baanaan sillä sähköpostilla, jolla olet luonut alkuperäisen ilmoituksen. Kirjauduttuasi voit jatkaa luonnoksen muokkaamista kohdasta 'Omat kilpailutukset' ja viimeistellä ilmoituksen.",
    "content-6": "Ajoneuvon myynnin kilpailutus Baanassa kestää pikakilpailutuksella joitakin tunteja ja tavallisella kilpailutuksella noin 48 tuntia. Kilpailutus päättyy kahden arkipäivän kuluttua ilmoituksen julkaisusta klo 10–17 välillä. Ostajaliikkeet voivat tehdä tarjouksia ilmoituksen julkaisusta kilpailutuksen päättymiseen asti. Näet tarkan päättymisajan, kun ilmoituksesi on julkaistu.",
    "content-7": "Et sitoudu. Jos et ole tyytyväinen tarjouksiin, voit hylätä ne tai neuvotella tarjoajien kanssa.",
    "content-8": "Kyllä, rahoitusyhtiön omistaman ajoneuvon myyminen onnistuu yhtä helposti kuin itse omistamasi. Liike vähentää myyntisummastasi loppuvelan, eikä sinun ei tarvitse huolehtia siitä. Jos ajoneuvon loppuvelka on myyntihintaa suurempi, voit maksaa ylijäävän osuuden suoraan liikkeelle. Osa liikkeistä pystyy myös rahoittamaan jäljelle jäävän osuuden, jos ajoneuvon loppuvelka on ajoneuvon arvoa suurempi. {{link1}}",
    "content-9": "Haemme rekisterinumeron avulla ajoneuvosi perustiedot puolestasi. Sinun tarvitsee vain ilmoittaa ajokilometrit, lisätä kuvat ja antaa muutama lisätieto liittyen esim. renkaiden kuntoon ja huoltohistoriaan.",
    "content-24": "Auton arvo koostuu mallista, merkistä, vuosimallista, kysynnästä ja autoyksilöön liittyvistä asioista, kuten auton kunto, kilometrit ja lisävarusteet. Jos autossa on paljon lisävarusteita ja sillä on ajettu vähän, auton hinta on jälleenmyyntitilanteessa korkeampi kuin jos siinä on paljon korjattavaa ja kyseinen malli ei ole myyntihetkellä suosittu.",
    "content-25": "Kun kilpailutat autoliikkeiden ostotarjoukset Baanassa, saat ilmoituksen jätön yhteydessä hinta-arvion autostasi. Auton hinta-arvio perustuu Nettiauton keräämiin tilastoihin autojen myynnistä.",
    "content-26": "Auton renkaista paremmat kannattaa laittaa takarenkaiksi. Jos auton rengaskoko on sama edessä ja takana, renkaita on hyvä vaihdella, jotta ne kuluvat tasaisesti. Jos ajaa maltillisia määriä, vaihdon voi tehdä kausivaihdon yhteydessä. Esimerkiksi niin, että edellisen talven eturenkaat siirretään seuraavaksi talveksi taakse.",
    "content-27": "Renkaan tärkein ominaisuus on riittävä ja hyvä kulutuspinta. Renkaan tulisi kulua tasaisesti ja koko leveydeltään.",
    "content-28": "Se, mikä tehtävä renkaiden kulutuspinnan urilla on talvella ja mikä kesällä, liittyy ajon turvallisuuteen. Riittävä urasyvyys esimerkiksi varmistaa, että vesi pääsee pois renkaiden alta eikä auto joudu vesiliirtoon.",
    "content-29": "Auton renkaiden urien tulee olla tarpeeksi syvät, jotta ne toimivat kunnolla eri ajo-olosuhteissa ja varmistavat, että ajaminen on turvallista.",
    "content-30": "Lain mukaan kesärenkaiden kulutuspinnan urasyvyyden on oltava vähintään 1,6 mm.",
    "content-31": "Lain mukaan talvirenkaan pienin sallittu urasyvyys renkaan pääurissa on 3 mm.",
    "content-32": "Autolla ajo on turvallisempaa, kun renkaat ovat hyvässä kunnossa. Hyvillä renkailla auto käyttäytyy ajossa kuten kuuluu, ja sitä on helppo hallita. Auto voi esimerkiksi voi joutua helpommin vesiliirtoon, jos renkaan kulutuspinnan urat eivät ole riittävän syvät. Ikääntyessään rengas kovettuu ja sen ajo-ominaisuudet huononevat.",
    "content-33": "Auton sähköinen huoltokirja on tallennettu autovalmistajan omaan järjestelmään. Jos asioit muualla kuin merkkiliikkeessä, tarkista, että liikkeellä on pääsy huoltokirjaan ja että se päivitetään. Sähköisestä huoltokirjasta saa pyytäessä ajantasaisen otteen huollon yhteydessä.",
    "content-34": "Sähköinen huoltokirja löytyy valmistajan järjestelmästä, mutta paperinen huoltokirja voi huonolla tuurilla kadota. Varaudu siihen, että hävinnyt huoltokirja voi vaikuttaa auton jälleenmyyntiin ja pyyntihintaan, jos tehtyjä huoltoja ja auton historiaa ei muuten saada todennettua.",
    "content-35": "Kyllä voi, kunhan kaikilla kuolinpesän osakkailla on myyntiin suostumus.",
    "content-36": "Auto voi olla kuolinpesän nimissä niin kauan kuin pesää ei ole jaettu, eikä laissa ole sille tarkkaa aikarajaa.",
    "content-37": "Kyllä saa, mutta myyntiin tarvitaan sukuselvitys ja kaikkien osakkaiden suostumus.",
    "content-38": "Rahoitusyhtiön omistaman auton voi myydä Baanassa aivan samalla tavalla kuin auton, joka on omassa omistuksessa. Liike maksaa loppuvelan rahoitusyhtiölle ja hoitaa siihen liittyvät paperityöt. Loppuvelan määrä vähennetään kauppasummasta.",
    "content-39": "Kyllä, auton haltija voi myydä auton. Kun rahoitusyhtiö omistaa auton, voit auton haltijana kilpailuttaa ostotarjoukset autoliikkeiltä ja myydä auton Baanassa. Ostajana toimiva autoliike hoitaa loppuvelan kuittaamisen rahoitusyhtiölle ja omistuksen siirron. Jäljellä oleva autolaina vähennetään sinulle maksettavasta kauppasummasta.",
    "content-40": "Kyllä, auton voi myydä, vaikka siitä olisi rahoitusta jäljellä. Baanan kautta myydessä ei tarvitse murehtia, onko rahoitus este, vaan auton voi myydä aivan samalla tavalla kuin omassa omistuksessa olevan auton. Rahoituksella ostetun auton voi myydä autoliikkeelle yksinkertaisesti niin, että liike hoitaa jäljellä olevan lainan maksun rahoitusyhtiölle ja siirtää omistuksen omiin nimiinsä. Tarvittavat paperityöt hoituvat autoliikkeessä, ja loppuvelka vähennetään kauppasummasta, jonka autoliike sinulle maksaa.",
    "content-41": "Auton arvo koostuu mallista, merkistä, vuosimallista, kysynnästä ja autoyksilöön liittyvistä asioista, kuten auton kunto, kilometrit ja lisävarusteet. Jos autossa on paljon lisävarusteita ja sillä on ajettu vähän, auton hinta on jälleenmyyntitilanteessa korkeampi kuin jos siinä on paljon korjattavaa ja kyseinen malli ei ole myyntihetkellä suosittu.",
    "content-42": "Kun kilpailutat autoliikkeiden ostotarjoukset Baanassa, saat ilmoituksen jätön yhteydessä hinta-arvion autostasi. Auton hinta-arvio perustuu Nettiauton keräämiin tilastoihin autojen myynnistä.",
    "content-43": "Vaikka loppuvelan määrä ylittää ajoneuvon arvon, voit silti myydä ajoneuvosi Baanassa. Kumppanimme Etua tarjoaa mahdollisuuden kilpailuttaa paras lainatarjous loppuvelan maksuun. {{link1}}",
    "content-44": "Tarvitset perunkirjan, osakkaiden suostumuksen ja rekisteröintitodistuksen II-osan. Rekisteröinti tehdään katsastustoimipaikalla tai vakuutusyhtiössä.",
    "content-45": "Sähköinen huoltokirja näkyy autonvalmistajan tai huoltoverkoston verkkopalvelussa, usein rekisterinumerolla tai auton tunnistenumerolla (VIN).",
    "content-46": "Auton huollot näkee huoltokirjasta – joko paperisesta tai sähköisestä – sekä mahdollisesti huoltoliikkeen järjestelmästä, jos huollot on tehty merkkiliikkeessä.",
    "content-47": "Täydellinen huoltokirja tarkoittaa, että kaikki auton huollot on dokumentoitu ajallaan ja kattavasti, ilman puuttuvia merkintöjä.",
    "content-202311291": "Auton arvo koostuu mallista, merkistä, vuosimallista, kysynnästä ja autoyksilöön liittyvistä asioista, kuten auton kunto, kilometrit ja lisävarusteet. Jos autossa on paljon lisävarusteita ja sillä on ajettu vähän, auton hinta on jälleenmyyntitilanteessa korkeampi kuin jos siinä on paljon korjattavaa ja kyseinen malli ei ole myyntihetkellä suosittu.",
    "content-202311292": "Kun kilpailutat autoliikkeiden ostotarjoukset Baanassa, saat ilmoituksen jätön yhteydessä hinta-arvion autostasi. Auton hinta-arvio perustuu Nettiauton keräämiin tilastoihin autojen myynnistä.",
    "content-48": "Kyllä. Kerro vioista kuitenkin myynti-ilmoituksessa mahdollisimman kattavasti, jotta liike osaa arvioida, paljonko korjaaminen maksaa.",
    "content-49": "Kyllä, kunhan yrityksen toimialaksi ei ole määritelty henkilöautojen ja kevyiden moottoriajoneuvojen vähittäiskauppa. Muistathan lisätä merkinnän \"ALV-vähennyskelpoinen\" myynti-ilmoitukseen, jos ehto täyttyy.",
    "content-50": "Kyllä. Voit helposti julkaista kilpailutuksen uudelleen kohdassa \"omat kilpailutukset\".",
    "content-51": "Voit, Baanan käyttö ei velvoita sinua mihinkään.",
    "content-52": "Ei hätää. Voit olla yhteydessä asiakaspalveluumme sähköpostitse osoitteeseen asiakaspalvelu@almamobility.fi.",
    "content-53": "Ostajaliike hoitaa kaikki kauppaan liittyvät maksut ja tarvittavat paperit. Sinun ei tarvitse tehdä muuta kuin odottaa ostajan yhteydenottoa. Yhteydenoton jälkeen saat liikkeeltä tarkemmat tiedon seuraavista käytännön vaiheista. Baanan kautta toimivat ostajat ovat ennakkoon varmistettuja ja luotettavia kumppaneita. Kaupat ovat sujuneet palvelussa turvallisesti ja ilman maksuihin liittyviä ongelmia.",
    "content-54": "Liike sopii sinun kanssasi sopivan ajankohdan luovutuksesta. Jos olet valinnut noudon sisältävän tarjouksen, liike tulee hakemaan auton suoraan haluamastasi paikasta.",
    "content-55": "Syynä on DAC7, joka on EU:n verodirektiivi. Direktiivi velvoittaa Baanan kaltaiset verkkopalvelut ilmoittamaan tietoja asiakkaidensa myynneistä ({{link1}}).",
    "faq-title": "Usein kysyttyä",
    "link-2-1": "Miten autoliike määrittää autosi hinnan?",
    "link-4-1": "Nettiautossa",
    "link-4-2": "Nettimotossa",
    "link-8-1": "Lue lisää rahoitetun auton myynnistä",
    "link-43-1": "Kilpailuta laina Etuan sivuilla",
    "link-55-1": "lue lisää DAC7-direktiivistä",
    "title-1": "Mitä palvelun käyttö maksaa?",
    "title-10": "Mitkä liikkeet ostavat ajoneuvoja Baanan kautta?",
    "title-11": "Ilmoituksen julkaiseminen ei onnistu tai olen tehnyt virheellisen ilmoituksen, mitä teen?",
    "title-12": "Miten arvioin renkaideni kunnon?",
    "title-13": "Miten arvioin tuulilasin kunnon?",
    "title-14": "Kannattaako ajoneuvo huoltaa tai korjata ennen myyntiä?",
    "title-15": "Mitä tarkoittaa kohta: Kuinka pitkälle olen valmis toimittamaan ajoneuvoni?",
    "title-16": "Miten otan kuvat palveluun?",
    "title-17": "Voinko jättää ilmoituksen täytön kesken?",
    "title-18": "Hyväksyin liikkeen tarjouksen, miksi liikkeestä ei ole vielä kuulunut mitään?",
    "title-19": "Mitä jos en ole tyytyväinen saamiini tarjouksiin?",
    "title-2": "Miten voin tietää autoni, moottoripyöräni, moponi, skootterini, mönkijäni tai karavaanini arvon?",
    "title-20": "Kannattaako uudehkon auton, moottoripyörän, mopon tai muun ajoneuvon myynti liikkeelle?",
    "title-21": "Mitä eroa on vaihtohyvityksellä ja välirahalla? / Voinko antaa auton, moottoripyörän tai muun ajoneuvon vaihdossa liikkeelle myymällä sen Baanan kautta?",
    "title-22": "Miksi näytti, että kilpailutusta tai neuvotteluaikaa oli vielä jäljellä, mutta todellisuudessa se oli jo päättynyt enkä onnistunut enää tekemään toimenpiteitä?",
    "title-23": "Miksi kilpailutuksen ja neuvotteluajan kellonaika ei täsmää päätelaitteeni kellonajan kanssa?",
    "title-202504011": "Milloin näen saamani tarjoukset?",
    "title-3": "Miksi kannattaa myydä auto Baanan kautta?",
    "title-4": "Millainen ajoneuvo sopii Baanassa myytäväksi?",
    "title-5": "Onko ilmoituksen jättäminen vaikeaa?",
    "title-202504013": "Rekisterinumerollani löytyy jo ilmoitus, mitä teen?",
    "title-6": "Kuinka kauan kilpailutus kestää?",
    "title-7": "Sitoudunko myymään ajoneuvoni?",
    "title-8": "Onko rahoitetun auton, moottoripyörän tai muun rahoitetun ajoneuvon myynti liikkeelle mahdollista?",
    "title-9": "Mitä tietoja tarvitsen ilmoituksen tekemiseen?",
    "title-24": "Miten määritellään auton arvo?",
    "title-25": "Miten saan hinta-arvion autosta?",
    "title-26": "Laitetaanko autoon paremmat renkaat eteen vai taakse?",
    "title-27": "Millainen kulutuspinta on oltava henkilöauton renkaissa?",
    "title-28": "Mikä tehtävä on renkaiden kulutuspinnan urilla?",
    "title-29": "Miksi renkaille on määrätty minimi urasyvyys?",
    "title-30": "Mikä on kesärenkaan kulutuspinnan pienin sallittu urasyvyys?",
    "title-31": "Mikä on talvirenkaan kulutuspinnan pienin sallittu urasyvyys?",
    "title-32": "Miten renkaiden kunto vaikuttaa auton käyttäytymiseen?",
    "title-33": "Mistä löytyy auton sähköinen huoltokirja?",
    "title-34": "Auton huoltokirja hävinnyt - mitä tehdä?",
    "title-35": "Voiko kuolinpesän auton myydä?",
    "title-36": "Kauanko auto voi olla kuolinpesän nimissä?",
    "title-37": "Saako vainajan auton myydä ennen perunkirjoitusta?",
    "title-38": "Miten myydä rahoitusyhtiön auto?",
    "title-39": "Voiko auton haltija myydä auton?",
    "title-40": "Voiko auton myydä vaikka rahoitusta on jäljellä?",
    "title-41": "Miten määritellään auton arvo?",
    "title-42": "Miten saan hinta-arvion autosta?",
    "title-43": "Mitä, jos ajoneuvon loppuvelka on suurempi kuin ajoneuvon arvo?",
    "title-44": "Miten saan kuolinpesän auton omiin nimiin?",
    "title-45": "Miten nähdä sähköinen huoltokirja?",
    "title-46": "Mistä näkee auton huollot?",
    "title-47": "Mitä tarkoittaa täydellinen huoltokirja?",
    "title-202311291": "Miten määritellään auton arvo?",
    "title-202311292": "Miten saan hinta-arvion autosta?",
    "title-56": "Kannattaako käytetyn auton myynti yksityiselle vai liikkeelle?",
    "content-56": "Yksityiselle myydessä hinta on usein korkeampi, mutta se vaatii enemmän aikaa ja vaivaa. Liikkeelle myydessä kaupat syntyvät nopeasti ja liike hoitaa paperityöt.",
    "title-57": "Kuinka kauan käytetyn auton myynti Baanassa kestää?",
    "content-57": "Kilpailutus autoliikkeiden kesken kestää yleensä noin kaksi vuorokautta ilmoituksen julkaisusta. Pikakilpailutuksessa auton ostaja voi löytyä jopa alle vuorokaudessa.",
    "title-58": "Maksaako käytetyn auton myynti Baanan kautta mitään?",
    "content-58": "Ei, kilpailutus on maksutonta, eikä se sido sinua myymään autoa, vaikka saisit tarjouksia.",
    "title-59": "Voiko auton arvon laskea itse ilman laskuria?",
    "content-59": "Kyllä, vertaamalla autoasi vastaaviin myynti-ilmoituksiin saat suuntaa antavan käsityksen. Tarkimman arvion saat kuitenkin todellisesta autoliikkeiden tarjouskilpailusta Baanassa.",
    "title-60": "Onko auton huoltokirja pakollinen auton myynnissä?",
    "content-60": "Huoltokirjaa ei vaadita lain puolesta, mutta se kannattaa aina liittää myynti-ilmoitukseen. Huoltokirja lisää ostajan luottamusta ja voi nostaa autosta saatavaa tarjousta.",
    "title-61": "Kannattaako vanha auto myydä liikkeelle vai yksityiselle?",
    "content-61": "Liikkeelle myyminen on nopeampaa ja liike hoitaa paperityöt. Yksityiselle myyminen voi tuottaa paremman hinnan, mutta vaatii enemmän aikaa.",
    "title-62": "Voiko hyvin ajetun tai vanhan auton myydä Baanassa?",
    "content-62": "Kyllä, kunhan mittarilukema on enintään 250 000 km. Auton iällä ei ole merkitystä.",
    "title-63": "Mistä tiedän, mikä on vanhan autoni arvo?",
    "content-63": "Vanhan auton arvo riippuu merkin ja mallin lisäksi mm. iästä, mittarilukemasta ja kunnosta. Voit laskea auton arvon Baanan hinta-arviolla. Baanan hinta-arvio perustuu Nettiauton tilastoihin vastaavista myydyistä autoista. Voit tehdä hinta-arvion ilmoituksen teon yhteydessä Baanassa.",
    "title-64": "Mikä on väliraha autokaupassa?",
    "content-64": "Väliraha on summa, joka jää maksettavaksi, kun uuden auton hinnasta vähennetään vanhan auton arvo. Väliraha maksetaan autoliikkeelle, kun vanha auto vaihdetaan uuteen.",
    "title-65": "Onko väliraha sama kuin hyvityshinta?",
    "content-65": "Ei aivan. Hyvityshinta on vanhasta autosta saatava vaihtoarvo, kun taas väliraha on jäljelle jäävä maksettava summa. Käytännössä molemmat kuvaavat samaa vaihtoprosessia eri näkökulmista.",
    "title-66": "Kannattaako väliraha maksaa vai myydä vanha auto erikseen?",
    "content-66": "Väliraha on helpoin ja nopein tapa, kun kaikki hoituu yhden liikkeen kautta. Tällöin olet kuitenkin vain kyseisen liikkeen ostotarjouksen varassa vanhasta autostasi. Erikseen myymällä, esimerkiksi kilpailuttamalla Baanassa, voit usein saada vanhasta autostasi paremman hinnan.",
    "title-67": "Miksi kilpailuttaa auton myynti Baanassa?",
    "content-67": "Auton myynnin kilpailutus on tehokkain tapa varmistaa paras mahdollinen myyntihinta, kun myyt auton autoliikkeelle. Baana kilpailuttaa puolestasi kaikki keskeiset autoliikkeet Suomessa. Autoliike on luotettava ja asiantunteva ostaja, joka hoitaa kaikki paperityöt puolestasi ja usein hoitaa myös auton noutamisen. Baanassa saat autoliikkeiden ostotarjoukset jopa vuorokaudessa, eikä auton myynnin kilpailutus velvoita sinua hyväksymään ostotarjousta.",
    "title-48": "Voinko myydä viallisen ajoneuvon?",
    "title-49": "Voiko yritys myydä ajoneuvon?",
    "title-50": "Voinko julkaista ilmoitukseni uudelleen?",
    "title-51": "Voinko vielä perua ajoneuvoni myynnin?",
    "title-52": "En ehtinyt reagoida tarjouksiin ajoissa, mitä teen?",
    "title-53": "Milloin saan maksun myymästäni ajoneuvosta?",
    "title-54": "Miten ajoneuvon luovutus tapahtuu?",
    "title-55": "Miksi minulta kysytään henkilötunnusta tarjouksen hyväksymisen yhteydessä?"
  },
  "faqPage": {
    "howToVideoTitle": "Baana - Kuinka kilpailutat autosi Baanassa",
    "leavingAd": {
      "item1": {
        "title": "Onko ilmoituksen jättäminen vaikeaa?",
        "content": "Ei, päinvastoin. Palvelumme opastaa ilmoituksenjätön kaikissa kohdissa ja kertoo, mitä tietoja kannattaa lisätä ja millaisia kuvia ilmoitukseen tarvitaan. Ilmoituksen jättäminen vie alle kymmenen minuuttia."
      },
      "item2": {
        "title": "Rekisterinumerollani löytyy jo ilmoitus, mitä teen?",
        "content": "Kyseisellä rekisterinumerolla löytyy todennäköisesti luonnostilassa oleva myynti-ilmoitus eri sähköpostilla, kuin millä yrität nyt ilmoitusta palveluun jättää. Kirjaudu sisään Baanaan sillä sähköpostilla, jolla olet luonut alkuperäisen ilmoituksen. Kirjauduttuasi voit jatkaa luonnoksen muokkaamista kohdasta 'Omat kilpailutukset' ja viimeistellä ilmoituksen."
      },
      "item3": {
        "title": "Miten otan kuvat palveluun?",
        "content": "Puhelimen kamera riittää mainiosti kuvien ottamiseen. Palvelu kertoo, mistä kohdista ajoneuvoa tarvitaan kuvat ja neuvoo niiden ottamisessa. Jos ajoneuvossasi on jotain erityistä, kuten vaurioita, suosittelemme ottamaan lisäkuvia. Mitä kattavammin ajoneuvo on kuvattu, sitä paremman käsityksen ostajaliike siitä saa. Muista ottaa kuvat myös huoltokirjasta."
      },
      "item4": {
        "title": "Miten arvioin renkaiden kunnon?",
        "content": "Perinteinen tapa testata ajoneuvon renkaiden kunto on asettaa kahden euron kolikko renkaan uraan. Voit myös ottaa ilmoitukseen lähikuvat renkaistasi, jolloin ostajaliike pystyy arvioimaan renkaidesi kunnon."
      },
      "item5": {
        "title": "Miten arvioin tuulilasin kunnon?",
        "content": "Tuulilasiin voi tulla kiveniskemiä tai pahimmillaan se voi haljeta. Tällaiset vauriot näkyvät paljaalla silmällä. Silmämääräinen arviointi tuulilasin kunnosta on riittävä."
      },
      "item6": {
        "title": "Mitä tarkoittaa kohta: Kuinka pitkälle olen valmis toimittamaan ajoneuvoni?",
        "content": "Auton tai muun ajoneuvon luovutus kauppojen jälkeen voidaan tehdä joko niin, että ajoneuvo noudetaan, tai niin, että toimitat sen itse liikkeeseen. Tämä tieto on ilmoituksessa ostajaliikkeille, jotta he osaavat varautua tarjousta tehdessään mahdollisiin noutokustannuksiin. Jos olet valmis viemään ajoneuvon liikkeeseen, saat todennäköisesti siitä hieman paremman hinnan."
      },
      "item7": {
        "title": "Voinko julkaista ilmoitukseni uudelleen?",
        "content": "Kyllä. Voit helposti julkaista kilpailutuksen uudelleen kohdassa \"omat kilpailutukset\"."
      }
    },
    "auctionInProgress": {
      "item1": {
        "title": "Milloin näen saamani tarjoukset?",
        "content": "Näet tarjoukset hintoineen vasta, kun tarjousaika on päättynyt."
      },
      "item2": {
        "title": "Kuinka kauan kilpailutus kestää?",
        "content": "Ajoneuvon myynnin kilpailutus Baanassa kestää pikakilpailutuksella joitakin tunteja ja tavallisella kilpailutuksella noin 48 tuntia. Kilpailutus päättyy kahden arkipäivän kuluttua ilmoituksen julkaisusta klo 10–17 välillä. Ostajaliikkeet voivat tehdä tarjouksia ilmoituksen julkaisusta kilpailutuksen päättymiseen asti. Näet tarkan päättymisajan, kun ilmoituksesi on julkaistu."
      }
    },
    "afterAuction": {
      "item1": {
        "title": "Mitä jos en ole tyytyväinen saamiini tarjouksiin?",
        "content": "Jos et ole tyytyväinen saamiisi tarjouksiin, kannattaa aloittaa neuvottelu valitsemasi liikkeen kanssa kohdasta \"aloita neuvottelu\". Neuvottelussa kumpikin osapuoli voi lähettää yhteensä 10 viestiä. Neuvottelun avulla pyritään pääsemään sopuun kauppahinnasta, jotta ajoneuvon myynti toteutuu."
      },
      "item2": {
        "title": "Voinko vielä perua ajoneuvoni myynnin?",
        "content": "Voit, Baanan käyttö ei velvoita sinua mihinkään."
      },
      "item3": {
        "title": "Hyväksyin liikkeen tarjouksen, miksi liikkeestä ei ole vielä kuulunut mitään?",
        "content": "Liike on sinuun yhteydessä pian sen jälkeen, kun olet hyväksynyt tarjouksen. Huomioithan, että viikonloppuisin ostajat eivät välttämättä ole töissä, joten yhteydenotto voi joissain tapauksissa venyä seuraavan viikon puolelle. Jos liikkeestä ei siltikään kuulu, voit olla meihin yhteydessä sähköpostitse osoitteeseen asiakaspalvelu@almamobility.fi."
      },
      "item4": {
        "title": "En ehtinyt reagoida tarjouksiin ajoissa, mitä teen?",
        "content": "Ei hätää. Voit olla yhteydessä asiakaspalveluumme sähköpostitse osoitteeseen asiakaspalvelu@almamobility.fi."
      },
      "item5": {
        "title": "Milloin saan maksun myymästäni ajoneuvosta?",
        "content": "Ostajaliike hoitaa kaikki kauppaan liittyvät maksut ja tarvittavat paperit. Sinun ei tarvitse tehdä muuta kuin odottaa ostajan yhteydenottoa. Yhteydenoton jälkeen saat liikkeeltä tarkemmat tiedon seuraavista käytännön vaiheista. Baanan kautta toimivat ostajat ovat ennakkoon varmistettuja ja luotettavia kumppaneita. Kaupat ovat sujuneet palvelussa turvallisesti ja ilman maksuihin liittyviä ongelmia."
      },
      "item6": {
        "title": "Miten ajoneuvon luovutus tapahtuu?",
        "content": "Liike sopii sinun kanssasi sopivan ajankohdan luovutuksesta. Jos olet valinnut noudon sisältävän tarjouksen, liike tulee hakemaan auton suoraan haluamastasi paikasta."
      },
      "item7": {
        "title": "Miksi minulta kysytään henkilötunnusta tarjouksen hyväksymisen yhteydessä?",
        "content": "Syynä on DAC7, joka on EU:n verodirektiivi. Direktiivi velvoittaa Baanan kaltaiset verkkopalvelut ilmoittamaan tietoja asiakkaidensa myynneistä ({{link1}}).",
        "link": "lue lisää DAC7-direktiivistä"
      }
    }
  },
  "auctionAdditionalInfo": {
    "title": "Lisätiedot",
    "addLabel": "Lisää tietoja ilmoitukseesi",
    "historyTitle": "Muokkaushistoria",
    "placeholder": "Kirjoita lisätietoja, esimerkiksi tarkennuksia ajoneuvon kuntoon tai varusteisiin",
    "submit": "Lisää tiedot",
    "success": "Lisätiedot tallennettu onnistuneesti",
    "error": "Lisätietojen lisääminen epäonnistui",
    "emptyMessage": "Lisää joko teksti tai kuvia",
    "addedAt": "Lisätty",
    "imageAddedAt": "Kuva lisätty",
    "tooltip": "Ilmoitukseen on lisätty tietoja",
    "addImages": "Lisää kuvia",
    "imageSelected": "kuva valittu",
    "imagesSelected": "{{selected}}/{{remaining}} kuvaa valittu",
    "uploading": "Ladataan kuvia...",
    "submitting": "Lähetetään...",
    "uploadError": "Kuvien lataus epäonnistui",
    "saveDetails": "Tallenna lisätiedot"
  },
  "general": {
    "add": "Lisää",
    "createAd": "Tee ilmoitus",
    "address": "Lähiosoite",
    "at": "klo",
    "city": "Kaupunki",
    "country": "Maa",
    "auctions": "Kilpailutukset",
    "back": "Takaisin",
    "bid": "tarjous",
    "bids": "tarjousta",
    "cancel": "Peruuta",
    "canceled": "Peruttu",
    "close": "Sulje",
    "companies": "Yritykset",
    "confirm": "Vahvista",
    "contactInfo": "Yhteystiedot",
    "create": "Luo",
    "decline": "Hylkää",
    "delete": "Poista",
    "deleted": "Poistettu",
    "edit": "Muokkaa",
    "email": "Sähköposti",
    "eurLong": "{{amount}} euroa",
    "eur": "{{amount}} €",
    "faq": "Usein kysyttyä",
    "includesVAT": "(sis. alv 24%)",
    "hasNewMessage": "Sinulle on saapunut uusi viesti",
    "loadMore": "Lataa lisää",
    "loading": "Ladataan...",
    "loggingIn": "Kirjaudutaan sisään...",
    "login": "Kirjaudu",
    "loginWithMicrosoft": "Kirjaudu sisään Microsoft-tunnuksilla",
    "loginAndContinue": "Kirjaudu ja jatka",
    "loginPopupOpenTitle": "Kirjautumisikkuna on auki selaimessasi",
    "loginPopupOpenMessage": "Kirjaudu sisään avautuneessa ikkunassa jatkaaksesi. Jos et näe ikkunaa, tarkista selaimen välilehdet.",
    "loginShort": "Kirjaudu",
    "loginAlmaYritystunnus": "Kirjaudu sisään Alma-yritystunnuksellasi",
    "logout": "Kirjaudu ulos",
    "month": "Kuukausi",
    "none": "Ei mitään",
    "months": {
      "january": "Tammikuu",
      "february": "Helmikuu",
      "march": "Maaliskuu",
      "april": "Huhtikuu",
      "may": "Toukokuu",
      "june": "Kesäkuu",
      "july": "Heinäkuu",
      "august": "Elokuu",
      "september": "Syyskuu",
      "october": "Lokakuu",
      "november": "Marraskuu",
      "december": "Joulukuu"
    },
    "municipality": "Paikkakunta",
    "name": "Nimi",
    "next": "Seuraava",
    "no": "Ei",
    "noBids": "Ei tarjouksia",
    "noMatchingAuctions": "Ei kilpailutuksia",
    "ok": "Ok",
    "open": "Avaa",
    "phoneNumber": "Puhelinnumero",
    "pieces": "kpl",
    "postalCode": "Postinumero",
    "previous": "Edellinen",
    "publish": "Julkaise",
    "registerConsumer": "Luo Alma-tunnus",
    "registerDealer": "Luo Alma-yritystunnus",
    "returnToSummary": "Palaa yhteenvetoon",
    "save": "Tallenna",
    "saveAsDraft": "Tallenna luonnos",
    "saveAsDraftUnauthenticated": "Tallenna luonnos",
    "showAll": "Näytä kaikki",
    "showMore": "Näytä lisää",
    "showAuction": "Näytä ilmoitus",
    "somethingWentWrong": "Valitettavasti jotain meni pieleen. Yritä myöhemmin uudelleen.",
    "streetAddress": "Katuosoite",
    "today": "Tänään",
    "unknownRegistrationNumber": "Tuntematon rekisterinumero",
    "unnamedUser": "Nimetön käyttäjä",
    "update": "Päivitä",
    "users": "Käyttäjät",
    "userSettings": "Käyttäjäasetukset ja hinnasto",
    "year": "Vuosi",
    "yes": "Kyllä",
    "pageNotFound": "Hakemaasi sivua ei löydy.",
    "car": "auto",
    "motorcycle": "moottoripyörä",
    "caravan": "asuntovaunu",
    "vehicle": "ajoneuvo",
    "backToHome": "Takaisin etusivulle",
    "backToBlog": "Takaisin artikkeleihin",
    "retry": "Yritä uudelleen",
    "errorTitle": "Jotain meni pieleen",
    "notFoundTitle": "Sivua ei löytynyt"
  },
  "menus": {
    "ownAuctions": "Omat kilpailutukset",
    "toConsumerView": "Kuluttajille",
    "toDealerView": "Ostajille"
  },
  "contactInfoContent": {
    "contactTitle": "Yhteystiedot",
    "customerServiceTitle": "Asiakaspalvelu",
    "businessCustomerServiceHeading": "Asiakaspalvelu yrityksille",
    "businessCustomerServiceIntro": "Avoinna arkisin klo 9–16 ┃ Matkapuhelin- tai paikallisverkkomaksu.",
    "businessCustomerServicePhone": "<a class='phone-link' href='tel:+358102311710'>010 231 1710</a>",
    "businessCustomerServiceEmail": "<a class='email-link' href='mailto:yritykset@almamobility.fi'>yritykset@almamobility.fi</a>",
    "privateCustomerServiceHeading": "Asiakaspalvelu yksityisille",
    "privateCustomerServiceHours": "Avoinna arkisin klo 9–16, la-su 11-15┃ 0,38€/ min + pvm",
    "privateCustomerServicePhone": "<a class='phone-link' href='tel:060004070'>060 004 070</a>",
    "privateCustomerServiceEmail": "<a class='email-link' href='mailto:asiakaspalvelu@almamobility.fi'>asiakaspalvelu@almamobility.fi</a>",
    "contactsTitle": "Yhteyshenkilöt",
    "customerServiceContact": "Asiakaspalvelu",
    "customerServiceEmail": "<a class='email-link' href='mailto:asiakaspalvelu@almamobility.fi'>asiakaspalvelu@almamobility.fi</a>",
    "businessOwnerContact": "Ville Vähämaa",
    "businessManager": "Liiketoimintapäällikkö",
    "managerContact": "Atte Hämäläinen",
    "manager": "Kehityspäällikkö"
  },
  "feedbackForm": {
    "title": "Ota yhteyttä",
    "fields": {
      "email": "Sähköposti",
      "name": "Nimi",
      "mobile": "Matkapuhelinnumero",
      "subject": "Palautteen aihe",
      "message": "Viesti",
      "attachments": "Liitteet",
      "attachmentHelper": "Voit liittää kuvakaappauksia tai valokuvia. Kuvat optimoidaan automaattisesti ennen lähetystä."
    },
    "subjectOptions": {
      "consumer": {
        "postingAd": "Ilmoituksen jättö",
        "login": "Kirjautuminen",
        "registration": "Rekisteröityminen",
        "otherFeedback": "Muu palaute ja neuvonta"
      },
      "dealer": {
        "businessInfoChanges": "Liikkeen tietojen muutokset",
        "technicalError": "Tekninen virhe",
        "newCustomer": "Uusi asiakas",
        "otherFeedback": "Muu palaute ja neuvonta"
      },
      "technicalError": "Tekninen virhe"
    },
    "validation": {
      "requiredEmail": "Sähköposti on pakollinen",
      "invalidEmail": "Tarkista sähköpostiosoitteen muoto",
      "requiredSubject": "Valitse palautteen aihe",
      "requiredMessage": "Viesti on pakollinen",
      "messageTooLong": "Viesti ei voi olla pidempi kuin {{max}} merkkiä"
    },
    "buttons": {
      "send": "Lähetä",
      "clear": "Tyhjennä"
    },
    "success": "Kiitos palautteestasi!",
    "successTitle": "Palaute lähetetty!",
    "successMessage": "Kiitos palautteestasi. Otamme sinuun yhteyttä mahdollisimman pian.",
    "sendNewFeedback": "Lähetä uusi palaute",
    "viewImage": "Näytä kuva",
    "removeFile": "Poista tiedosto",
    "error": {
      "badRequest": "Tarkista lomakkeen tiedot.",
      "unauthorized": "Kirjaudu sisään uudelleen.",
      "forbidden": "Ei oikeuksia.",
      "unprocessable": "Lomakkeen tiedot eivät kelpaa.",
      "rateLimit": "Olet lähettänyt liian monta palautetta. Yritä myöhemmin uudelleen.",
      "generic": "Jokin meni pieleen. Yritä myöhemmin uudelleen.",
      "fileTooLarge": "Seuraavat tiedostot ovat liian suuria (max {{max}} Mt): {{files}}",
      "imageUploadPartial": "Osa kuvista ei latautunut onnistuneesti. Yritä lähettää ne uudelleen.",
      "imageUploadFailed": "Kuvan \"{{filename}}\" lataaminen epäonnistui. Yritä uudelleen.",
      "maxImagesReached": "Enintään {{max}} kuvaa sallitaan."
    },
    "progress": {
      "sending": "Lähetetään...",
      "uploadingImage": "Ladataan kuvaa {{current}}/{{total}}...",
      "doNotRefreshWarning": "Odota, että kaikki kuvat on ladattu"
    }
  },
  "myAuctions": {
    "acceptedAuctions": "Hyväksytyt kilpailutukset",
    "auctioned": "Kilpailutettu",
    "acceptOffer": "Hyväksy tarjous",
    "acceptOfferBody": "Olet hyväksymässä seuraavaa tarjousta. Tarkista vielä tarjouksen tiedot ennen hyväksyntää.",
    "addNewAuction": "Kilpailuta ajoneuvosi",
    "auctionHasEnded": "Kilpailutus on päättynyt",
    "auctionHasEndedFinalOffer": "Liike on nostanut tarjoustaan",
    "auctionHasEndedBody": "Kilpailutus on päättynyt ja alla näet saamasi tarjoukset. Voit päättää, haluatko hyväksyä tai hylätä jonkin saamistasi tarjouksista.\n\nHuom! Jos korkein tarjous jäi merkittävästi tavoitehinnastasi, suosittelemme siitä huolimatta aloittamaan neuvottelun ostajaliikkeen kanssa. Liike saattaa olla valmis nostamaan tarjoustaan.",
    "finalOfferTimeToFinishDeal": "Aikaa jäljellä hyväksyä tarjous",
    "auctionTimeEnded": {
      "title": "Loppuiko aika kesken?",
      "body": "Jos et ehtinyt sopia kaupoista ostajan kanssa, ota yhteyttä asiakaspalveluumme.",
      "button": "Asiakaspalvelun yhteystiedot"
    },
    "allBidsDeclinedSuccess": "Kaikki tarjoukset hylätty onnistuneesti.",
    "bidDeclinedSuccess": "Tarjous hylätty onnistuneesti.",
    "buyerDistance": "Ostajan etäisyys",
    "continueDraft": "Jatka ilmoituksen täyttämistä",
    "continueDraftHeader": "Jatka luonnosta",
    "declineAllOffers": "Hylkää kaikki tarjoukset",
    "declineOffer": "Hylkää tarjous",
    "endedAuctionsHeader": "Päättyneet kilpailutukset",
    "endedNegotiation": "Käydyt neuvottelut",
    "me": "Minä",
    "dealership": "Liike",
    "unfinishedDraftDialog": {
      "title": "Keskeneräinen {{vehicleType}}ilmoitus",
      "message": "Sinulla on keskeneräinen {{vehicleDialogText1}}ilmoitus. Haluatko jatkaa keskeneräistä ilmoitusluonnosta vai luoda uuden {{vehicleDialogText2}}ilmoituksen?",
      "continueDraft": "Jatka luonnosta",
      "createNewAuction": "Luo uusi ilmoitus",
      "createNewWillDelete": "Huomio: Uuden ilmoituksen luominen poistaa nykyisen luonnoksen.",
      "loading": "Ladataan..."
    },
    "publishedAuctionDescription": "Liikkeet voivat nyt tehdä tarjouksia ajoneuvostasi. Huom! Julkaistua ilmoitusta ei voi enää muokata. Kun tarjousaika on päättynyt, pääset tarkastelemaan tarjouksia. Jos kaipaat apua, ota yhteyttä",
    "support": "asiakaspalveluumme.",
    "hasActiveAuctionTitle": "Julkaistu kilpailutuksesi",
    "hasDraftAuctionDescription": "Kilpailutuksesi on keskeneräinen. Voit jatkaa sen täyttämistä.",
    "hasDraftAuctionHeader": "Keskeneräinen ilmoitus",
    "highestBid": "Korkein tarjous",
    "draftAuction": "Kilpailutusluonnos",
    "isFetchingAuctions": "Kilpailutuksia haetaan...",
    "hasErrorWithFetching": "Ilmoituksia hakiessa tapahtui virhe. Kokeile hetken kuluttua uudelleen.",
    "hasErrorWithRemoval": "Ilmoitusta poistaessa tapahtui virhe. Kokeile hetken kuluttua uudelleen.",
    "header": "Omat kilpailutuksesi",
    "highTargetPriceWarning": "Tavoitehinta poikkeaa merkittävästi hinta-arviosta. Korkea tavoitehinta voi vaikeuttaa auton myyntiä.",
    "infoMessage": "on saanut yhteystietosi ja on teihin yhteydessä mahdollisimman pian. Näin varmistamme että päädytte keskustelemaan suoraan oikean henkilön kanssa oikeassa toimipisteessä",
    "messageSenderDealer": "Liike",
    "messageSenderMe": "Minä",
    "myMessageNumber": "Viesti",
    "negotiationDescription": "Voit neuvotella tarjouksesta lähettämällä ostajaliikkeelle viestin. Kun neuvottelu on käynnissä, jokainen uusi viesti nollaa neuvotteluajan 30 tuntiin.",
    "negotiationErrorFetchingAuction": "Virhe kilpailutuksen tietojen hakemisessa",
    "negotiationErrorFetchingMessages": "Virhe viestien hakemisessa",
    "negotiationMessageLimit": "Voit lähettää korkeintaan kymmenen (10) viestiä.",
    "negotiationMessageLimitReached": "Olet käyttänyt sinulle varatun viestimäärän. Mikäli keskustelu ostajan kanssa jäi pahasti kesken, ole hyvä ja ota yhteyttä Baanan asiakaspalveluun.",
    "negotiationMessageDisabled": "Tämä on toisen saman ostajaliikkeen edustajan neuvottelu. Viestien lähetys estetty.",
    "negotiationAcceptModal": {
      "title": "Tarjouksen hyväksyminen",
      "body": "Olet hyväksymässä tarjouksen kauppasummalla {{amount}} €. Haluatko varmasti hyväksyä tarjouksen?"
    },
    "negotiationDeclineModal": {
      "acceptOffer": "Hyväksy",
      "title": "Tarjouksen hylkääminen",
      "body": "Haluatko varmasti hylätä tarjouksen kauppasummalla {{amount}} € kokeilematta neuvottelua? Voit ehdottaa neuvottelussa hintaa, jolla olisit valmis myymään ajoneuvosi."
    },
    "negotiationSendMessageError": "Virhe viestin lähetyksessä",
    "noAuctions": "Sinulla ei ole yhtään aktiivista kilpailutusta.",
    "startSellingDescription": "Aloita ajoneuvosi myynti luomalla uusi kilpailutus. Se on nopeaa ja helppoa!",
    "noOffersReceived": "Kohteesta ei ole tarjouksia",
    "numberOfBids": "Tarjoukset",
    "offerAcceptedDescription": "Valitsemasi tarjouksen hyväksyntä onnistui.",
    "offerAcceptedContent": {
      "alert": "Olet hyväksynyt tarjouksen!",
      "header1": "Mitä seuraavaksi tapahtuu?",
      "body1": "Tarjouksen tehnyt ostajaliike ottaa sinuun yhteyttä antamaasi numeroon {{phoneNumber}} tai sähköpostiin {{email}} mahdollisimman pian, viimeistään muutaman päivän kuluessa.",
      "body1-2": "Huom! Luovutuksesta ostajaliikkeelle tulee sopia mahdollisimman pian",
      "header2": "Mitä teen, jos ostajaliike ei ota yhteyttä?",
      "body2": "Jos ostajaliike ei ole ottanut yhteyttä kahden arkipäivän kuluessa, ole yhteydessä ",
      "link2": "asiakaspalveluumme."
    },
    "offerAccepted": "Tarjous hyväksytty",
    "offerAcceptedError": "Tarjouksen hyväksymisessä tapahtui virhe.",
    "offerAcceptedHeader": "Hienoa! Hyväksyit tarjouksen!",
    "offerAcceptedBody1": "Tarjouksen teki",
    "offerAcceptedBody2": "hinnalla",
    "offerAcceptedBody3": "{{amount}} euroa.",
    "offerDeclined": "Tarjous hylätty",
    "offerEnds": "Tarjousaika päättyy",
    "offererCount": "Tarjoajat",
    "offersVisibleAfterAuction": "Tarjousten euromäärät näkyvät vasta kilpailutuksen päätyttyä!",
    "offersComingInBackground": "Kilpailutuksen aikana näet tarjousten ja tarjoajien määrän. ",
    "auctionInProgress": "Kilpailutus käynnissä!",
    "auctionInProgressDescription": "Liikkeet voivat tehdä tarjouksia ajoneuvostasi tarjousajan päättymiseen asti.",
    "needHelp": {
      "prefix": "Voit lisätä ilmoitukseesi tietoja",
      "additionalInfoLink": "tästä",
      "middle": "Voit myös ottaa yhteyttä",
      "contactLink": "asiakaspalveluumme",
      "suffix": "."
    },
    "contactCustomerService": "asiakaspalveluumme",
    "offerNegotiations": "Neuvottelu tarjouksesta",
    "pickUpIncluded": "Nouto",
    "priceEstimate": "Tavoitehinta",
    "priceEstimateAbove": "Ylitetty",
    "priceEstimateBelow": "Ei ylitetty",
    "readTipsForGoodAuctionAd": "Lue vinkit hyvän ilmoituksen tekemiseen",
    "rejectOffer": "Hylkää tarjous",
    "rejectOfferBody": "Haluatko varmasti hylätä seuraavan tarjouksen?\n\nHylättyä tarjousta ei voi enää hyväksyä eikä sen tehneen autoliikkeen kanssa voi enää neuvotella.",
    "rejectOfferHeader": "Tarjouksen hylkääminen",
    "remainingTime": "Aikaa jäljellä",
    "removeAuction": "Poista ilmoitus",
    "removeAuctionModalBody": "Jos poistat ilmoituksen, et voi jatkaa sen täyttämistä myöhemmin vaan se poistetaan kokonaan.",
    "removeAuctionModalTitle": "Haluatko varmasti poistaa ilmoituksen?",
    "selectedOffer": "Tarjous",
    "selectedBid": "Valittu tarjous",
    "selectedBidAmount": "Tarjouksen summa",
    "sendMessage": "Lähetä viesti",
    "showNegotiation": "Neuvottelu käynnissä",
    "startNegotiation": "Neuvottele tarjouksesta",
    "originalOfferRank": "{{originalOfferRank}}. korkein tarjous",
    "sumOfOffer": "Tarjouksen summa",
    "targetInformation": "Kohteen tiedot",
    "targetPriceReached": "Korkein tarjous",
    "timeToFinishDeal": "Aikaa jäljellä hyväksyä tarjous",
    "timeToAcceptOffer": "Aikaa hyväksyä tarjous",
    "inNegotiation": "Neuvottelussa",
    "pendingOffer": "Odottaa",
    "topOffers": "Tarjoukset",
    "totalBidCount": "Tarjoukset",
    "finalOfferReceivedMessage": "Korkeimman tarjouksen tehnyt liike on edelleen kiinnostunut ajoneuvosta ja on nostanut tarjoustaan.",
    "finalOfferReceived": "Viimeinen tarjous saapunut!",
    "hasIncreasedOffer": "on korottanut tarjoustaan.",
    "winningBid": "Korkein tarjous",
    "writeMessage": "Kirjoita viesti",
    "whatHappensNext": "Mitä seuraavaksi tapahtuu?",
    "whatHappensNextBody": "Seuraavaksi liike ottaa sinuun yhteyttä, jotta voitte sopia ajoneuvon luovutuksesta. Huom! Ajoneuvon luovutuksesta liikkeeseen tulee sopia mahdollisimman pian.\n\n\nJos liike ei ole ottanut sinuun yhteyttä 24 arkitunnin sisällä, ota yhteyttä asiakaspalveluumme niin autamme asian selvittämisessä.",
    "status": "Tila",
    "updated": "Päivitetty",
    "days": "päivää",
    "favorites": "suosikkilistausta",
    "messages": "viestiä",
    "searchAlerts": "kertaa hakuvahtiviesteissä",
    "searchAlertsTooltip": "Hakutiedotteiden määrä",
    "newBids": "UUSIA TARJOUKSIA",
    "newQuestions": "UUSIA KYSYMYKSIÄ",
    "bids": "tarjousta",
    "questions": "kysymystä",
    "bidders": "tarjoajaa",
    "auctionDeleted": "Ilmoitus poistettu",
    "viewOffers": "Näytä tarjoukset",
    "viewAuction": "Näytä kilpailutus",
    "highestOffer": "Korkein tarjous",
    "offer": "Tarjous",
    "finalOffer": "Viimeinen tarjous",
    "vehicleImages": "Ajoneuvon kuvat",
    "targetReached": "Tavoite saavutettu!",
    "viewAll": "Näytä kaikki",
    "drafts": "Luonnokset",
    "negotiation": "Neuvottelu",
    "active": "Aktiiviset",
    "history": "Historia",
    "auctionDetails": "Ilmoituksen tiedot"
  },
  "collaborations": {
    "etua": {
      "paragraph1": "Ylittääkö autorahoituksen jäljellä oleva osuus autosi arvon? Löydä paras lainatarjous loppusumman maksuun ",
      "link": "kumppanimme Etuan",
      "paragraph2": " avulla."
    }
  },
  "emailVerification": {
    "title": "Tervetuloa",
    "paragraph1": "Olet luonut {{userType}} {{email}}.",
    "paragraph2": "Vahvista vielä sähköpostiosoitteesi päästäksesi käyttämään Baana-palvelua.",
    "paragraph3": "Sähköpostiisi on lähetetty ohjeet vahvistamista varten.",
    "paragraph4": "Etkö saanut viestiä?",
    "link": "Tilaa uusi vahvistusviesti",
    "almaAccount": "Alma-tunnuksen",
    "almaBusinessAccount": "Alma-yritystunnuksen",
    "verified": "Vahvistettu"
  },
  "notifications": {
    "addNoteFailure": "Muistiinpanon lisääminen epäonnistui!",
    "addNoteSuccess": "Muistiinpano lisätty.",
    "auctionAccepted": "Myyjä hyväksyi tarjouksesi kohteesta {{targetVehicleInfo}}.",
    "auctionCancelled": "Kilpailutus kohteesta {{targetVehicleInfo}} keskeytettiin.",
    "auctionEnded": "Kilpailutus kohteesta {{targetVehicleInfo}} on päättynyt.",
    "biddingFailure": "Tarjouksen tekeminen epäonnistui!",
    "adminBidRemoved": "Ylläpito on poistanut tarjouksesi kohteesta {{targetVehicleInfo}}.",
    "adminBidModified": "Ylläpito on muokannut tarjoustasi kohteesta {{targetVehicleInfo}}.",
    "bidDeclined": "Myyjä hylkäsi tarjouksesi kohteesta {{targetVehicleInfo}}.",
    "bidFailedOtherBidMachineGotBid": "Tarjouksesi ei onnistunut, sillä kilpailija ehti tehdä tarjouksen samalla summalla sinua aiemmin.",
    "bidMachineDeactivationFailure": "Korotusautomaatin sulkeminen epäonnistui!",
    "bidMachineDeactivationSuccess": "Korotusautomaatti suljettu.",
    "bidMachineUpdateFailure": "Korotusautomaatin päivittäminen epäonnistui!",
    "bidMachineUpdateSuccess": "Korotusautomaatti päivitetty.",
    "bidSuccess": "Tarjous tehty.",
    "bidSuccessOtherBidMachineRaised": "Tarjouksesi onnistui, mutta kilpailijan tarjous ylitti sen.",
    "createAuctionFailed": "Sinulla on jo aktiivinen kilpailutus, et voi tällä hetkellä luoda uutta.",
    "deleteNoteFailure": "Muistiinpanon poistaminen epäonnistui!",
    "deleteNoteSuccess": "Muistiinpano poistettu.",
    "editNoteFailure": "Muistiinpanon muokkaus epäonnistui!",
    "editNoteSuccess": "Muistiinpano muokattu.",
    "emailNotVerified": "Sinulle on lähetetty sähköpostiviesti. Käythän vahvistamassa sähköpostiosoitteesi viestin ohjeiden mukaisesti. Kirjaudu tämän jälkeen Baanaan uudelleen päästäksesi aloittamaan kilpailutuksen!",
    "loginFailed": "Kirjautuminen epäonnistui.",
    "logoutFirst": "Kirjaudu ensin ulos nykyisestä näkymästä.",
    "noAdminRights": "Käyttäjällä ei ole pääkäyttäjän oikeuksia.",
    "userNotVerified": "Saat sähköpostiisi viestin, kun sinut on aktivoitu Baanan päässä ja huutaminen voi alkaa.",
    "userMissingNameException": "Alma-tunnuksestasi puuttuu jokin pakollisista tiedoista (etunimi, sukunimi). Käythän päivittämässä tietosi alla olevasta linkistä ja yritä kirjautua tämän jälkeen uudelleen.",
    "userMissingNameExceptionDealer": "Alma-yritystunnuksestasi puuttuu jokin pakollisista tiedoista. Ota yhteyttä asiakaspalveluun tietojen päivittämiseksi.",
    "userMissingNameExceptionErrorMessage": "https://itsepalvelu.almamedia.fi/",
    "userRemovedSuccefully": "Käyttäjä {{firstName}} {{lastName}} on poistettu palvelusta",
    "negotiationMessageSendingFailed": "Neuvotteluviestin lähetys epäonnistui!",
    "withdrawOfferSuccess": "Tarjous peruttu.",
    "withdrawOfferFailure": "Tarjouksen peruminen epäonnistui!",
    "markAsCompleteSuccess": "Kauppa merkitty toteutuneeksi.",
    "markAsCompleteFailure": "Kaupan merkitseminen toteutuneeksi epäonnistui!",
    "newBidsOutBidded": "Tarjouksesi kohteesta {{targetVehicleInfo}} on ylitetty.",
    "newNegotiationMessage": "Uusi neuvotteluviesti kohteesta {{targetVehicleInfo}}.",
    "newAnswerToQuestion": "Uusi vastaus kysymykseesi kohteessa {{targetVehicleInfo}}.",
    "newQuestion": "Uusi kysymys",
    "questionDeletedSuccesfully": "Kysymys poistettu",
    "questionDeleteError": "Kysymyksen poistaminen epäonnistui",
    "questionAddedSuccessfully": "Kysymys lisätty",
    "questionAddError": "Kysymyksen lisääminen epäonnistui",
    "offerSendError": "Tarjouksen lähetys epäonnistui",
    "dac7AccountClosed": "Käyttäjätilisi on suljettu puuttuvien tietojen takia. Täytä nimesi, osoitteesi ja henkilötunnuksesi tilisi uudelleenaktivoimiseksi.",
    "dac7AccountClosedWithDraft": "Käyttäjätilisi on suljettu puuttuvien tietojen takia. Täytä nimesi, osoitteesi ja henkilötunnuksesi tilisi aktivoimiseksi. Ilmoitusluonnoksesi on tallennettu – sinut ohjataan siihen tilin aktivoinnin jälkeen.",
    "wrongAccountTypeDealer": "Yrität päästä Baanan kuluttajapalveluun Alma-yritystunnuksella. Kirjaudu ulos ja yritä uudelleen.",
    "wrongAccountTypeConsumer": "Yrität päästä Baanan yrityspalveluun kuluttajille tarkoitetulla Alma-tunnuksella. Kirjaudu ulos ja yritä uudelleen.",
    "newInstructionsAvailable": "Uusia ohjeita tai päivityksiä on saatavilla",
    "tooManyImages": "Voit lisätä korkeintaan {{maxCount}} kuvaa yhdellä kerralla.",
    "maxImagesReached": "Enimmäismäärä kuvia saavutettu. Et voi lisätä enempää kuvia tähän osioon.",
    "tooManySectionImages": "Voit lisätä korkeintaan {{maxCount}} kuvaa tähän osioon yhdellä kerralla.",
    "maxSectionImagesReached": "Osion enimmäismäärä kuvia saavutettu. Et voi lisätä enempää kuin {{maxCount}} kuvaa tähän osioon.",
    "maxImagesReachedButton": "Maksimimäärä kuvia saavutettu",
    "addImagesButton": "Lisää kuvia",
    "uploadingImagesInProgress": "Kuvia ladataan…",
    "dragOrSelectImagesDescription": "Raahaa tai valitse. Tuetut tiedostotyypit: JPG, PNG, WEBP, HEIC, HEIF",
    "someImagesFailedToUpload": "{{count}} kuvan lataus epäonnistui.",
    "allImagesFailedToUpload": "Kaikkien kuvien lataus epäonnistui. Yritä uudelleen.",
    "autologinSuccess": "Olet kirjautunut Alma-tunnuksella {{email}}",
    "reportAuctionSuccess": "Ilmoitus lähetetty ylläpidolle.",
    "reportAuctionLimitReached": "Olet jo ilmoittanut tästä kilpailutuksesta enimmäismäärän kertoja.",
    "reportAuctionFailure": "Ilmoituksen lähettäminen epäonnistui!"
  },
  "socketMessages": {
    "newOfferReceived": "Uusi tarjous",
    "newMessageReceived": "Uusi viesti",
    "auctionHasEnded": "Kilpailutus on päättynyt",
    "offerAccepted": "Tarjous hyväksytty",
    "dealerOfferAccepted": "Liike on merkinnyt kaupan alustavaksi kaupaksi",
    "rejectedByDealer": "Ostaja hylkäsi tarjouksen",
    "dealCompleted": "Kauppa toteutunut"
  },
  "analytics": {
    "vehicleType": {
      "car": "Auto",
      "moto": "Moottoripyörä",
      "caravan": "Matkailuajoneuvo"
    },
    "motoSubType": {
      "2": "Moottoripyörä",
      "5": "Mopo",
      "6": "Moottorikelkka",
      "16": "Mönkijä",
      "17": "Skootteri",
      "19": "Mopoauto",
      "default": "Ajoneuvo"
    }
  },
  "vehicleType": {
    "car": "Auto",
    "moto": "Moto",
    "caravan": "Karavaani"
  }
}
